import "./App.css";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import Login from "./Login";
import { formatarCpf, limparCpf } from "./lib/cpf";

/* Configura o token salvo (se houver) para todas as requisições */
const tokenSalvo = localStorage.getItem("token");
if (tokenSalvo) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + tokenSalvo;
}

/* Se o token expirar/for inválido, volta para a tela de login.
   Só recarrega quando REALMENTE havia um token (sessão expirada),
   evitando loop de reload quando o usuário ainda nem logou. */
axios.interceptors.response.use(
  (resposta) => resposta,
  (erro) => {
    const url = erro.config?.url || "";
    const tinhaToken = !!localStorage.getItem("token");
    if (
      erro.response?.status === 401 &&
      !url.includes("/auth/login") &&
      tinhaToken
    ) {
      localStorage.removeItem("token");
      localStorage.removeItem("usuario");
      delete axios.defaults.headers.common["Authorization"];
      window.location.reload();
    }
    return Promise.reject(erro);
  }
);

/* Ícones (SVG inline, estilo linha) */
const Icone = ({ nome }) => {
  const p = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  const svg = {
    dashboard: <><rect x="3" y="3" width="7" height="7" {...p} /><rect x="14" y="3" width="7" height="7" {...p} /><rect x="14" y="14" width="7" height="7" {...p} /><rect x="3" y="14" width="7" height="7" {...p} /></>,
    recebimentos: <><path d="M3 12h4l2 3h6l2-3h4" {...p} /><path d="M5 6h14v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6z" {...p} /></>,
    envios: <><path d="M22 2 11 13" {...p} /><path d="M22 2 15 22l-4-9-9-4 20-7z" {...p} /></>,
    agentes: <><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" {...p} /><circle cx="9" cy="7" r="4" {...p} /><path d="M23 21v-2a4 4 0 0 0-3-3.87" {...p} /></>,
    bancos: <><path d="M3 21h18M4 10h16M5 10 12 4l7 6M6 10v11M18 10v11M10 10v11M14 10v11" {...p} /></>,
    agencias: <><rect x="4" y="3" width="16" height="18" rx="1" {...p} /><path d="M9 8h1M14 8h1M9 12h1M14 12h1M9 16h6" {...p} /></>,
    receitas: <><path d="M20.59 13.41 12 22l-9-9V3h10l7.59 7.59a2 2 0 0 1 0 2.82z" {...p} /><circle cx="7.5" cy="7.5" r="1.5" {...p} /></>,
    config: <><circle cx="12" cy="12" r="3" {...p} /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-2.82 1.17V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 8 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 3.6 15H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6V4a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" {...p} /></>,
    relacionamentos: <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" {...p} /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" {...p} /></>,
    fontes: <><path d="m12 2 9 5-9 5-9-5 9-5z" {...p} /><path d="m3 12 9 5 9-5M3 17l9 5 9-5" {...p} /></>,
    usuarios: <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...p} /><circle cx="9" cy="7" r="4" {...p} /><path d="M19 8v6M22 11h-6" {...p} /></>,
    perfil: <><circle cx="12" cy="8" r="4" {...p} /><path d="M20 21a8 8 0 0 0-16 0" {...p} /></>,
    relogio: <><circle cx="12" cy="12" r="9" {...p} /><path d="M12 7v5l3 2" {...p} /></>,
    alerta: <><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" {...p} /><path d="M12 9v4M12 17h.01" {...p} /></>,
    dinheiro: <><rect x="2" y="6" width="20" height="12" rx="2" {...p} /><circle cx="12" cy="12" r="2.5" {...p} /></>,
    conciliacao: <><path d="M3 7h13l-3-3M21 17H8l3 3" {...p} /><path d="M18 4v6M15 7h6" {...p} /></>,
    outroSistema: <><path d="M8 3 4 7l4 4M4 7h16M16 21l4-4-4-4M20 17H4" {...p} /></>,
    ajuda: <><circle cx="12" cy="12" r="9" {...p} /><path d="M9.3 9a2.7 2.7 0 0 1 5.4.3c0 1.8-2.7 2.3-2.7 3.9M12 17h.01" {...p} /></>,
    email: <><rect x="2" y="4" width="20" height="16" rx="2" {...p} /><path d="m22 7-10 6L2 7" {...p} /></>,
    editar: <><path d="M17 3a2.83 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z" {...p} /></>,
    lixeira: <><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6M10 11v6M14 11v6" {...p} /></>,
    fechar: <><path d="M18 6 6 18M6 6l12 12" {...p} /></>,
    sucesso: <><circle cx="12" cy="12" r="9" {...p} /><path d="m8.5 12.5 2.5 2.5 5-5.5" {...p} /></>,
    info: <><circle cx="12" cy="12" r="9" {...p} /><path d="M12 8h.01M12 12v4" {...p} /></>,
    historico: <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6z" {...p} /><path d="M14 2v6h6M8 13h8M8 17h5" {...p} /></>,
    lista: <><rect x="8" y="2" width="8" height="4" rx="1" {...p} /><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2M9 12h6M9 16h6" {...p} /></>,
    trocar: <><path d="M8 3 4 7l4 4M4 7h16M16 21l4-4-4-4M20 17H4" {...p} /></>,
    pastas: <><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" {...p} /></>,
    dica: <><path d="M9 18h6M10 22h4M12 2a7 7 0 0 0-4 12c.6.5 1 1.2 1 2h6c0-.8.4-1.5 1-2a7 7 0 0 0-4-12z" {...p} /></>,
  };
  return (
    <svg viewBox="0 0 24 24" width="18" height="18">
      {svg[nome] || svg.dashboard}
    </svg>
  );
};

/* Rótulos e ordem dos perfis de acesso */
const LABEL_TIPO = {
  admin: "Administrador",
  gestor: "Gestor de Relatórios",
  operador: "Operador",
  // pedido do SAAE (23/10/2026): operador + estornar envio
  contabilidade: "Contabilidade",
};

/*
  Estrutura do menu lateral.
  Cada item define quais perfis podem vê-lo (roles).
    - admin:    acesso total, inclui gestão de usuários
    - operador: operação (recebimentos, envios e cadastros)
    - gestor:   visão gerencial (painel, recebimentos e envios)
*/
const TODOS = ["admin", "gestor", "operador", "contabilidade"];

const MENU = [
  {
    titulo: "Principal",
    itens: [
      { id: "dashboard", label: "Painel", icone: "dashboard", roles: TODOS },
      { id: "recebimentos", label: "Recebimentos", icone: "recebimentos", roles: TODOS },
      { id: "envios", label: "Envios", icone: "envios", roles: TODOS },
      { id: "conciliacao", label: "Conciliação", icone: "conciliacao", roles: TODOS },
    ],
  },
  {
    titulo: "Cadastros",
    itens: [
      { id: "agentes", label: "Agentes Arrecadadores", icone: "agentes", roles: ["admin", "operador", "contabilidade"] },
      { id: "bancos", label: "Bancos", icone: "bancos", roles: ["admin", "operador", "contabilidade"] },
      { id: "agencias", label: "Agências Bancárias", icone: "agencias", roles: ["admin", "operador", "contabilidade"] },
      { id: "receitas", label: "Códigos de Receita", icone: "receitas", roles: ["admin", "operador", "contabilidade"] },
    ],
  },
  {
    titulo: "Configurações",
    itens: [
      { id: "config", label: "Configuração SIAFIC", icone: "config", roles: ["admin"] },
      { id: "sequencia", label: "Sequência da Chave Única", icone: "config", roles: ["admin"] },
      { id: "relacionamentos", label: "Relacionamentos SIAFIC", icone: "relacionamentos", roles: ["admin"] },
      { id: "fontes", label: "Fontes de Recursos", icone: "fontes", roles: ["admin"] },
      { id: "smtp", label: "E-mail (SMTP)", icone: "email", roles: ["admin"] },
      { id: "usuarios", label: "Usuários", icone: "usuarios", roles: ["admin"] },
    ],
  },
  {
    titulo: "Conta",
    itens: [
      { id: "perfil", label: "Meu Perfil", icone: "perfil", roles: TODOS },
    ],
  },
  {
    titulo: "Suporte",
    itens: [
      { id: "ajuda", label: "Ajuda", icone: "ajuda", roles: TODOS },
    ],
  },
];

/* Lê um arquivo de imagem, redimensiona (máx. 256px) e devolve data URI JPEG */
function lerImagemRedimensionada(arquivo, max = 256) {
  return new Promise((resolve, reject) => {
    const leitor = new FileReader();
    leitor.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        let { width, height } = img;
        const escala = Math.min(1, max / Math.max(width, height));
        width = Math.round(width * escala);
        height = Math.round(height * escala);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL("image/jpeg", 0.85));
      };
      img.onerror = reject;
      img.src = ev.target.result;
    };
    leitor.onerror = reject;
    leitor.readAsDataURL(arquivo);
  });
}

/* Formatação */
const formatarBRL = (v) =>
  Number(v || 0).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });

/* Converte valor em texto para número: aceita tanto o formato
   pt-BR do PDF ("1.234,56") quanto o decimal do banco ("1234.56") */
const valorParaNumero = (v) => {
  let t = String(v ?? "0").replace(/\s/g, "").replace("R$", "");
  if (t.includes(",")) {
    t = t.replace(/\./g, "").replace(",", ".");
  }
  const n = Number(t);
  return isNaN(n) ? 0 : n;
};

const somarValores = (lista) =>
  (lista || []).reduce((acc, r) => acc + valorParaNumero(r.valor), 0);

const formatarData = (d) => {
  if (!d) return "—";
  const s = String(d).slice(0, 10);
  const partes = s.split("-");
  return partes.length === 3 ? `${partes[2]}/${partes[1]}/${partes[0]}` : s;
};

// Formata data e hora (ex.: "2026-07-20 13:45:00" -> "20/07/2026 13:45:00")
const formatarDataHora = (d) => {
  if (!d) return "—";
  const s = String(d);
  const dataParte = formatarData(s);
  const horaParte = s.slice(11, 19);
  return horaParte ? `${dataParte} ${horaParte}` : dataParte;
};

/* Avatar do usuário: mostra a foto, ou a inicial do nome */
const AvatarUsuario = ({ usuario, className }) => (
  <div className={className}>
    {usuario && usuario.foto ? (
      <img src={usuario.foto} alt="Foto do usuário" className="avatar-img" />
    ) : (
      (usuario && usuario.nome ? usuario.nome : "U").charAt(0).toUpperCase()
    )}
  </div>
);

/* Card padrão da tela de Ajuda: para que serve + passo a passo + dicas */
const CardAjuda = ({ icone, titulo, servePara, passos = [], dicas = [] }) => (
  <div className="card">
    <h3><Icone nome={icone} /> {titulo}</h3>
    {servePara && (
      <p className="conc-ajuda" style={{ marginBottom: 8 }}>{servePara}</p>
    )}
    {passos.length > 0 && (
      <>
        <p style={{ fontWeight: 600, fontSize: 13, color: "#475569", margin: "10px 0 4px" }}>
          Passo a passo
        </p>
        <ol style={{ paddingLeft: 22, margin: 0, color: "#334155", fontSize: 14.5, lineHeight: 1.8, listStyleType: "decimal" }}>
          {passos.map((p, i) => (
            <li key={i}>{p}</li>
          ))}
        </ol>
      </>
    )}
    {dicas.map((d, i) => (
      <p
        key={i}
        style={{
          marginTop: 12,
          padding: "10px 12px",
          background: "#fefce8",
          borderLeft: "3px solid #eab308",
          borderRadius: 6,
          fontSize: 13.5,
          color: "#713f12",
        }}
      >
        <Icone nome="dica" /> {d}
      </p>
    ))}
  </div>
);

/*
  Gráfico de rosca do painel: percentual de arrecadação por
  agente ou por banco. As cores seguem ordem fixa (paleta
  validada para daltonismo); acima de 7 categorias, o
  excedente é agrupado em "Outros".
*/
const CORES_GRAFICO = [
  "#2a78d6", "#eb6834", "#1baf7a", "#eda100",
  "#e87ba4", "#008300", "#4a3aa7",
];
const COR_OUTROS = "#94a3b8";

const GraficoRosca = ({ dados }) => {
  const comValor = (dados || [])
    .map((d) => ({ nome: d.nome, valor: Number(d.valor) || 0 }))
    .filter((d) => d.valor > 0);

  const total = comValor.reduce((s, d) => s + d.valor, 0);

  if (!total) {
    return (
      <p className="texto-suave">
        Nenhum valor arrecadado para os filtros escolhidos.
      </p>
    );
  }

  let fatias = comValor;

  if (comValor.length > CORES_GRAFICO.length) {
    const visiveis = comValor.slice(0, CORES_GRAFICO.length);
    const resto = comValor
      .slice(CORES_GRAFICO.length)
      .reduce((s, d) => s + d.valor, 0);
    fatias = [...visiveis, { nome: "Outros", valor: resto, outros: true }];
  }

  const corDe = (fatia, i) =>
    fatia.outros ? COR_OUTROS : CORES_GRAFICO[i];

  const pctDe = (fatia) => (fatia.valor / total) * 100;

  const formatarPct = (pct) =>
    pct.toLocaleString("pt-BR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }) + "%";

  // Geometria da rosca: ângulos a partir das 12h, sentido horário
  const RE = 88;
  const RI = 56;

  const ponto = (r, ang) => [
    100 + r * Math.sin(ang),
    100 - r * Math.cos(ang),
  ];

  const arco = (a0, a1) => {
    const grande = a1 - a0 > Math.PI ? 1 : 0;
    const [x0, y0] = ponto(RE, a0);
    const [x1, y1] = ponto(RE, a1);
    const [x2, y2] = ponto(RI, a1);
    const [x3, y3] = ponto(RI, a0);
    return (
      `M ${x0} ${y0} ` +
      `A ${RE} ${RE} 0 ${grande} 1 ${x1} ${y1} ` +
      `L ${x2} ${y2} ` +
      `A ${RI} ${RI} 0 ${grande} 0 ${x3} ${y3} Z`
    );
  };

  let anguloAtual = 0;

  return (
    <div className="grafico-corpo">
      <svg
        viewBox="0 0 200 200"
        className="rosca-svg"
        role="img"
        aria-label="Gráfico de percentuais de arrecadação"
      >
        {fatias.length === 1 ? (
          <circle
            cx="100"
            cy="100"
            r={(RE + RI) / 2}
            fill="none"
            stroke={corDe(fatias[0], 0)}
            strokeWidth={RE - RI}
            className="rosca-fatia"
          >
            <title>
              {`${fatias[0].nome}: ${formatarBRL(fatias[0].valor)} (100%)`}
            </title>
          </circle>
        ) : (
          fatias.map((f, i) => {
            const a0 = anguloAtual;
            const a1 = a0 + (f.valor / total) * 2 * Math.PI;
            anguloAtual = a1;
            return (
              <path
                key={f.nome}
                d={arco(a0, a1)}
                fill={corDe(f, i)}
                stroke="#fff"
                strokeWidth="2"
                strokeLinejoin="round"
                className="rosca-fatia"
              >
                <title>
                  {`${f.nome}: ${formatarBRL(f.valor)} (${formatarPct(pctDe(f))})`}
                </title>
              </path>
            );
          })
        )}
      </svg>

      <div className="grafico-legenda">
        {fatias.map((f, i) => (
          <div key={f.nome} className="legenda-item">
            <span
              className="legenda-cor"
              style={{ background: corDe(f, i) }}
            />
            <span className="legenda-nome" title={f.nome}>
              {f.nome}
            </span>
            <span className="legenda-valor">{formatarBRL(f.valor)}</span>
            <span className="legenda-pct">{formatarPct(pctDe(f))}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

/*
  Gráfico de colunas do painel: total arrecadado por mês.
  Meses sem recebimento aparecem zerados para a linha do
  tempo não "pular" períodos.
*/
const MESES_ABREV = [
  "jan", "fev", "mar", "abr", "mai", "jun",
  "jul", "ago", "set", "out", "nov", "dez",
];
const MESES_NOME = [
  "janeiro", "fevereiro", "março", "abril", "maio", "junho",
  "julho", "agosto", "setembro", "outubro", "novembro", "dezembro",
];

const GraficoColunas = ({ dados }) => {
  const recebidos = (dados || [])
    .map((d) => ({ mes: String(d.mes), valor: Number(d.valor) || 0 }))
    .filter((d) => /^\d{4}-\d{2}$/.test(d.mes));

  if (!recebidos.length) {
    return (
      <p className="texto-suave">
        Nenhum valor arrecadado para os filtros escolhidos.
      </p>
    );
  }

  // Preenche os meses sem movimento entre o primeiro e o último
  const porMes = Object.fromEntries(recebidos.map((d) => [d.mes, d.valor]));
  const [anoIni, mesIni] = recebidos[0].mes.split("-").map(Number);
  const [anoFim, mesFim] = recebidos[recebidos.length - 1].mes.split("-").map(Number);

  const itens = [];
  for (
    let ano = anoIni, mes = mesIni;
    ano < anoFim || (ano === anoFim && mes <= mesFim);
    mes === 12 ? (ano++, mes = 1) : mes++
  ) {
    const chave = `${ano}-${String(mes).padStart(2, "0")}`;
    itens.push({
      chave,
      ano,
      mes,
      valor: porMes[chave] || 0,
    });
  }

  // Escala do eixo: 3 divisões com passo "redondo"
  const maior = Math.max(...itens.map((i) => i.valor), 1);
  const potencia = Math.pow(10, Math.floor(Math.log10(maior / 3)));
  const passo = Math.ceil(maior / 3 / potencia) * potencia;
  const teto = passo * 3;

  const formatarAbrev = (v) => {
    if (v >= 1e6) {
      return (
        (v / 1e6).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + " mi"
      );
    }
    if (v >= 1e3) {
      return Math.round(v / 1e3).toLocaleString("pt-BR") + " mil";
    }
    return String(Math.round(v));
  };

  // Área do desenho
  const X0 = 64;
  const X1 = 712;
  const Y0 = 200;
  const Y1 = 18;

  const passoX = (X1 - X0) / itens.length;
  const largura = Math.min(40, passoX * 0.6);
  const alturaDe = (v) => ((Y0 - Y1) * v) / teto;

  // Coluna com o topo arredondado, ancorada na linha de base
  const coluna = (x, altura) => {
    const raio = Math.min(4, altura);
    const yTopo = Y0 - altura;
    return (
      `M ${x} ${Y0} ` +
      `L ${x} ${yTopo + raio} ` +
      `Q ${x} ${yTopo} ${x + raio} ${yTopo} ` +
      `L ${x + largura - raio} ${yTopo} ` +
      `Q ${x + largura} ${yTopo} ${x + largura} ${yTopo + raio} ` +
      `L ${x + largura} ${Y0} Z`
    );
  };

  // Com muitos meses na tela, mostra um rótulo sim, outros não
  const saltoRotulo = Math.ceil(itens.length / 13);

  return (
    <svg
      viewBox="0 0 720 232"
      className="colunas-svg"
      role="img"
      aria-label="Gráfico da arrecadação por mês"
    >
      {[1, 2, 3].map((n) => {
        const y = Y0 - alturaDe(passo * n);
        return (
          <g key={n}>
            <line
              x1={X0}
              y1={y}
              x2={X1}
              y2={y}
              stroke="#e2e8f0"
              strokeWidth="1"
            />
            <text
              x={X0 - 8}
              y={y + 3.5}
              textAnchor="end"
              fontSize="10.5"
              fill="#64748b"
            >
              {formatarAbrev(passo * n)}
            </text>
          </g>
        );
      })}

      <line
        x1={X0}
        y1={Y0}
        x2={X1}
        y2={Y0}
        stroke="#cbd5e1"
        strokeWidth="1"
      />

      {itens.map((item, i) => {
        const x = X0 + i * passoX + (passoX - largura) / 2;
        return (
          <g key={item.chave}>
            {item.valor > 0 && (
              <path d={coluna(x, alturaDe(item.valor))} fill="#2a78d6" className="colunas-barra">
                <title>
                  {`${MESES_NOME[item.mes - 1]} de ${item.ano}: ${formatarBRL(item.valor)}`}
                </title>
              </path>
            )}
            {(i % saltoRotulo === 0 || itens.length <= 13) && (
              <text
                x={x + largura / 2}
                y={Y0 + 16}
                textAnchor="middle"
                fontSize="10.5"
                fill="#64748b"
              >
                {`${MESES_ABREV[item.mes - 1]}/${String(item.ano).slice(2)}`}
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
};

/* Título exibido na barra superior por tela */
const TITULOS = {
  dashboard: "Painel",
  perfil: "Meu Perfil",
  recebimentos: "Recebimentos",
  envios: "Envios ao SIAFIC",
  conciliacao: "Conciliação de Depósitos",
  agentes: "Agentes Arrecadadores",
  bancos: "Bancos",
  agencias: "Agências Bancárias",
  receitas: "Códigos de Receita",
  config: "Configuração SIAFIC",
  sequencia: "Sequência da Chave Única",
  relacionamentos: "Relacionamentos SIAFIC",
  fontes: "Fontes de Recursos",
  smtp: "E-mail (SMTP)",
  usuarios: "Usuários",
  ajuda: "Ajuda e Orientações de Uso",
};

/*
  Texto do botão de informações ao lado do título: uma explicação curta do que a tela
  faz e por onde começar. A visão completa fica na aba Ajuda.
*/
const DESCRICAO_TELAS = {
  dashboard:
    "Visão geral da arrecadação: totais do período, situação dos envios ao SIAFIC e os últimos recebimentos. Use os filtros de data, agente, banco e receita para recortar os números.",
  recebimentos:
    "Importe aqui o arquivo diário de cada agente arrecadador. O sistema lê as receitas, os valores e o documento, e cria um recebimento por agente/dia, pronto para o envio ao SIAFIC.",
  envios:
    "Acompanhe e transmita os recebimentos ao SIAFIC. Use a Prévia para conferir antes de enviar, o Histórico para ver cada tentativa com a descrição do que precisa ser corrigido, e o Estornar (administrador ou contabilidade) para desfazer um envio e reenviar corrigido.",
  conciliacao:
    "Compara o valor arrecadado por dia e agente com os comprovantes de depósito. Anexe o comprovante (os dados são lidos automaticamente), lance o depósito e distribua o valor entre os recebimentos. O PDF unificado traz a capa e, dia a dia, o BDA seguido dos comprovantes do dia.",
  agentes:
    "Cadastro dos agentes arrecadadores (lotéricas, bancos, correspondentes). O código de cada agente deve ser o mesmo usado nos arquivos que ele envia.",
  bancos:
    "Cadastro dos bancos com o código oficial (ex.: 001 Banco do Brasil). É a base para o reconhecimento dos arquivos e para os relacionamentos com o SIAFIC.",
  agencias:
    "Cadastro das agências bancárias: número, dígito e nome (opcional), vinculadas ao banco.",
  receitas:
    "Códigos de receita usados na arrecadação. São criados automaticamente na importação dos arquivos, mas podem ser ajustados ou completados aqui.",
  config:
    "Conexão com o SIAFIC (URL, token e órgão), mapeamento dos campos do arquivo, regras de envio e os e-mails avisados a cada envio. Depois de alterar, use o Testar Conexão SIAFIC.",
  sequencia:
    "Próximo número da chave única enviada ao SIAFIC em cada lançamento. Só altere com orientação da contabilidade — números repetidos são recusados.",
  relacionamentos:
    "O de-para com o SIAFIC, exigido no envio: conta bancária de cada banco (com dígito separado), credor de cada agente e o plano de contas de cada receita — o botão de sugestões preenche a maior parte sozinho.",
  fontes:
    "Fontes de recursos por exercício, usadas no de-para das receitas com o SIAFIC.",
  smtp:
    "Servidor de e-mail que dispara os avisos automáticos. O botão de informações da tela explica como obter os dados (Gmail, Outlook ou e-mail do domínio) e o envio de teste confirma a configuração.",
  usuarios:
    "Contas de acesso ao sistema. Administrador vê tudo; operador cuida da operação diária; gestor tem a visão de relatórios. O CPF cadastrado aqui é o login de entrada (o e-mail continua valendo para quem não tem CPF).",
  perfil:
    "Seus dados de acesso: nome, CPF, foto e troca de senha.",
};

function App() {
  // o sistema abre no Painel (pedido do SAAE, 23/10/2026)
  const [tela, setTela] = useState("dashboard");

  const [logado, setLogado] = useState(
    !!localStorage.getItem("token")
  );

  const [menuAberto, setMenuAberto] = useState(false);

  const [receitas, setReceitas] = useState([]);
  const [totalReceitas, setTotalReceitas] = useState(0);
  const [novaReceita, setNovaReceita] = useState({
    codigo: "",
    descricao: "",
    valor: ""
  });

  // Filtro por MÊS no painel (pedido do SAAE, 23/10/2026): vem selecionado
  // o mês vigente; escolher um mês preenche o período (1º ao último dia)
  const ymd = (d) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
  const periodoDoMes = (mes) => {
    const [a, m] = mes.split("-").map(Number);
    return { dataInicio: ymd(new Date(a, m - 1, 1)), dataFim: ymd(new Date(a, m, 0)) };
  };
  const mesVigente = () => ymd(new Date()).slice(0, 7);
  const NOMES_MESES = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
    "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  const opcoesMeses = (() => {
    const hoje = new Date();
    return Array.from({ length: 24 }, (_, i) => {
      const d = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);
      return { valor: ymd(d).slice(0, 7), rotulo: `${NOMES_MESES[d.getMonth()]}/${d.getFullYear()}` };
    });
  })();

  const [filtros, setFiltros] = useState({
    mes: mesVigente(),
    ...periodoDoMes(mesVigente()),
    agente: "",
    banco: "",
    receita: ""
  });

  const [pdf, setPdf] = useState(null);

  // Indica que o PDF já foi processado e ainda não foi salvo:
  // mostra o aviso para salvar em vez de processar de novo
  const [pdfProcessado, setPdfProcessado] = useState(false);

  // Estados visuais da tela de recebimentos: leitura do PDF em
  // andamento, gravação em andamento e arquivo sendo arrastado
  // sobre a área de upload
  const [processandoPdf, setProcessandoPdf] = useState(false);
  const [salvandoRecebimento, setSalvandoRecebimento] = useState(false);
  const [arrastandoPdf, setArrastandoPdf] = useState(false);

  // Anexo do espelho em recebimento antigo (sem PDF salvo)
  const [recebimentoAnexo, setRecebimentoAnexo] = useState(null);
  const inputEspelhoRef = useRef(null);
  // Anexo em comprovante de depósito lançado sem arquivo
  const [comprovanteAnexo, setComprovanteAnexo] = useState(null);
  const inputAnexoComprovanteRef = useRef(null);
  // Input do PDF na tela de recebimentos (para limpar após salvar)
  const inputPdfRef = useRef(null);
  const [dataRecebimento, setDataRecebimento] =
  useState("");

  const [listaAgentes, setListaAgentes] = useState([]);
  const [listaBancos, setListaBancos] = useState([]);
  const [listaAgencias, setListaAgencias] = useState([]);
  const [listaReceitas, setListaReceitas] = useState([]);
  const [listaRecebimentos, setListaRecebimentos] =
  useState([]);
  // Pesquisa nos Recebimentos Salvos (pedido do SAAE, 14/10/2026): por
  // valor, mês do recebimento, data, agente e banco
  // Filtro de STATUS (pedido do SAAE, 16/10/2026)
  const filtroRecebVazio = { valor: "", mes: "", data: "", agente: "", banco: "", status: "" };
  const [filtroReceb, setFiltroReceb] = useState(filtroRecebVazio);
  // Lista de envios estornados (pedido do SAAE, 15/10/2026)
  const [listaEstornos, setListaEstornos] = useState([]);
  const [recebimentoSelecionado, setRecebimentoSelecionado] =
  useState(null);

  // Histórico de tentativas de envio ao SIAFIC:
  // { recebimento, itens: [{data_tentativa, sucesso, erro, dica, ...}] }
  const [historicoEnvios, setHistoricoEnvios] = useState(null);

  // Avisos do sistema (pendências operacionais no topo das telas)
  const [avisosSistema, setAvisosSistema] = useState([]);

  // Recebimentos ESTORNADOS aguardando resolução (pedido do SAAE,
  // 21/10/2026): alerta em todas as telas e lembrete periódico até o
  // recebimento ser reenviado ou excluído e substituído por um novo
  const [estornadosPendentes, setEstornadosPendentes] = useState([]);
  const LEMBRETE_ESTORNO_MS = 2 * 60 * 60 * 1000;

  const carregarEstornadosPendentes = async () => {
    try {
      const r = await axios.get("/api/estornados-pendentes");
      const itens = Array.isArray(r.data) ? r.data : [];
      setEstornadosPendentes(itens);
      if (itens.length === 0) return;
      // lembrete em janela a cada 2 horas de uso
      let ultimo = 0;
      try { ultimo = Number(localStorage.getItem("lembreteEstornadosEm")) || 0; } catch (e) {}
      if (Date.now() - ultimo < LEMBRETE_ESTORNO_MS) return;
      try { localStorage.setItem("lembreteEstornadosEm", String(Date.now())); } catch (e) {}
      const total = itens.reduce((acc, x) => acc + (Number(x.valor) || 0), 0);
      mostrarAlerta(
        `Há ${itens.length} recebimento(s) ESTORNADO(S) no SIAFIC aguardando ` +
          `resolução (${formatarBRL(total)}):\n\n` +
          itens.map((x) =>
            `• ${formatarData(x.data_recebimento)} · ${x.agente_nome || "-"} · ` +
            `${formatarBRL(x.valor)}` +
            (x.estornado_em ? ` — estornado há ${x.dias_estornado} dia(s)` : "")
          ).join("\n") +
          "\n\nResolva de uma das formas:\n" +
          "1. Arquivo errado: inclua um NOVO recebimento com o arquivo correto " +
          "e EXCLUA este envio estornado;\n" +
          "2. Arquivo correto: REENVIE ao SIAFIC (Envios > Status SIAFIC).",
        "Estornados aguardando resolução"
      );
    } catch (err) {
      console.log("ERRO ESTORNADOS PENDENTES:", err.message);
    }
  };

  const verEstornadosNoStatus = () => {
    setFiltroReceb({ ...filtroRecebVazio, status: "ESTORNADO" });
    setTela("envios");
  };

  const carregarAvisos = async () => {
    try {
      const r = await axios.get("/api/avisos");
      setAvisosSistema(Array.isArray(r.data) ? r.data : []);
    } catch (err) {
      console.log("ERRO AVISOS:", err.message);
    }
  };

  const resolverAviso = async (aviso) => {
    const confirmar = await mostrarConfirmacao(
      "Marcar este aviso como resolvido?\n\n" + aviso.texto
    );
    if (!confirmar) return;
    try {
      await axios.post(`/api/avisos/${aviso.id}/resolver`);
      await carregarAvisos();
    } catch (err) {
      mostrarAlerta(
        err.response?.data?.erro || "Não foi possível resolver o aviso."
      );
    }
  };

  const abrirHistoricoEnvios = async (recebimento) => {
    try {
      const resposta = await axios.get(
        `/api/historico-siafic/${recebimento.id}`
      );
      setHistoricoEnvios({
        recebimento,
        itens: resposta.data || [],
      });
    } catch (err) {
      mostrarAlerta("Não foi possível carregar o histórico de envios.");
    }
  };

  /* ========= MODAL PERSONALIZADO ========= */
  // modal = { tipo: "alerta"|"confirmacao"|"prompt", titulo, mensagem, variante, resolver }
  const [modal, setModal] = useState(null);
  const [modalInput, setModalInput] = useState("");

  /* ========= RELACIONAMENTO DE RECEITAS (SIAFIC) ========= */

  // Lista exibida na tela: mistura o que já está vinculado com as
  // sugestões vindas do catálogo do SIAFIC.
  const [relReceitas, setRelReceitas] = useState([]);
  const [sugestoesReceitas, setSugestoesReceitas] = useState([]);
  const [carregandoRelReceitas, setCarregandoRelReceitas] = useState(false);

  // Catálogo de rubricas do SIAFIC, usado no seletor de cada linha
  const [planosContasSiafic, setPlanosContasSiafic] = useState([]);

  // Alterações ainda não salvas, por código de receita
  const [edicaoReceitas, setEdicaoReceitas] = useState({});
  const [salvandoReceita, setSalvandoReceita] = useState(null);

  // Diagnóstico dos métodos da API (tela de Configuração SIAFIC)
  const [diagnosticoSiafic, setDiagnosticoSiafic] = useState(null);
  const [testandoMetodos, setTestandoMetodos] = useState(false);

  /* ========= CONCILIAÇÃO DE DEPÓSITOS ========= */

  // Filtros do painel. Por padrão, o mês corrente.
  const primeiroDiaDoMes = () => {
    const hoje = new Date();
    return new Date(hoje.getFullYear(), hoje.getMonth(), 1)
      .toISOString()
      .slice(0, 10);
  };

  const hojeISO = () => new Date().toISOString().slice(0, 10);

  const [filtroConc, setFiltroConc] = useState({
    inicio: primeiroDiaDoMes(),
    fim: hojeISO(),
    agente_id: "",
    banco_id: "",
    situacao: "",
  });

  // Resultado do painel: linhas por dia, totais por agente e totais gerais
  const [conciliacao, setConciliacao] = useState({
    linhas: [],
    agentes: [],
    totais: { valor_arrecadado: 0, valor_conciliado: 0, diferenca: 0 },
  });

  const [carregandoConc, setCarregandoConc] = useState(false);

  // Controla o lembrete de depósitos a menor: aparece uma vez a cada
  // visita à tela de conciliação, não a cada recarga de filtro.
  const avisoDepositoMenorMostrado = useRef(false);

  /* ========= CONFIGURAÇÃO DO E-MAIL (SMTP) ========= */

  const [configSmtp, setConfigSmtp] = useState({
    host: "",
    porta: 587,
    usuario: "",
    senha: "",
    remetente: "",
    tem_senha: false,
  });

  const [mostrarComoObterSmtp, setMostrarComoObterSmtp] = useState(false);
  const [emailTesteSmtp, setEmailTesteSmtp] = useState("");
  const [testandoSmtp, setTestandoSmtp] = useState(false);

  const carregarSmtp = async () => {
    try {
      const resposta = await axios.get("/api/smtp");
      setConfigSmtp({ ...resposta.data, senha: "" });
    } catch (err) {
      console.log(err);
    }
  };

  const salvarSmtp = async () => {
    try {
      await axios.post("/api/smtp", configSmtp);
      await carregarSmtp();
      mostrarAlerta("Configuração de e-mail salva com sucesso");
    } catch (err) {
      mostrarAlerta(
        err.response?.data?.erro || "Erro ao salvar a configuração de e-mail"
      );
    }
  };

  const testarSmtp = async () => {
    if (!emailTesteSmtp) {
      return mostrarAlerta("Informe o e-mail que receberá o teste.");
    }
    setTestandoSmtp(true);
    try {
      const resposta = await axios.post("/api/smtp/testar", {
        para: emailTesteSmtp,
      });
      mostrarAlerta(resposta.data.mensagem || "E-mail de teste enviado.");
    } catch (err) {
      const dados = err.response?.data;
      mostrarAlerta(
        (dados?.erro || "O envio de teste falhou.") +
          (dados?.dica ? "\n\n" + dados.dica : "")
      );
    } finally {
      setTestandoSmtp(false);
    }
  };

  // Modal do lembrete com a escolha de frequência por usuário:
  // { itens, total, dias } — dias null = todo dia; 2/3/5 = a cada N dias
  const [lembreteDeposito, setLembreteDeposito] = useState(null);

  const fecharLembreteDeposito = async () => {

    const escolha = lembreteDeposito?.dias ?? null;

    setLembreteDeposito(null);

    try {
      await axios.post("/api/perfil/preferencias", {
        lembrete_deposito_dias: escolha,
        marcar_visto: true,
      });
    } catch (err) {
      // Sem gravar a preferência o lembrete só volta a aparecer
      console.log(err);
    }

  };

  const [listaComprovantes, setListaComprovantes] = useState([]);

  // Recebimentos disponíveis para vincular ao comprovante
  const [recebimentosConc, setRecebimentosConc] = useState([]);

  // Formulário de lançamento do comprovante.
  // Primeiro registra-se o depósito; os recebimentos são vinculados depois.
  const comprovanteVazio = {
    data_deposito: hojeISO(),
    valor: "",
    numero_documento: "",
    observacao: "",
  };

  const [novoComprovante, setNovoComprovante] = useState(comprovanteVazio);
  const [arquivoComprovante, setArquivoComprovante] = useState(null);
  const [salvandoComprovante, setSalvandoComprovante] = useState(false);

  // Usado para limpar o campo quando o arquivo é recusado
  // (PDF com senha ou Boletim Diário de Arrecadação)
  const inputArquivoComprovanteRef = useRef(null);

  // Leitura automática do arquivo anexado (nº do documento, valor, data)
  const [extraindoComprovante, setExtraindoComprovante] = useState(false);
  const [dadosExtraidos, setDadosExtraidos] = useState(null);

  // Vínculo do depósito com recebimentos:
  // { comprovante_id, valor_total, saldo, valores: { [recebimento_id]: "0,00" } }
  const [vinculando, setVinculando] = useState(null);

  // Linha do dia aberta em detalhe
  const [detalheConc, setDetalheConc] = useState(null);

  // Remanejamento de sobra: { comprovante, data_origem, data_destino, valor }
  const [remanejando, setRemanejando] = useState(null);

  /* ========= SEQUÊNCIA DA CHAVE ÚNICA ========= */
  const [proximoChave, setProximoChave] = useState("");

  const [agente, setAgente] = useState("");
  const [banco, setBanco] = useState("");
  const [agenciaBanco, setAgenciaBanco] =
  useState("");

  const [nomeAgencia, setNomeAgencia] =
  useState("");
  const [numeroAgencia, setNumeroAgencia] =
  useState("");
  const [codigoBanco, setCodigoBanco] = useState("");
  const [codigoAgente, setCodigoAgente] = useState("");
  const [agenteBanco, setAgenteBanco] =
  useState("");
  const [agenteAgencia, setAgenteAgencia] =
  useState("");
  // id do agente em edição (null = cadastro novo)
  const [agenteEditando, setAgenteEditando] = useState(null);



const [relBanco, setRelBanco] = useState("");
const [relConta, setRelConta] = useState("");
// Dígito verificador da conta, informado separado: a API do SIAFIC
// recebe conta e dígito em campos distintos (CONTA_RECEBEDORA / DIGITO)
const [relDigito, setRelDigito] = useState("");
const [relAgente, setRelAgente] = useState("");
const [relCredor, setRelCredor] = useState("");

/* ========= RELACIONAMENTOS BANCOS AGENTES ========= */

const [listaRelacionamentosBancos, setListaRelacionamentosBancos] =
useState([]);
const [listaRelacionamentosAgentes, setListaRelacionamentosAgentes] =
useState([]);

/* ========= DE PARA API SIAFIC ========= */
const [deParaSiafic, setDeParaSiafic] = useState([]);

/* ========= RELACIONAMENTOS SIAFIC ========= */

const [codigoSistema, setCodigoSistema] = useState("");

const [codigoCredor, setCodigoCredor] = useState("");

/* ========= EXERCICIO E FONTE DE RECURSOS ========= */

// listas
const [listaExercicios, setListaExercicios] = useState([]);
const [listaFontesRecurso, setListaFontesRecurso] = useState([]);
const [listaVinculosFonte, setListaVinculosFonte] = useState([]);
const [listaReceitaVinculos, setListaReceitaVinculos] = useState([]);

// etapa 1 - exercício
const [novoExercicio, setNovoExercicio] = useState("");

// etapa 2 - fonte de recurso
const [novaFonteCodigo, setNovaFonteCodigo] = useState("");
const [novaFonteDescricao, setNovaFonteDescricao] = useState("");

// etapa 3 - vínculo fonte x exercício
const [vinculoFonte, setVinculoFonte] = useState("");
const [vinculoExercicio, setVinculoExercicio] = useState("");

// etapa 4 - vínculo receita x (exercício/fonte)
const [vinculoReceita, setVinculoReceita] = useState("");
const [vinculoFonteExercicio, setVinculoFonteExercicio] = useState("");

/* ========= CONFIG SIAFIC ========= */
const [configSiafic, setConfigSiafic] = useState({

  // conexão
  url: "",
  token: "",
  usuario: "",
  senha: "",

  // órgão
  codigoOrgao: "",
  nomeOrgao: "",
  exercicio: "",

  // recebimento
  

  // integração
  ambiente: "homologacao",
  tipoIntegracao: "api",

  // mapeamentos
  campoReceita: "codigo",
  campoValor: "valor",
  campoData: "dataRecebimento",
  campoAgente: "agente",
  campoBanco: "banco",
  campoAgencia: "agencia",

  // mapeamentos DE-PARA (chaves de controle do lote/recebimento)
  cdChave: "",
  cdRecebimento: "",
  chaveUnica: "",
  dtGeracao: "",

  // envio
  enviarAutomatico: false,
  validarAntesEnviar: true,

  // e-mails avisados a cada envio de arrecadação (separados por vírgula)
  emailsNotificacao: "",

  // liga/desliga o disparo dos avisos sem apagar os e-mails
  avisosAtivos: true,

  // observações
  observacaoPadrao: ""

});

  const [codigoReceita, setCodigoReceita] = useState("");
  const [descricaoReceita, setDescricaoReceita] = useState("");
  const [mostrarToken, setMostrarToken] =
  useState(false);

  const [mostrarUrl, setMostrarUrl] =
  useState(false);

  const [usuario, setUsuario] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("usuario")) || { tipo: "admin" };
    } catch (e) {
      return { tipo: "admin" };
    }
  });

  const atualizarUsuario = (novo) => {
    setUsuario(novo);
    localStorage.setItem("usuario", JSON.stringify(novo));
  };

  const sair = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("usuario");
    delete axios.defaults.headers.common["Authorization"];
    setLogado(false);
  };

  /* ========= HELPERS DO MODAL PERSONALIZADO ========= */

  // Detecta a variante (cor/ícone) a partir do texto da mensagem
  const detectarVariante = (mensagem) => {
    const t = String(mensagem || "").toLowerCase();
    if (t.includes("erro") || t.includes("inválid") || t.includes("invalid") ||
        t.includes("não") || t.includes("falha") || t.includes("preencha")) {
      return "erro";
    }
    if (t.includes("sucesso") || t.includes("salv") || t.includes("atualiz") ||
        t.includes("excluíd") || t.includes("vinculad")) {
      return "sucesso";
    }
    return "info";
  };

  // Substitui window.alert — retorna Promise que resolve ao clicar OK
  const mostrarAlerta = (mensagem, titulo) =>
    new Promise((resolve) => {
      const variante = detectarVariante(mensagem);
      setModal({
        tipo: "alerta",
        titulo: titulo || (variante === "erro" ? "Erro" : variante === "sucesso" ? "Sucesso" : "Aviso"),
        mensagem: String(mensagem),
        variante,
        resolver: resolve
      });
    });

  // Substitui window.confirm — retorna Promise<boolean>
  const mostrarConfirmacao = (mensagem, titulo) =>
    new Promise((resolve) => {
      setModal({
        tipo: "confirmacao",
        titulo: titulo || "Confirmação",
        mensagem: String(mensagem),
        variante: "info",
        resolver: resolve
      });
    });

  // Substitui window.prompt — retorna Promise<string|null>
  const mostrarPrompt = (mensagem, valorInicial, titulo) =>
    new Promise((resolve) => {
      setModalInput(valorInicial != null ? String(valorInicial) : "");
      setModal({
        tipo: "prompt",
        titulo: titulo || "Editar",
        mensagem: String(mensagem),
        variante: "info",
        resolver: resolve
      });
    });

  const fecharModal = (resultado) => {
    if (modal?.resolver) modal.resolver(resultado);
    setModal(null);
  };

  /* ========= PERFIL ========= */
  const [perfilSenhaAtual, setPerfilSenhaAtual] = useState("");
  const [perfilNovaSenha, setPerfilNovaSenha] = useState("");
  const [perfilConfirmaSenha, setPerfilConfirmaSenha] = useState("");
  const [perfilMsg, setPerfilMsg] = useState(null);
  const [salvandoSenha, setSalvandoSenha] = useState(false);

  const irParaPerfil = () => {
    // A sincronização dos dados acontece no efeito de troca de tela,
    // que também cobre a entrada pela aba "Meu Perfil" do menu.
    setTela("perfil");
    setMenuAberto(false);
  };

  const trocarSenha = async (e) => {
    e.preventDefault();
    setPerfilMsg(null);

    if (perfilNovaSenha.length < 6) {
      setPerfilMsg({ tipo: "erro", texto: "A nova senha deve ter ao menos 6 caracteres" });
      return;
    }
    if (perfilNovaSenha !== perfilConfirmaSenha) {
      setPerfilMsg({ tipo: "erro", texto: "A confirmação não confere com a nova senha" });
      return;
    }

    setSalvandoSenha(true);
    try {
      await axios.put("/api/perfil/senha", {
        senhaAtual: perfilSenhaAtual,
        novaSenha: perfilNovaSenha,
      });
      setPerfilMsg({ tipo: "ok", texto: "Senha alterada com sucesso!" });
      setPerfilSenhaAtual("");
      setPerfilNovaSenha("");
      setPerfilConfirmaSenha("");
    } catch (err) {
      setPerfilMsg({
        tipo: "erro",
        texto: err.response?.data?.erro || "Erro ao alterar senha",
      });
    } finally {
      setSalvandoSenha(false);
    }
  };

  const salvarFoto = async (dataUrl) => {
    setPerfilMsg(null);
    try {
      await axios.put("/api/perfil/foto", { foto: dataUrl });
      atualizarUsuario({ ...usuario, foto: dataUrl });
      setPerfilMsg({ tipo: "ok", texto: "Foto atualizada com sucesso!" });
    } catch (err) {
      setPerfilMsg({
        tipo: "erro",
        texto: err.response?.data?.erro || "Erro ao salvar a foto",
      });
    }
  };

  const selecionarFoto = (e) => {
    const arquivo = e.target.files[0];
    if (!arquivo) return;
    lerImagemRedimensionada(arquivo).then(salvarFoto).catch(() => {});
    e.target.value = "";
  };

  const removerFoto = async () => {
    setPerfilMsg(null);
    try {
      await axios.put("/api/perfil/foto", { foto: null });
      atualizarUsuario({ ...usuario, foto: null });
      setPerfilMsg({ tipo: "ok", texto: "Foto removida." });
    } catch (err) {
      setPerfilMsg({ tipo: "erro", texto: "Erro ao remover a foto" });
    }
  };

  /* Nome (editável) e e-mail (somente leitura) */
  const [perfilNome, setPerfilNome] = useState("");
  const [perfilEmail, setPerfilEmail] = useState("");
  const [perfilCpf, setPerfilCpf] = useState("");
  const [salvandoNome, setSalvandoNome] = useState(false);

  const sincronizarPerfil = async () => {
    try {
      const r = await axios.get("/api/perfil");
      setPerfilNome(r.data.nome || "");
      setPerfilEmail(r.data.email || "");
      setPerfilCpf(r.data.cpf || "");
      atualizarUsuario({
        ...usuario,
        nome: r.data.nome,
        email: r.data.email,
        tipo: r.data.tipo,
        foto: r.data.foto,
      });
    } catch (e) {
      console.log(e);
    }
  };

  const salvarNome = async (e) => {
    e.preventDefault();
    setPerfilMsg(null);
    if (!perfilNome.trim()) {
      setPerfilMsg({ tipo: "erro", texto: "Informe o nome" });
      return;
    }
    setSalvandoNome(true);
    try {
      await axios.put("/api/perfil/nome", { nome: perfilNome.trim() });
      atualizarUsuario({ ...usuario, nome: perfilNome.trim() });
      setPerfilMsg({ tipo: "ok", texto: "Nome atualizado com sucesso!" });
    } catch (err) {
      setPerfilMsg({
        tipo: "erro",
        texto: err.response?.data?.erro || "Erro ao salvar o nome",
      });
    } finally {
      setSalvandoNome(false);
    }
  };

  /* ========= USUÁRIOS (admin) ========= */
  const [listaUsuarios, setListaUsuarios] = useState([]);
  const [usuarioForm, setUsuarioForm] = useState({
    id: null,
    nome: "",
    email: "",
    cpf: "",
    senha: "",
    tipo: "operador",
    foto: null,
  });
  const [usuarioMsg, setUsuarioMsg] = useState(null);

  const selecionarFotoUsuario = (e) => {
    const arquivo = e.target.files[0];
    if (!arquivo) return;
    lerImagemRedimensionada(arquivo)
      .then((dataUrl) => setUsuarioForm((f) => ({ ...f, foto: dataUrl })))
      .catch(() => {});
    e.target.value = "";
  };

  const carregarUsuarios = async () => {
    try {
      const r = await axios.get("/api/usuarios");
      setListaUsuarios(r.data);
    } catch (e) {
      console.log(e);
    }
  };

  const novoUsuario = () => {
    setUsuarioForm({ id: null, nome: "", email: "", cpf: "", senha: "", tipo: "operador", foto: null });
    setUsuarioMsg(null);
  };

  const editarUsuario = (u) => {
    setUsuarioForm({
      id: u.id,
      nome: u.nome,
      email: u.email,
      cpf: formatarCpf(u.cpf || ""),
      senha: "",
      tipo: u.tipo,
      foto: u.foto || null,
    });
    setUsuarioMsg(null);
  };

  const salvarUsuario = async (e) => {
    e.preventDefault();
    setUsuarioMsg(null);
    try {
      if (usuarioForm.id) {
        await axios.put("/api/usuarios/" + usuarioForm.id, {
          nome: usuarioForm.nome,
          tipo: usuarioForm.tipo,
          cpf: limparCpf(usuarioForm.cpf) || null,
          senha: usuarioForm.senha || undefined,
          foto: usuarioForm.foto,
        });
      } else {
        await axios.post("/api/usuarios", {
          nome: usuarioForm.nome,
          email: usuarioForm.email,
          cpf: limparCpf(usuarioForm.cpf) || null,
          senha: usuarioForm.senha,
          tipo: usuarioForm.tipo,
          foto: usuarioForm.foto,
        });
      }
      setUsuarioMsg({ tipo: "ok", texto: "Usuário salvo com sucesso!" });
      novoUsuario();
      carregarUsuarios();
      // se editou a si mesmo, reflete o nome
      sincronizarPerfil();
    } catch (err) {
      setUsuarioMsg({
        tipo: "erro",
        texto: err.response?.data?.erro || "Erro ao salvar usuário",
      });
    }
  };

  const excluirUsuario = async (id) => {
    if (!(await mostrarConfirmacao("Excluir este usuário?"))) return;
    setUsuarioMsg(null);
    try {
      await axios.delete("/api/usuarios/" + id);
      carregarUsuarios();
    } catch (err) {
      setUsuarioMsg({
        tipo: "erro",
        texto: err.response?.data?.erro || "Erro ao excluir usuário",
      });
    }
  };

  /* ========= PAINEL (indicadores) ========= */
  const [dashboard, setDashboard] = useState(null);

  // Dimensão do gráfico de percentuais: "agente" ou "banco"
  const [graficoPor, setGraficoPor] = useState("agente");

  const carregarDashboard = async (filtrosAplicar) => {
    try {
      const f = filtrosAplicar || filtros;
      const params = {};
      if (f.dataInicio) params.dataInicio = f.dataInicio;
      if (f.dataFim) params.dataFim = f.dataFim;
      if (f.agente) params.agente = f.agente;
      if (f.banco) params.banco = f.banco;
      if (f.receita) params.receita = f.receita;

      const r = await axios.get("/api/dashboard", { params });
      setDashboard(r.data);
    } catch (e) {
      console.log(e);
    }
  };

  const limparFiltros = () => {
    const vazio = { mes: "", dataInicio: "", dataFim: "", agente: "", banco: "", receita: "" };
    setFiltros(vazio);
    carregarDashboard(vazio);
  };

  const formatarCodigo = (valor) => {
    let v = valor.replace(/\D/g, "");

    return v
      .replace(/^(\d)(\d)/, "$1.$2")
      .replace(/^(\d\.\d)(\d)/, "$1.$2")
      .replace(/^(\d\.\d\.\d)(\d)/, "$1.$2")
      .replace(/^(\d\.\d\.\d\.\d)(\d{2})/, "$1.$2")
      .replace(/^(\d\.\d\.\d\.\d\.\d{2})(\d)/, "$1.$2")
      .replace(/^(\d\.\d\.\d\.\d\.\d{2}\.\d)(\d)/, "$1.$2")
      .replace(/^(\d\.\d\.\d\.\d\.\d{2}\.\d\.\d)(\d{2})/, "$1.$2")
      .replace(/^(\d\.\d\.\d\.\d\.\d{2}\.\d\.\d\.\d{2})(\d{2})/, "$1.$2")
      .slice(0, 21);
  };

  useEffect(() => {

  // Só carrega dados protegidos depois de logado
  if (!logado) return;

  carregarDados();
  carregarRecebimentos();
  carregarDeParaSiafic();
  carregarConfig();
  carregarProximoChave();
  sincronizarPerfil();
  carregarAvisos();
  carregarEstornadosPendentes();

  // estornados: confere de novo a cada 15 minutos (alerta periódico)
  const timerEstornados = setInterval(carregarEstornadosPendentes, 15 * 60 * 1000);
  return () => clearInterval(timerEstornados);

}, [logado]);

/* Título da aba do navegador conforme a tela */
useEffect(() => {
  document.title = "IntegraReceitas · " + (TITULOS[tela] || "Painel");
}, [tela]);

/* Bloqueia telas que o perfil do usuário não pode acessar */
useEffect(() => {
  const permitidas = new Set(
    MENU.flatMap((s) => s.itens)
      .filter((i) => i.roles.includes(usuario.tipo))
      .map((i) => i.id)
      .concat("perfil")
  );
  if (!permitidas.has(tela)) {
    setTela("dashboard");
  }
}, [tela, usuario.tipo]);

/* Carrega dados sob demanda ao abrir Painel ou Usuários */
useEffect(() => {
  if (!logado) return;
  if (tela === "dashboard") carregarDashboard();
  if (tela === "perfil") {
    setPerfilMsg(null);
    sincronizarPerfil();
  }
  if (tela === "usuarios" && usuario.tipo === "admin") carregarUsuarios();
  if (tela === "conciliacao") carregarConciliacao();
  if (tela === "relacionamentos") carregarVinculosReceitas();
  if (tela === "smtp" && usuario.tipo === "admin") carregarSmtp();

  // Saiu da conciliação: o lembrete de depósitos a menor volta a
  // aparecer na próxima visita à tela.
  if (tela !== "conciliacao") avisoDepositoMenorMostrado.current = false;
}, [tela, logado]);

/* ========= RELACIONAMENTO DE RECEITAS ========= */

/*
  Mostra os vínculos JÁ GRAVADOS ao abrir a tela, sem depender da
  consulta ao SIAFIC. O botão "Buscar sugestões" continua existindo
  para completar o que falta — antes deste carregamento a tela voltava
  vazia após recarregar, mesmo com os vínculos salvos no banco.
*/
const carregarVinculosReceitas = async () => {

  try {

    const resposta = await axios.get("/api/relacionamentos/receitas");

    const linhas = (resposta.data || []).map((r) => ({
      codigo_receita: r.codigo_receita,
      num_plano_contas: r.num_plano_contas,
      ds_plano_contas: r.ds_plano_contas,
      num_fonte_recurso: r.num_fonte_recurso,
      ja_vinculado: !!r.relacionamento_id,
      encontrado: !!r.num_plano_contas,
    }));

    setRelReceitas(linhas);
    setSugestoesReceitas([]);
    setEdicaoReceitas({});

  } catch (err) {

    // Sem a lista gravada a tela ainda funciona pelo botão de sugestões
    console.log(err);

  }

};

/* Busca no SIAFIC as rubricas e monta a lista com o que já está vinculado */
const carregarRelReceitas = async () => {

  setCarregandoRelReceitas(true);

  try {

    const ano = new Date().getFullYear();

    const resposta = await axios.get(
      `/api/relacionamentos/receitas/sugestoes?ano=${ano}`
    );

    const sugestoes = resposta.data.sugestoes || [];

    setRelReceitas(sugestoes);
    setEdicaoReceitas({});

    // Carrega o catálogo para permitir a escolha manual da rubrica
    try {
      const catalogo = await axios.get(
        `/api/siafic-catalogo/planos-contas?ano=${ano}`
      );
      setPlanosContasSiafic(catalogo.data || []);
    } catch (e) {
      // Sem o catálogo a tela ainda funciona, só não oferece a lista
      setPlanosContasSiafic([]);
    }

    // Só entram na aplicação em lote as que o SIAFIC reconheceu
    // e que ainda não estão vinculadas.
    setSugestoesReceitas(
      sugestoes.filter((s) => s.encontrado && !s.ja_vinculado)
    );

    const pendentes = sugestoes.filter((s) => !s.encontrado).length;

    if (pendentes > 0) {
      mostrarAlerta(
        `${sugestoes.length - pendentes} de ${sugestoes.length} receitas ` +
          `foram localizadas no SIAFIC. As demais precisam ser vinculadas à mão.`
      );
    }

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível consultar o plano de contas do SIAFIC."
    );

  } finally {

    setCarregandoRelReceitas(false);

  }

};

const aplicarSugestoesReceitas = async () => {

  if (sugestoesReceitas.length === 0) {
    return mostrarAlerta("Não há sugestões novas para aplicar.");
  }

  const confirmou = await mostrarConfirmacao(
    `Vincular ${sugestoesReceitas.length} receita(s) ao plano de contas ` +
      `sugerido pelo SIAFIC?`
  );

  if (!confirmou) return;

  try {

    const resposta = await axios.post(
      "/api/relacionamentos/receitas/aplicar-sugestoes",
      { itens: sugestoesReceitas }
    );

    mostrarAlerta(`${resposta.data.gravados} receita(s) vinculada(s).`);

    await carregarRelReceitas();

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro || "Não foi possível aplicar as sugestões."
    );

  }

};

/* Salva o vínculo de uma única receita, escolhido à mão na lista */
const salvarRelReceita = async (codigo) => {

  const escolhido = edicaoReceitas[codigo];

  if (!escolhido) {
    return mostrarAlerta("Selecione o plano de contas antes de salvar.");
  }

  const plano = planosContasSiafic.find(
    (p) => String(p.num_plano_contas) === String(escolhido)
  );

  if (!plano) {
    return mostrarAlerta("Plano de contas não encontrado no catálogo.");
  }

  setSalvandoReceita(codigo);

  try {

    await axios.post("/api/relacionamentos/receitas", {
      codigo_receita: codigo,
      num_plano_contas: plano.num_plano_contas,
      ds_plano_contas: plano.ds_plano_contas,
      num_fonte_recurso: plano.num_fonte_recurso,
    });

    // Atualiza a linha na tela sem refazer a consulta inteira
    setRelReceitas((lista) =>
      lista.map((r) =>
        r.codigo_receita === codigo
          ? {
              ...r,
              ja_vinculado: true,
              encontrado: true,
              num_plano_contas: plano.num_plano_contas,
              ds_plano_contas: plano.ds_plano_contas,
              num_fonte_recurso: plano.num_fonte_recurso,
            }
          : r
      )
    );

    setEdicaoReceitas((e) => {
      const novo = { ...e };
      delete novo[codigo];
      return novo;
    });

    setSugestoesReceitas((s) =>
      s.filter((x) => x.codigo_receita !== codigo)
    );

    mostrarAlerta(`Receita ${codigo} vinculada com sucesso.`);

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro || "Não foi possível salvar o vínculo."
    );

  } finally {

    setSalvandoReceita(null);

  }

};

const excluirRelReceita = async (codigo) => {

  const confirmou = await mostrarConfirmacao(
    `Remover o vínculo da receita ${codigo}?`
  );

  if (!confirmou) return;

  try {

    await axios.delete(
      `/api/relacionamentos/receitas/${encodeURIComponent(codigo)}`
    );

    await carregarVinculosReceitas();

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro || "Não foi possível remover o vínculo."
    );

  }

};

/*
  Mostra o que seria enviado ao SIAFIC, sem enviar.
  Serve para conferir o de-para e as pendências antes de gravar.
*/
const verPreviaEnvio = async (id) => {

  try {

    const resposta = await axios.get(`/api/previa-envio/${id}`);

    const d = resposta.data;

    if (!d.pronto) {
      return mostrarAlerta(
        "Este recebimento ainda não pode ser enviado:\n\n• " +
          d.pendencias.join("\n• ") +
          "\n\nCadastre os itens em Relacionamentos SIAFIC."
      );
    }

    mostrarAlerta(
      `Pronto para envio.\n\n` +
        `Linhas: ${d.quantidade_linhas}\n` +
        `Valor total: ${formatarBRL(d.valor_total)}\n\n` +
        `Cada linha corresponde a uma rubrica contábil do recebimento.`,
      "Prévia do envio"
    );

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro || "Não foi possível montar a prévia."
    );

  }

};

/* Testa todos os métodos da API com as credenciais salvas */
const testarMetodosSiafic = async () => {

  setTestandoMetodos(true);
  setDiagnosticoSiafic(null);

  try {

    const ano = new Date().getFullYear();

    const resposta = await axios.get(
      `/api/siafic-catalogo/diagnostico?ano=${ano}`
    );

    setDiagnosticoSiafic(resposta.data);

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível executar o diagnóstico dos métodos."
    );

  } finally {

    setTestandoMetodos(false);

  }

};

/* ========= CONCILIAÇÃO ========= */

/* Monta a query string dos filtros, ignorando os campos vazios */
const paramsConciliacao = (extras = {}) => {
  const p = new URLSearchParams();
  const origem = { ...filtroConc, ...extras };
  Object.entries(origem).forEach(([k, v]) => {
    if (v !== "" && v != null) p.append(k, v);
  });
  return p.toString();
};

/* Busca o painel (linhas por dia + totais) e a lista de comprovantes */
const carregarConciliacao = async () => {

  setCarregandoConc(true);

  try {

    const painel = await axios.get(
      "/api/conciliacao?" + paramsConciliacao()
    );

    setConciliacao(painel.data);

    // Lembrete de cobrança: dias em que o agente depositou a menor
    // (ou não depositou). A frequência é escolhida por usuário no
    // próprio pop-up: todo dia (padrão) ou a cada 2/3/5 dias.
    const aMenor = (painel.data.linhas || []).filter(
      (l) => l.situacao === "pendente" && l.diferenca > 0
    );

    if (aMenor.length > 0 && !avisoDepositoMenorMostrado.current) {

      avisoDepositoMenorMostrado.current = true;

      let dias = null;
      let devido = true;

      try {

        const pref = await axios.get("/api/perfil/preferencias");

        dias = pref.data.lembrete_deposito_dias || null;

        const visto = pref.data.lembrete_deposito_visto_em;

        if (visto) {
          const decorrido =
            Date.now() -
            new Date(String(visto).replace(" ", "T")).getTime();
          devido = decorrido >= (dias || 1) * 24 * 60 * 60 * 1000;
        }

      } catch (err) {
        // Sem as preferências o lembrete aparece normalmente
        console.log(err);
      }

      if (devido) {
        setLembreteDeposito({
          itens: aMenor.slice(0, 6),
          total: aMenor.length,
          dias,
        });
      }

    }

    // A lista de comprovantes usa o mesmo período, sem o filtro de situação
    const comprovantes = await axios.get(
      "/api/conciliacao/comprovantes?" +
        paramsConciliacao({ situacao: "" })
    );

    setListaComprovantes(comprovantes.data);

    // Recebimentos que podem ser vinculados a um comprovante
    const recebimentos = await axios.get(
      "/api/conciliacao/recebimentos?" +
        paramsConciliacao({ situacao: "" })
    );

    setRecebimentosConc(recebimentos.data);

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível carregar a conciliação."
    );

  } finally {

    setCarregandoConc(false);

  }

};

/* Abre o detalhe de um dia (recebimentos e comprovantes daquela linha) */
const abrirDetalheConciliacao = async (linha) => {

  try {

    const p = new URLSearchParams({ data: linha.data });
    if (linha.agente_id) p.append("agente_id", linha.agente_id);
    if (linha.banco_id) p.append("banco_id", linha.banco_id);

    const resposta = await axios.get(
      "/api/conciliacao/detalhe?" + p.toString()
    );

    setDetalheConc({ linha, ...resposta.data });

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível carregar o detalhe do dia."
    );

  }

};

/*
  Lê o arquivo escolhido e preenche nº do documento, valor e data
  automaticamente (camada de texto do PDF ou OCR no servidor).
  Os campos continuam editáveis — a leitura é só uma sugestão.
*/
const aoEscolherArquivoComprovante = async (arquivo) => {

  setArquivoComprovante(arquivo);
  setDadosExtraidos(null);

  if (!arquivo) return;

  setExtraindoComprovante(true);

  try {

    const dados = new FormData();
    dados.append("arquivo", arquivo);

    const resposta = await axios.post(
      "/api/conciliacao/comprovantes/extrair",
      dados
    );

    const lido = resposta.data || {};

    setNovoComprovante((atual) => ({
      ...atual,
      valor: lido.valor || atual.valor,
      numero_documento: lido.numero_documento || atual.numero_documento,
      data_deposito: lido.data_deposito || atual.data_deposito,
    }));

    setDadosExtraidos(lido);

  } catch (err) {

    const recusa = err.response?.status === 400
      ? err.response?.data?.erro
      : null;

    if (recusa) {

      // Arquivo recusado (PDF com senha ou Boletim Diário de
      // Arrecadação): o campo volta a ficar vazio, para não lançar
      // o depósito com um anexo que não serve.
      setArquivoComprovante(null);
      if (inputArquivoComprovanteRef.current) {
        inputArquivoComprovanteRef.current.value = "";
      }
      mostrarAlerta(recusa);

    } else {

      // Sem leitura automática o usuário só preenche na mão
      setDadosExtraidos({ falhou: true });

    }

  } finally {

    setExtraindoComprovante(false);

  }

};

/* Salva o depósito e abre o vínculo com os recebimentos */
const salvarComprovante = async () => {

  if (!arquivoComprovante) {
    return mostrarAlerta(
      "Anexe o arquivo do comprovante para lançar o depósito."
    );
  }

  if (!novoComprovante.data_deposito) {
    return mostrarAlerta("Informe a data do depósito.");
  }

  if (!novoComprovante.valor) {
    return mostrarAlerta("Informe o valor do depósito.");
  }

  setSalvandoComprovante(true);

  try {

    const dados = new FormData();

    Object.entries(novoComprovante).forEach(([campo, valor]) => {
      dados.append(campo, valor ?? "");
    });

    if (arquivoComprovante) {
      dados.append("arquivo", arquivoComprovante);
    }

    const resposta = await axios.post(
      "/api/conciliacao/comprovantes",
      dados
    );

    setNovoComprovante(comprovanteVazio);
    setArquivoComprovante(null);
    setDadosExtraidos(null);

    await carregarConciliacao();

    // Depósito registrado: agora o usuário escolhe quais
    // recebimentos ele cobre.
    setVinculando({
      comprovante_id: resposta.data.id,
      valor_total: paraNumeroBR(novoComprovante.valor),
      saldo: Number(resposta.data.saldo_nao_alocado || 0),
      agente_id: null,
      banco_id: null,
      valores: {},
    });

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível salvar o comprovante."
    );

  } finally {

    setSalvandoComprovante(false);

  }

};

/* Converte "1.234,56" em número */
const paraNumeroBR = (v) => {
  const t = String(v || "").trim();
  const normalizado = t.includes(",")
    ? t.replace(/\./g, "").replace(",", ".")
    : t;
  const n = Number(normalizado);
  return Number.isFinite(n) ? n : 0;
};

/* Abre o vínculo para um comprovante já lançado que ainda tem saldo */
const abrirVinculoComprovante = (c) => {
  setVinculando({
    comprovante_id: c.id,
    valor_total: Number(c.valor),
    saldo: Number(c.saldo_nao_alocado),
    agente_id: c.agente_id || null,
    banco_id: c.banco_id || null,
    valores: {},
  });
};

/* Vincula parte do saldo do depósito a um recebimento */
const vincularRecebimento = async (recebimento, valorTexto) => {

  if (!vinculando) return;

  const valor = paraNumeroBR(valorTexto);

  if (valor <= 0) {
    return mostrarAlerta("Informe um valor maior que zero.");
  }

  // Quanto do recebimento continuará descoberto depois deste vínculo:
  // se sobrar, o agente depositou a menor e o usuário precisa cobrar
  // a diferença.
  const faltaRestante =
    Math.round((Number(recebimento.valor_em_aberto) - valor) * 100) / 100;

  try {

    const resposta = await axios.post(
      `/api/conciliacao/comprovantes/${vinculando.comprovante_id}/vincular`,
      {
        recebimento_id: recebimento.id,
        valor,
      }
    );

    const saldo = Number(resposta.data.saldo_nao_alocado || 0);

    await carregarConciliacao();

    if (saldo <= 0) {

      setVinculando(null);

      await mostrarAlerta("Depósito totalmente distribuído.");

    } else {

      // O primeiro vínculo fixa o agente/banco do depósito
      setVinculando((atual) =>
        atual && {
          ...atual,
          saldo,
          agente_id: atual.agente_id || recebimento.agente_id,
          banco_id: atual.banco_id || recebimento.banco_id,
          valores: { ...atual.valores, [recebimento.id]: undefined },
        }
      );

    }

    // Depósito a menor: lembra o usuário de cobrar do agente os
    // depósitos separados no dia seguinte.
    if (faltaRestante > 0.009) {

      mostrarAlerta(
        `O depósito de ${recebimento.agente_nome} cobriu só parte do ` +
          `arrecadado em ${formatarData(recebimento.data_recebimento)}: ` +
          `ainda faltam ${formatarBRL(faltaRestante)}. ` +
          `Solicite ao agente que, no dia seguinte, faça DOIS depósitos ` +
          `separados: um com a diferença que faltou ` +
          `(${formatarBRL(faltaRestante)}) e outro com o valor arrecadado ` +
          `do dia corrente. Depósitos separados facilitam a conciliação.`,
        "Depósito a menor — cobrar diferença"
      );

    }

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível vincular o recebimento."
    );

  }

};

const excluirComprovante = async (id) => {

  const confirmou = await mostrarConfirmacao(
    "Excluir este comprovante? A conciliação dos dias envolvidos será recalculada."
  );

  if (!confirmou) return;

  try {

    await axios.delete("/api/conciliacao/comprovantes/" + id);

    await carregarConciliacao();

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível excluir o comprovante."
    );

  }

};

/* Edita só o número do documento do comprovante já lançado */
const editarDocumentoComprovante = async (c) => {

  const novoNumero = await mostrarPrompt(
    "Número do documento:",
    c.numero_documento || ""
  );

  if (novoNumero === null) return;

  try {

    await axios.put(
      `/api/conciliacao/comprovantes/${c.id}/documento`,
      { numero_documento: novoNumero }
    );

    await carregarConciliacao();

    mostrarAlerta("Documento atualizado");

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível atualizar o documento."
    );

  }

};

/* Anexa o arquivo em um comprovante lançado sem anexo */
const anexarArquivoComprovante = async (arquivo) => {

  if (!arquivo || !comprovanteAnexo) return;

  const confirmar = await mostrarConfirmacao(
    `Anexar "${arquivo.name}" ao depósito de ` +
      `${formatarBRL(comprovanteAnexo.valor)} em ` +
      `${formatarData(comprovanteAnexo.data_deposito)} ` +
      `(${comprovanteAnexo.agente_nome || "-"})?`
  );

  if (!confirmar) {
    setComprovanteAnexo(null);
    return;
  }

  try {

    const dados = new FormData();

    dados.append("arquivo", arquivo);

    await axios.post(
      `/api/conciliacao/comprovantes/${comprovanteAnexo.id}/arquivo`,
      dados
    );

    await carregarConciliacao();

    mostrarAlerta(`Arquivo "${arquivo.name}" anexado.`);

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível anexar o arquivo."
    );

  } finally {

    setComprovanteAnexo(null);

  }

};

/*
  Baixa o PDF unificado dos comprovantes do período, respeitando os
  filtros de agente e banco aplicados na tela.
*/
const [gerandoPdfComprovantes, setGerandoPdfComprovantes] = useState(false);
// Caixa "Incluir os BDAs" do PDF unificado (pedido do SAAE, 16/10/2026)
const [pdfComBdas, setPdfComBdas] = useState(true);

/* visualizar=true (pedido do SAAE, 15/10/2026): abre a prévia do PDF
   unificado numa nova aba em vez de baixar. A aba é aberta antes da
   requisição para o navegador não bloquear como pop-up. */
const baixarPdfComprovantes = async (visualizar = false) => {

  const janela = visualizar ? window.open("", "_blank") : null;

  setGerandoPdfComprovantes(true);

  try {

    const resposta = await axios.get(
      "/api/conciliacao/comprovantes/pdf?" + paramsConciliacao() +
        "&bdas=" + (pdfComBdas ? "1" : "0"),
      { responseType: "blob" }
    );

    const url = URL.createObjectURL(
      new Blob([resposta.data], { type: "application/pdf" })
    );

    if (janela) {

      janela.location.href = url;

    } else {

      const link = document.createElement("a");
      link.href = url;
      link.download =
        `comprovantes_${filtroConc.inicio}_a_${filtroConc.fim}.pdf`;
      link.click();

    }

    setTimeout(() => URL.revokeObjectURL(url), 60000);

  } catch (err) {

    if (janela) janela.close();

    // A resposta de erro vem como blob; tenta ler a mensagem real
    let mensagem = "Não foi possível gerar o PDF dos comprovantes.";

    try {
      const texto = await err.response?.data?.text?.();
      const json = texto ? JSON.parse(texto) : null;
      if (json?.erro) mensagem = json.erro;
    } catch (e) { /* mantém a mensagem genérica */ }

    mostrarAlerta(mensagem);

  } finally {

    setGerandoPdfComprovantes(false);

  }

};

/* Abre o arquivo anexado em uma nova aba, levando o token da sessão */
const abrirArquivoComprovante = async (id) => {

  try {

    const resposta = await axios.get(
      `/api/conciliacao/comprovantes/${id}/arquivo`,
      { responseType: "blob" }
    );

    const url = URL.createObjectURL(resposta.data);

    window.open(url, "_blank");

    // Libera a memória depois que o navegador abriu o arquivo
    setTimeout(() => URL.revokeObjectURL(url), 60000);

  } catch (err) {

    mostrarAlerta("Não foi possível abrir o arquivo do comprovante.");

  }

};

/* Anexa o espelho (PDF) a um recebimento salvo antes do espelho existir.
   O backend renomeia para aaaa-mm-dd_NOME DO AGENTE.pdf e só aceita
   se o recebimento ainda não tiver arquivo. */
const anexarEspelhoRecebimento = async (arquivo) => {

  if (!arquivo || !recebimentoAnexo) return;

  const confirmar = await mostrarConfirmacao(
    `Anexar "${arquivo.name}" como espelho do recebimento ` +
      `#${recebimentoAnexo.id} de ` +
      `${formatarData(recebimentoAnexo.data_recebimento)} ` +
      `(${recebimentoAnexo.agente_nome || "-"})?`
  );

  if (!confirmar) {
    setRecebimentoAnexo(null);
    return;
  }

  try {

    const formData = new FormData();

    formData.append("pdf", arquivo);

    const resposta = await axios.post(
      `/api/recebimentos/${recebimentoAnexo.id}/arquivo`,
      formData
    );

    await carregarRecebimentos();

    mostrarAlerta(
      `Espelho anexado como "${resposta.data.arquivo_nome}".`
    );

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível anexar o espelho."
    );

  } finally {

    setRecebimentoAnexo(null);

  }

};

/* Abre o espelho (PDF) do recebimento em uma nova aba, levando o token */
const abrirEspelhoRecebimento = async (id) => {

  try {

    const resposta = await axios.get(
      `/api/recebimentos/${id}/arquivo`,
      { responseType: "blob" }
    );

    const url = URL.createObjectURL(resposta.data);

    window.open(url, "_blank");

    // Libera a memória depois que o navegador abriu o arquivo
    setTimeout(() => URL.revokeObjectURL(url), 60000);

  } catch (err) {

    mostrarAlerta("Não foi possível abrir o espelho em PDF deste recebimento.");

  }

};

/* Envia o remanejamento da sobra para outra data ou outro recebimento */
const confirmarRemanejamento = async () => {

  if (!remanejando) return;

  const {
    comprovante,
    modo,
    data_origem,
    data_destino,
    recebimento_destino_id,
    valor,
  } = remanejando;

  const paraRecebimento = modo === "recebimento";

  if (paraRecebimento && !recebimento_destino_id) {
    return mostrarAlerta(
      "Escolha o recebimento que vai receber o valor."
    );
  }

  if (!paraRecebimento && !data_destino) {
    return mostrarAlerta("Informe a data em que a sobra será abatida.");
  }

  try {

    await axios.post(
      `/api/conciliacao/comprovantes/${comprovante.id}/remanejar`,
      paraRecebimento
        ? { data_origem, recebimento_destino_id, valor }
        : { data_origem, data_destino, valor }
    );

    setRemanejando(null);

    await carregarConciliacao();

    mostrarAlerta(
      paraRecebimento
        ? "Comprovante remanejado para o recebimento escolhido."
        : "Sobra remanejada com sucesso."
    );

  } catch (err) {

    mostrarAlerta(
      err.response?.data?.erro ||
        "Não foi possível remanejar a sobra."
    );

  }

};

useEffect(() => {

  setTotalReceitas(somarValores(receitas));

}, [receitas]);


const carregarDados = async () => {

  try {

    const agentes = await axios.get(
      "/api/agentes"
    );

    setListaAgentes(agentes.data);

    const bancos = await axios.get(
      "/api/bancos"
    );

    setListaBancos(bancos.data);

    const agencias = await axios.get(
      "/api/agencias"
    );

    setListaAgencias(agencias.data);

    const receitasResponse = await axios.get(
  "/api/receitas"
);

setListaReceitas(receitasResponse.data);
const relBancos = await axios.get(
  "/api/relacionamentos/bancos"
);

setListaRelacionamentosBancos(
  relBancos.data

);
await carregarFontesRecurso();

const relAgentes = await axios.get(
  "/api/relacionamentos/agentes"
);

setListaRelacionamentosAgentes(
  relAgentes.data
);

  } catch (err) {

    console.log(err);

  }

};

/* Carrega todas as listas do módulo de Fontes de Recurso */
const carregarFontesRecurso = async () => {

  try {

    const [exercicios, recursos, vinculos, receitas] =
      await Promise.all([
        axios.get("/api/fontes/exercicios"),
        axios.get("/api/fontes/recursos"),
        axios.get("/api/fontes/vinculos"),
        axios.get("/api/fontes/receitas")
      ]);

    setListaExercicios(exercicios.data);
    setListaFontesRecurso(recursos.data);
    setListaVinculosFonte(vinculos.data);
    setListaReceitaVinculos(receitas.data);

  } catch (err) {

    console.log(err);

  }

};

/* ---- Etapa 1: Exercício ---- */
const salvarExercicio = async () => {
  if (!novoExercicio) return;
  try {
    await axios.post("/api/fontes/exercicios", { ano: novoExercicio });
    setNovoExercicio("");
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao salvar exercício");
  }
};

const excluirExercicio = async (id) => {
  if (!(await mostrarConfirmacao("Excluir este exercício?"))) return;
  try {
    await axios.delete(`/api/fontes/exercicios/${id}`);
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao excluir");
  }
};

/* ---- Etapa 2: Fonte de recurso ---- */
const salvarFonteRecurso = async () => {
  if (!novaFonteCodigo) return;
  try {
    await axios.post("/api/fontes/recursos", {
      codigo: novaFonteCodigo,
      descricao: novaFonteDescricao
    });
    setNovaFonteCodigo("");
    setNovaFonteDescricao("");
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao salvar fonte");
  }
};

const excluirFonteRecurso = async (id) => {
  if (!(await mostrarConfirmacao("Excluir esta fonte de recurso?"))) return;
  try {
    await axios.delete(`/api/fontes/recursos/${id}`);
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao excluir");
  }
};

/* ---- Etapa 3: Vínculo fonte x exercício ---- */
const salvarVinculoFonte = async () => {
  if (!vinculoFonte || !vinculoExercicio) {
    mostrarAlerta("Selecione a fonte e o exercício");
    return;
  }
  try {
    await axios.post("/api/fontes/vinculos", {
      fonte_id: vinculoFonte,
      exercicio_id: vinculoExercicio
    });
    setVinculoFonte("");
    setVinculoExercicio("");
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao vincular");
  }
};

const excluirVinculoFonte = async (id) => {
  if (!(await mostrarConfirmacao("Excluir este vínculo?"))) return;
  try {
    await axios.delete(`/api/fontes/vinculos/${id}`);
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao excluir");
  }
};

/* ---- Etapa 4: Vínculo receita x (exercício/fonte) ---- */
const salvarVinculoReceita = async () => {
  if (!vinculoReceita || !vinculoFonteExercicio) {
    mostrarAlerta("Selecione a receita e o vínculo exercício/fonte");
    return;
  }
  try {
    await axios.post("/api/fontes/receitas", {
      receita_id: vinculoReceita,
      fonte_exercicio_id: vinculoFonteExercicio
    });
    setVinculoReceita("");
    setVinculoFonteExercicio("");
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao vincular");
  }
};

const excluirVinculoReceita = async (id) => {
  if (!(await mostrarConfirmacao("Excluir este vínculo?"))) return;
  try {
    await axios.delete(`/api/fontes/receitas/${id}`);
    carregarFontesRecurso();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao excluir");
  }
};

const carregarDeParaSiafic =
  async () => {

    try {

      const res = await axios.get(
        "/api/configuracao-depara"
      );

      setDeParaSiafic(res.data);

    } catch (err) {

      console.log(err);

    }

  };
const salvarDeParaSiafic =
  async () => {

    try {

      await axios.post(
        "/api/configuracao-depara",
        deParaSiafic
      );

      mostrarAlerta(
        "Configuração salva com sucesso"
      );

    } catch (err) {

      console.log(err);

      mostrarAlerta("Erro ao salvar");

    }

  };
const carregarRelacionamentosAgentes =
  async () => {

    try {

      const res = await axios.get(
        "/api/relacionamentos/agentes"
      );

      setListaRelacionamentosAgentes(
        res.data
      );

    } catch (err) {

      console.log(err);

    }

  };
// Recebimentos Salvos com a pesquisa aplicada. Valor: o digitado em reais
// ("13.567,71" ou "13567.71") bate com o valor exato; um pedaço ("13.567")
// procura no valor formatado.
// Status como aparece na tabela: o PENDENTE que veio de um estorno (lote
// -R*) é ESTORNADO até o reenvio
const statusExibido = (r) =>
  r.status_siafic === "PENDENTE" && /-R\d+$/.test(String(r.chave_lote || ""))
    ? "ESTORNADO"
    : r.status_siafic;

const recebimentosFiltrados = () => {
  const f = filtroReceb;
  const alvoValor = f.valor.trim();
  return listaRecebimentos.filter((r) => {
    const data = String(r.data_recebimento || "").slice(0, 10);
    if (f.mes && data.slice(0, 7) !== f.mes) return false;
    if (f.data && data !== f.data) return false;
    if (f.agente && r.agente_nome !== f.agente) return false;
    if (f.banco && r.banco_nome !== f.banco) return false;
    if (f.status && statusExibido(r) !== f.status) return false;
    if (alvoValor) {
      const exato = Math.abs(valorParaNumero(alvoValor) - valorParaNumero(r.valor)) < 0.005;
      const pedaco = formatarBRL(valorParaNumero(r.valor)).includes(alvoValor);
      if (!exato && !pedaco) return false;
    }
    return true;
  });
};

const carregarRecebimentos = async () => {

  try {

    const response = await axios.get(
      "/api/recebimentos"
    );

    setListaRecebimentos(response.data);

    // Envios estornados (pedido do SAAE, 15/10/2026)
    axios.get("/api/estornos-siafic")
      .then((e) => setListaEstornos(Array.isArray(e.data) ? e.data : []))
      .catch(() => setListaEstornos([]));
    // o alerta dos estornados some assim que o recebimento e reenviado/excluido
    carregarEstornadosPendentes();

  } catch (err) {

    console.log(err);

  }

}
   
      
  const handleFiltro = (e) => {
    const { name, value } = e.target;
    // mudar a data à mão vira "período personalizado"
    const extra = name === "dataInicio" || name === "dataFim" ? { mes: "" } : {};
    setFiltros({
      ...filtros,
      ...extra,
      [name]: value
    });
  };

  // escolher o mês preenche o período e já aplica
  const escolherMes = (e) => {
    const mes = e.target.value;
    const novo = mes
      ? { ...filtros, mes, ...periodoDoMes(mes) }
      : { ...filtros, mes: "", dataInicio: "", dataFim: "" };
    setFiltros(novo);
    carregarDashboard(novo);
  };

  const adicionarReceita = () => {
    if (!novaReceita.codigo || !novaReceita.valor) return;

    setReceitas([...receitas, novaReceita]);

    setNovaReceita({
      codigo: "",
      descricao: "",
      valor: ""
    });
  };

  const removerReceita = (index) => {
    const lista = [...receitas];
    lista.splice(index, 1);
    setReceitas(lista);
  };

 
  const limparFormAgente = () => {
    setAgente("");
    setCodigoAgente("");
    setAgenteBanco("");
    setAgenteAgencia("");
    setCodigoBanco("");
    setAgenteEditando(null);
  };

  const salvarAgente = async () => {
    if (!agente || !codigoAgente) {
      mostrarAlerta("Informe o nome e o código do agente");
      return;
    }
    try {
      const dados = {
        nome: agente,
        codigo: codigoAgente,
        banco_id: agenteBanco,
        agencia_id: agenteAgencia
      };

      if (agenteEditando) {
        await axios.put(`/api/agentes/${agenteEditando}`, dados);
      } else {
        await axios.post("/api/agentes", dados);
      }

      carregarDados();

      mostrarAlerta(agenteEditando ? "Agente atualizado" : "Agente salvo");
      limparFormAgente();
    } catch {
      mostrarAlerta("Erro ao salvar agente");
    }
  };

  const salvarBanco = async () => {
    try {
      await axios.post("/api/bancos", {
  nome: banco,
  codigo: codigoBanco
});

      carregarDados();

      mostrarAlerta("Banco salvo");
      setBanco("");
    } catch {
      mostrarAlerta("Erro ao salvar banco");
    }
  };

 const salvarAgencia = async () => {

  try {

    await axios.post(
      "/api/agencias",
      {
        banco_id: agenciaBanco,
        codigo: numeroAgencia,
        nome: nomeAgencia || null
      }
    );

    carregarDados();

    mostrarAlerta("Agência salva");

    setNumeroAgencia("");
    setNomeAgencia("");
    setAgenciaBanco("");

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao salvar agência");

  }

};

  const salvarCodigoReceita = async () => {
    try {
      await axios.post("/api/receitas", {
        codigo: codigoReceita,
        descricao: descricaoReceita
      });

      carregarDados();

      mostrarAlerta("Receita salva");

      setCodigoReceita("");
      setDescricaoReceita("");
    } catch {
      mostrarAlerta("Erro ao salvar receita");
    }
  };

 const excluirItem = async (rota, id) => {

  try {

    await axios.delete(
      `/api/${rota}/${id}`
    );

    carregarDados();

    mostrarAlerta("Excluído com sucesso");

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao excluir");

  }

};

const editarItem = async (rota, item) => {

  const novoNome = await mostrarPrompt(
    "Editar nome:",
    item.nome || item.descricao
  );

  if (novoNome === null) return;

  const novoCodigo = (await mostrarPrompt(
    "Editar código:",
    item.codigo || ""
  ))?.trim();

  if (novoCodigo === null) return;

  let dados = {};

  if (rota === "bancos") {

    dados = {
      nome: novoNome,
      codigo: novoCodigo
    };

  }

  else if (rota === "agentes") {

    dados = {
      nome: novoNome,
      codigo: novoCodigo,
      banco_id: item.banco_id,
      agencia_id: item.agencia_id
    };

  }

  else if (rota === "receitas") {

    dados = {
      descricao: novoNome,
      codigo: novoCodigo
    };

  }

  else if (rota === "agencias") {

    dados = {
      nome: novoNome,
      codigo: novoCodigo,
      banco_id: item.banco_id
    };

  }

  try {
console.log({
  rota,
  id: item.id,
  nome: novoNome,
  codigo: novoCodigo,
  dados
});
    await axios.put(
      `/api/${rota}/${item.id}`,
      dados
    );

    carregarDados();

    mostrarAlerta("Atualizado");

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao editar");

  }

};


  const processarPDF = async () => {

  if (!pdf) {
    mostrarAlerta("Selecione um PDF");
    return;
  }

  // Já existe um processamento não salvo: reprocessar apaga os
  // ajustes feitos na tela. O caminho certo é Salvar Recebimento.
  if (receitas.length > 0) {

    const confirmar = await mostrarConfirmacao(
      "Este PDF já foi processado. Se você só precisa corrigir " +
      "alguma informação, ajuste na tela e clique em Salvar " +
      "Recebimento — não é necessário processar de novo. " +
      "Processar novamente descarta todas as alterações feitas. " +
      "Deseja processar mesmo assim?",
      "Processar novamente?"
    );

    if (!confirmar) return;

  }

  setReceitas([]);
  setPdfProcessado(false);
  setProcessandoPdf(true);

  try {

    const formData = new FormData();

    formData.append("pdf", pdf);

    const response = await axios.post(
      "/api/upload",
      formData
    );

    if (response.data.receitas) {

      const receitasFormatadas =
response.data.receitas.map((r) => {

  console.log("VALOR PDF:", r.valor);

  return {

    ...r,

    valor: String(r.valor || "")
      .replace("R$", "")
      .trim()

  };

});

      console.log("RECEITAS FORMATADAS:",
     receitasFormatadas);

    setReceitas([...receitasFormatadas]);
    setTimeout(() => {

  console.log("STATE RECEITAS:", receitas);

}, 1000);

    }

    if (response.data.dataRecebimento) {

      const partes =
        response.data.dataRecebimento.split("/");

      setDataRecebimento(
        `${partes[2]}-${partes[1]}-${partes[0]}`
      );

    }

    // seleciona o agente arrecadador comparando o nome do banco
    // do PDF com os nomes dos agentes (ignorando acentos e
    // palavras genéricas): "ITAÚ UNIBANCO S.A." -> "AGENTE ITAÚ"
    let agentePdf = null;

    if (response.data.nomeBanco) {

      const GENERICAS =
        ["AGENTE", "BANCO", "DO", "DA", "DE", "S", "A", "SA"];

      const palavras = (texto) =>
        String(texto || "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toUpperCase()
          .split(/[^A-Z0-9]+/)
          .filter((p) => p && !GENERICAS.includes(p));

      const doPdf = palavras(response.data.nomeBanco);

      let melhor = null;
      let melhorPontos = 0;
      let empate = false;

      for (const a of listaAgentes) {

        const pontos = palavras(a.nome).filter(
          (p) => doPdf.includes(p)
        ).length;

        if (pontos > melhorPontos) {
          melhor = a;
          melhorPontos = pontos;
          empate = false;
        } else if (pontos === melhorPontos && pontos > 0) {
          empate = true;
        }

      }

      // só preenche quando um único agente combina melhor
      if (melhor && !empate) {
        agentePdf = melhor;
        setAgente(melhor.id);
      }

    }

    // Banco: vale o vínculo do cadastro do agente (ex.: o AGENTE
    // BRADESCO deposita na conta do Banco do Brasil). O banco do
    // cabeçalho do PDF só entra se o agente não tiver vínculo.
    if (agentePdf?.banco_id) {

      setBanco(agentePdf.banco_id);

    } else if (response.data.codigoBanco) {

      const bancoPdf = listaBancos.find(
        (b) =>
          Number(b.codigo) ===
          Number(response.data.codigoBanco)
      );

      if (bancoPdf) {
        setBanco(bancoPdf.id);
      }

    }

    setPdfProcessado(true);

    mostrarAlerta("PDF processado");

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao processar PDF");

  } finally {

    setProcessandoPdf(false);

  }

};

const salvarRecebimento = async () => {

  if (!agente || !banco) {

    mostrarAlerta("Selecione agente e banco");

    return;

  }

  setSalvandoRecebimento(true);

  try {

    // FormData para levar o espelho (PDF) junto com os dados;
    // o backend o salva renomeado para aaaa-mm-dd.pdf
    const formData = new FormData();

    formData.append("agente_id", agente);
    formData.append("banco_id", banco);
    formData.append("data_recebimento", dataRecebimento);
    formData.append("receitas", JSON.stringify(receitas));

    if (pdf) {
      formData.append("pdf", pdf);
    }

    await axios.post(
      "/api/recebimentos",
      formData
    );

  // limpa a tela para o próximo PDF
  setPdf(null);
  setReceitas([]);
  setPdfProcessado(false);
  setAgente("");
  setBanco("");
  setDataRecebimento("");

  if (inputPdfRef.current) {
    inputPdfRef.current.value = "";
  }

  await carregarRecebimentos();

  setTela("envios");

    mostrarAlerta("Recebimento salvo");

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao salvar");

  } finally {

    setSalvandoRecebimento(false);

  }

};

const salvarConfiguracao = async () => {

  try {

    await axios.post(
      "/api/config",
      {
        url: configSiafic.url,
        token: configSiafic.token,
        codigoOrgao: configSiafic.codigoOrgao,
        nomeOrgao: configSiafic.nomeOrgao,
        ambiente: configSiafic.ambiente,
        emailsNotificacao: configSiafic.emailsNotificacao,
        avisosAtivos: configSiafic.avisosAtivos,
        // guarda o objeto completo de configuração (mapeamentos,
        // regras, campos DE-PARA, etc.) no campo JSON de_para
        dePara: configSiafic
      }
    );

    mostrarAlerta("Configuração salva com sucesso");

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao salvar configuração");

  }

};

const carregarConfig = async () => {

  try {

    const res = await axios.get("/api/config");

    const dados = res.data || {};

    // de_para guarda o objeto configSiafic completo em JSON
    let salvo = {};

    if (dados.de_para) {
      salvo =
        typeof dados.de_para === "string"
          ? JSON.parse(dados.de_para)
          : dados.de_para;
    }

    // se de_para vier como array (formato antigo), ignora
    if (Array.isArray(salvo)) salvo = {};

    setConfigSiafic((prev) => ({
      ...prev,
      ...salvo,
      // colunas dedicadas prevalecem quando preenchidas
      url: dados.url ?? salvo.url ?? prev.url,
      token: dados.token ?? salvo.token ?? prev.token,
      codigoOrgao:
        dados.codigo_orgao ?? salvo.codigoOrgao ?? prev.codigoOrgao,
      nomeOrgao:
        dados.nome_orgao ?? salvo.nomeOrgao ?? prev.nomeOrgao,
      ambiente:
        dados.ambiente ?? salvo.ambiente ?? prev.ambiente,
      emailsNotificacao:
        dados.emails_notificacao ??
        salvo.emailsNotificacao ??
        prev.emailsNotificacao,
      avisosAtivos:
        dados.avisos_ativos != null
          ? !!Number(dados.avisos_ativos)
          : salvo.avisosAtivos ?? prev.avisosAtivos
    }));

  } catch (err) {

    console.log(err);

  }

};

/* ========= SEQUÊNCIA DA CHAVE ÚNICA ========= */
const carregarProximoChave = async () => {
  try {
    const res = await axios.get("/api/recebimentos/sequencia-chave");
    setProximoChave(String(res.data.proximo ?? ""));
  } catch (err) {
    console.log(err);
  }
};

const salvarProximoChave = async () => {
  const n = parseInt(proximoChave, 10);
  if (!n || n < 1) {
    mostrarAlerta("Informe um número válido (maior que zero)");
    return;
  }
  try {
    await axios.post("/api/recebimentos/sequencia-chave", { proximo: n });
    mostrarAlerta("Número inicial da chave única salvo com sucesso");
    carregarProximoChave();
  } catch (err) {
    mostrarAlerta(err.response?.data?.erro || "Erro ao salvar");
  }
};

const editarAgente = (item) => {

  // Preenche o formulário de cadastro em modo edição,
  // permitindo informar banco e o código da agência pelos dropdowns.
  setAgenteEditando(item.id);
  setAgente(item.nome || "");
  setCodigoAgente(item.codigo || "");
  setAgenteBanco(item.banco_id || "");
  setAgenteAgencia(item.agencia_id || "");
  setCodigoBanco(item.banco_codigo || "");

  // leva o usuário para a tela/formulário de agentes
  setTela("agentes");

};

const editarRelacionamento = (r) => {

  setRelAgente(r.agente_id || "");

  setRelCredor(
    r.codigo_credor_siafic || ""
  );

};

const excluirRelacionamento = async (id) => {

  const confirmar =
    await mostrarConfirmacao(
      "Excluir relacionamento?"
    );

  if (!confirmar) return;

  try {

    await axios.delete(
      `/api/relacionamentos/agentes/${id}`
    );

    carregarRelacionamentosAgentes();

  } catch (err) {

    console.log(err);

    mostrarAlerta("Erro ao excluir");

  }

};

  /* Portão de autenticação: sem login, mostra a tela de acesso */
  if (!logado) {
    return <Login onLogin={() => setLogado(true)} />;
  }

  return (
    <div className="shell">

      {menuAberto && (
        <div
          className="shell__overlay"
          onClick={() => setMenuAberto(false)}
        />
      )}

      <aside className={"sidebar" + (menuAberto ? " sidebar--aberto" : "")}>

        <div className="sidebar__brand">
          <div className="sidebar__logo">IR</div>
          <div className="sidebar__brand-txt">
            <h1>IntegraReceitas</h1>
            <p>Integração SIAFIC</p>
          </div>
        </div>

        <nav className="sidebar__nav">
          {MENU.map((secao) => {
            const itens = secao.itens.filter((i) =>
              i.roles.includes(usuario.tipo)
            );
            if (itens.length === 0) return null;
            return (
              <div className="sidebar__grupo" key={secao.titulo}>
                <span className="sidebar__grupo-titulo">
                  {secao.titulo}
                </span>
                {itens.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={
                      "sidebar__item" +
                      (tela === item.id ? " is-active" : "")
                    }
                    onClick={() => {
                      setTela(item.id);
                      setMenuAberto(false);
                    }}
                  >
                    <span className="sidebar__item-ic">
                      <Icone nome={item.icone} />
                    </span>
                    <span>{item.label}</span>
                  </button>
                ))}
              </div>
            );
          })}
          {/* Atalho para o IntegraSAAE, para alternar entre os sistemas sem
              digitar o endereco (pedido do SAAE, 22/10/2026) */}
          <div className="sidebar__grupo">
            <span className="sidebar__grupo-titulo">Outros sistemas</span>
            <a
              className="sidebar__item"
              style={{ textDecoration: "none" }}
              href="https://contabil.saaevalenca.ba.gov.br"
              target="_blank"
              rel="noopener noreferrer"
              title="Abre o IntegraSAAE numa aba nova"
            >
              <span className="sidebar__item-ic">
                <Icone nome="outroSistema" />
              </span>
              <span>IntegraSAAE</span>
            </a>
          </div>
        </nav>

        <div className="sidebar__rodape">
          <button
            type="button"
            className="sidebar__user"
            onClick={irParaPerfil}
            title="Meu perfil"
          >
            <AvatarUsuario usuario={usuario} className="sidebar__avatar" />
            <div className="sidebar__user-info">
              <strong>{usuario.nome || "Usuário"}</strong>
              <small>{usuario.email || ""}</small>
            </div>
          </button>
          <button type="button" className="btn-sair" onClick={sair}>
            Sair
          </button>
        </div>

      </aside>

      <div className="main">

        <header className="topbar">
          <button
            type="button"
            className="topbar__menu"
            onClick={() => setMenuAberto((v) => !v)}
            aria-label="Abrir menu"
          >
            <span /><span /><span />
          </button>

          <h2 className="topbar__titulo">
            {TITULOS[tela] || "Painel"}
          </h2>

          {DESCRICAO_TELAS[tela] && (
            <button
              type="button"
              title="O que é esta tela?"
              aria-label="O que é esta tela?"
              style={{
                background: "none",
                border: "none",
                lineHeight: 1,
                padding: "2px 6px",
                color: "#94a3b8",
                display: "inline-flex",
                alignItems: "center",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = "#475569")}
              onMouseLeave={(e) => (e.currentTarget.style.color = "#94a3b8")}
              onClick={() =>
                mostrarAlerta(
                  DESCRICAO_TELAS[tela],
                  TITULOS[tela] || "Sobre esta tela"
                )
              }
            >
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none"
                stroke="currentColor" strokeWidth="1.8"
                strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="9" />
                <path d="M12 11v5" />
                <path d="M12 7.6h.01" />
              </svg>
            </button>
          )}

          <div className="topbar__spacer" />

          <button
            type="button"
            className="topbar__user"
            onClick={irParaPerfil}
            title="Meu perfil"
          >
            <span className="topbar__user-nome">
              {usuario.nome || "Usuário"}
            </span>
            <AvatarUsuario usuario={usuario} className="topbar__avatar" />
          </button>
        </header>

        <main className="content">

{/* =========================
   AVISOS DO SISTEMA
   Pendências operacionais visíveis em todas as telas até um
   administrador marcá-las como resolvidas.
========================= */}
{/* Estornados aguardando resolução (pedido do SAAE, 21/10/2026) */}
{estornadosPendentes.length > 0 && (
  <div className="card aviso-banner aviso-banner--estorno">

    <h3>
      <Icone nome="alerta" /> {estornadosPendentes.length === 1
        ? "1 recebimento estornado aguardando resolução"
        : `${estornadosPendentes.length} recebimentos estornados aguardando resolução`}
      {" — "}{formatarBRL(estornadosPendentes.reduce((acc, x) => acc + (Number(x.valor) || 0), 0))}
    </h3>

    {estornadosPendentes.map((x) => (
      <div key={x.id} className="aviso-item">
        <p>
          <strong>{formatarData(x.data_recebimento)} · {x.agente_nome || "—"} · {x.banco_nome || "—"} · {formatarBRL(x.valor)}</strong>
          {x.estornado_em && (
            <> — estornado em {formatarData(x.estornado_em)}
              {x.dias_estornado > 0 ? ` (há ${x.dias_estornado} dia${x.dias_estornado > 1 ? "s" : ""})` : " (hoje)"}
              {x.estornado_por ? ` por ${x.estornado_por}` : ""}</>
          )}
          {x.motivo && <><br />Motivo do estorno: {x.motivo}</>}
        </p>
      </div>
    ))}

    <p style={{ margin: "8px 0" }}>
      <strong>Como resolver:</strong> se o arquivo estava errado, inclua um
      {" "}<strong>novo recebimento</strong> com o arquivo correto e
      {" "}<strong>exclua este envio</strong>; se o arquivo está correto,
      {" "}<strong>reenvie ao SIAFIC</strong>.
    </p>

    <div className="aviso-rodape">
      <span className="aviso-meta">Este alerta continua aparecendo até o reenvio ou a exclusão.</span>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button className="btn" onClick={() => setTela("recebimentos")}>Incluir novo recebimento</button>
        <button className="btn" onClick={verEstornadosNoStatus}>Reenviar ou excluir (Status SIAFIC)</button>
      </div>
    </div>

  </div>
)}

{avisosSistema.length > 0 && (
  <div className="card aviso-banner">

    <h3>
      <Icone nome="alerta" /> Pendências do sistema
    </h3>

    {avisosSistema.map((a) => (

      <div key={a.id} className="aviso-item">

        <p>{a.texto}</p>

        <div className="aviso-rodape">

          <span className="aviso-meta">
            {formatarData(a.criado_em)}
            {a.criado_por ? ` · ${a.criado_por}` : ""}
          </span>

          {usuario?.tipo === "admin" && (
            <button
              className="btn"
              onClick={() => resolverAviso(a)}
            >
              Marcar como resolvido
            </button>
          )}

        </div>

      </div>

    ))}

  </div>
)}

{tela === "dashboard" && (
  <>

    {/* =========================
       FILTROS DO PAINEL
    ========================= */}

    <div className="card">

      <h3>Filtros</h3>

      <div className="grid">

        {/* filtro por mês (pedido do SAAE, 23/10/2026) — o mês vigente por padrão */}
        <select
          name="mes"
          value={filtros.mes}
          onChange={escolherMes}
          title="Mês — preenche o período do 1º ao último dia"
        >
          <option value="">
            {filtros.dataInicio || filtros.dataFim ? "Período personalizado" : "Todos os meses"}
          </option>
          {opcoesMeses.map((o) => (
            <option key={o.valor} value={o.valor}>
              {o.rotulo}
            </option>
          ))}
        </select>

        <input
          type="date"
          name="dataInicio"
          value={filtros.dataInicio}
          onChange={handleFiltro}
        />

        <input
          type="date"
          name="dataFim"
          value={filtros.dataFim}
          onChange={handleFiltro}
        />

        <select
          name="agente"
          value={filtros.agente}
          onChange={handleFiltro}
        >
          <option value="">Todos os agentes</option>
          {listaAgentes.map((a) => (
            <option key={a.id} value={a.nome}>
              {a.nome}
            </option>
          ))}
        </select>

        <select
          name="banco"
          value={filtros.banco}
          onChange={handleFiltro}
        >
          <option value="">Todos os bancos</option>
          {listaBancos.map((b) => (
            <option key={b.id} value={b.nome}>
              {b.nome}
            </option>
          ))}
        </select>

        <select
          name="receita"
          value={filtros.receita}
          onChange={handleFiltro}
        >
          <option value="">Todas as receitas</option>
          {listaReceitas.map((r) => (
            <option key={r.id} value={r.codigo}>
              {r.codigo} - {r.descricao}
            </option>
          ))}
        </select>

        <button
          className="btn"
          onClick={() => carregarDashboard()}
        >
          Aplicar filtro
        </button>

        <button
          className="btn-delete"
          onClick={limparFiltros}
        >
          Limpar
        </button>

      </div>

    </div>

    <div className="stats-grid">
      <div className="stat">
        <div className="stat__ic stat__ic--blue">
          <Icone nome="recebimentos" />
        </div>
        <div>
          <div className="stat__val">{dashboard ? dashboard.total : "—"}</div>
          <div className="stat__lbl">Recebimentos</div>
        </div>
      </div>

      <div className="stat">
        <div className="stat__ic stat__ic--green">
          <Icone nome="envios" />
        </div>
        <div>
          <div className="stat__val">{dashboard ? dashboard.enviados : "—"}</div>
          <div className="stat__lbl">Integrados ao SIAFIC</div>
          {/* valor total dos integrados (pedido do SAAE, 23/10/2026) */}
          <div className="stat__sub">{formatarBRL(dashboard ? dashboard.valorEnviados : 0)}</div>
        </div>
      </div>

      <div className="stat">
        <div className="stat__ic stat__ic--amber">
          <Icone nome="relogio" />
        </div>
        <div>
          <div className="stat__val">{dashboard ? dashboard.pendentes : "—"}</div>
          <div className="stat__lbl">Pendentes</div>
          {/* valor total dos pendentes (pedido do SAAE, 21/10/2026) */}
          <div className="stat__sub">{formatarBRL(dashboard ? dashboard.valorPendentes : 0)}</div>
        </div>
      </div>

      {/* Estornados aguardando reenvio, com o valor total (pedido do SAAE,
          21/10/2026) — fora da contagem de Pendentes */}
      <div className="stat stat--clicavel" onClick={verEstornadosNoStatus} title="Ver os estornados no Status SIAFIC">
        <div className="stat__ic stat__ic--red">
          <Icone nome="alerta" />
        </div>
        <div>
          <div className="stat__val">{dashboard ? dashboard.estornados : "—"}</div>
          <div className="stat__lbl">Estornados</div>
          <div className="stat__sub">{formatarBRL(dashboard ? dashboard.valorEstornados : 0)}</div>
        </div>
      </div>

      <div className="stat">
        <div className="stat__ic stat__ic--red">
          <Icone nome="alerta" />
        </div>
        <div>
          <div className="stat__val">{dashboard ? dashboard.erros : "—"}</div>
          <div className="stat__lbl">Com erro</div>
        </div>
      </div>
    </div>

    <div className="card valor-destaque">
      <div>
        <div className="stat__lbl">Valor total arrecadado</div>
        <div className="valor-grande">
          {formatarBRL(dashboard ? dashboard.valorTotal : 0)}
        </div>
      </div>
      <div className="valor-cadastros">
        <span><strong>{dashboard ? dashboard.cadastros.agentes : 0}</strong> agentes</span>
        <span><strong>{dashboard ? dashboard.cadastros.bancos : 0}</strong> bancos</span>
        <span><strong>{dashboard ? dashboard.cadastros.receitas : 0}</strong> receitas</span>
      </div>
    </div>

    <div className="card">
      <div className="grafico-cabecalho">
        <h3>Percentual de arrecadação</h3>
        <div className="grafico-toggle">
          <button
            type="button"
            className={graficoPor === "agente" ? "ativo" : ""}
            onClick={() => setGraficoPor("agente")}
          >
            Por agente
          </button>
          <button
            type="button"
            className={graficoPor === "banco" ? "ativo" : ""}
            onClick={() => setGraficoPor("banco")}
          >
            Por banco
          </button>
          <button
            type="button"
            className={graficoPor === "receita" ? "ativo" : ""}
            onClick={() => setGraficoPor("receita")}
          >
            Por receita
          </button>
        </div>
      </div>
      <GraficoRosca
        dados={
          dashboard
            ? (graficoPor === "agente"
                ? dashboard.porAgente
                : graficoPor === "banco"
                ? dashboard.porBanco
                : dashboard.porReceita) || []
            : []
        }
      />
    </div>

    <div className="card">
      <div className="grafico-cabecalho">
        <h3>Evolução mensal da arrecadação</h3>
        <span className="grafico-nota">
          {filtros.dataInicio || filtros.dataFim
            ? "Período filtrado"
            : "Últimos 12 meses"}
        </span>
      </div>
      <GraficoColunas dados={dashboard ? dashboard.porMes || [] : []} />
    </div>

    <div className="card">
      <h3>Últimos recebimentos</h3>
      {dashboard && dashboard.recentes.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Agente</th>
              <th>Banco</th>
              <th>Valor</th>
              <th>Status</th>
              <th>Espelho</th>
            </tr>
          </thead>
          <tbody>
            {dashboard.recentes.map((r) => (
              <tr key={r.id}>
                <td>{formatarData(r.data_recebimento)}</td>
                <td>{r.agente_nome || "—"}</td>
                <td>{r.banco_nome || "—"}</td>
                <td>{formatarBRL(r.valor)}</td>
                <td>
                  <span className={"status status--" + String(r.status_siafic || "").toLowerCase()}>
                    {r.status_siafic}
                  </span>
                </td>
                <td>
                  {Number(r.tem_arquivo) ? (
                    <button
                      className="btn"
                      onClick={() => abrirEspelhoRecebimento(r.id)}
                    >
                      Ver PDF
                    </button>
                  ) : (
                    "—"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="texto-suave">Nenhum recebimento cadastrado ainda.</p>
      )}
    </div>
  </>
)}

{tela === "perfil" && (
  <>
    {perfilMsg && (
      <div
        className={
          "perfil-msg " +
          (perfilMsg.tipo === "ok" ? "perfil-msg--ok" : "perfil-msg--erro")
        }
      >
        {perfilMsg.texto}
      </div>
    )}

    <div className="card perfil-topo">
      <AvatarUsuario usuario={usuario} className="perfil-avatar" />
      <div className="perfil-info">
        <h3>{perfilNome || usuario.nome || "Usuário"}</h3>
        <p className="texto-suave">{perfilEmail || usuario.email || ""}</p>
        <span className="perfil-tipo">
          {LABEL_TIPO[usuario.tipo] || "Usuário"}
        </span>
      </div>
      <div className="perfil-foto-acoes">
        <label className="btn perfil-btn-foto">
          {usuario.foto ? "Trocar foto" : "Enviar foto"}
          <input
            type="file"
            accept="image/*"
            onChange={selecionarFoto}
            style={{ display: "none" }}
          />
        </label>
        {usuario.foto && (
          <button type="button" className="btn-delete" onClick={removerFoto}>
            Remover
          </button>
        )}
      </div>
    </div>

    <div className="card">
      <h3>Dados da conta</h3>
      <form className="perfil-form" onSubmit={salvarNome}>
        <div className="perfil-campo">
          <label>Nome</label>
          <input
            type="text"
            value={perfilNome}
            onChange={(e) => setPerfilNome(e.target.value)}
            placeholder="Seu nome"
            required
          />
        </div>
        <div className="perfil-campo">
          <label>E-mail de acesso (não pode ser alterado)</label>
          <input type="email" value={perfilEmail} disabled />
        </div>
        <div className="perfil-campo">
          <label>CPF de acesso (alterado pelo administrador em Usuários)</label>
          <input
            type="text"
            value={perfilCpf ? formatarCpf(perfilCpf) : "Não cadastrado"}
            disabled
          />
        </div>
        <button className="btn" type="submit" disabled={salvandoNome}>
          {salvandoNome ? "Salvando..." : "Salvar nome"}
        </button>
      </form>
    </div>

    <div className="card">
      <h3>Trocar senha</h3>
      <form className="perfil-form" onSubmit={trocarSenha}>
        <div className="perfil-campo">
          <label>Senha atual</label>
          <input
            type="password"
            value={perfilSenhaAtual}
            onChange={(e) => setPerfilSenhaAtual(e.target.value)}
            placeholder="Digite sua senha atual"
            required
          />
        </div>
        <div className="perfil-campo">
          <label>Nova senha</label>
          <input
            type="password"
            value={perfilNovaSenha}
            onChange={(e) => setPerfilNovaSenha(e.target.value)}
            placeholder="Mínimo de 6 caracteres"
            required
          />
        </div>
        <div className="perfil-campo">
          <label>Confirmar nova senha</label>
          <input
            type="password"
            value={perfilConfirmaSenha}
            onChange={(e) => setPerfilConfirmaSenha(e.target.value)}
            placeholder="Repita a nova senha"
            required
          />
        </div>
        <button className="btn" type="submit" disabled={salvandoSenha}>
          {salvandoSenha ? "Salvando..." : "Salvar nova senha"}
        </button>
      </form>
    </div>
  </>
)}

{tela === "usuarios" && usuario.tipo === "admin" && (
  <>
    <div className="card">
      <h3>{usuarioForm.id ? "Editar usuário" : "Novo usuário"}</h3>
      {usuarioMsg && (
        <div
          className={
            "perfil-msg " +
            (usuarioMsg.tipo === "ok" ? "perfil-msg--ok" : "perfil-msg--erro")
          }
        >
          {usuarioMsg.texto}
        </div>
      )}
      <form className="usuario-form" onSubmit={salvarUsuario}>
        <div className="usuario-foto">
          <AvatarUsuario
            usuario={{ nome: usuarioForm.nome, foto: usuarioForm.foto }}
            className="perfil-avatar"
          />
          <div className="perfil-foto-acoes">
            <label className="btn perfil-btn-foto">
              {usuarioForm.foto ? "Trocar foto" : "Enviar foto"}
              <input
                type="file"
                accept="image/*"
                onChange={selecionarFotoUsuario}
                style={{ display: "none" }}
              />
            </label>
            {usuarioForm.foto && (
              <button
                type="button"
                className="btn-delete"
                onClick={() => setUsuarioForm((f) => ({ ...f, foto: null }))}
              >
                Remover
              </button>
            )}
          </div>
        </div>

        <div className="grid">
          <input
            type="text"
            placeholder="Nome"
            value={usuarioForm.nome}
            onChange={(e) => setUsuarioForm({ ...usuarioForm, nome: e.target.value })}
            required
          />
          <input
            type="email"
            placeholder="E-mail"
            value={usuarioForm.email}
            onChange={(e) => setUsuarioForm({ ...usuarioForm, email: e.target.value })}
            disabled={!!usuarioForm.id}
            required
          />
          <input
            type="text"
            placeholder="CPF (login)"
            value={usuarioForm.cpf}
            onChange={(e) =>
              setUsuarioForm({ ...usuarioForm, cpf: formatarCpf(e.target.value) })
            }
          />
          <input
            type="password"
            placeholder={usuarioForm.id ? "Nova senha (opcional)" : "Senha"}
            value={usuarioForm.senha}
            onChange={(e) => setUsuarioForm({ ...usuarioForm, senha: e.target.value })}
            required={!usuarioForm.id}
          />
          <select
            value={usuarioForm.tipo}
            onChange={(e) => setUsuarioForm({ ...usuarioForm, tipo: e.target.value })}
          >
            <option value="operador">Operador</option>
            <option value="contabilidade">Contabilidade (operador + estornar envio)</option>
            <option value="gestor">Gestor de Relatórios</option>
            <option value="admin">Administrador</option>
          </select>
          <button className="btn" type="submit">
            {usuarioForm.id ? "Salvar alterações" : "Criar usuário"}
          </button>
          {usuarioForm.id && (
            <button type="button" className="btn-delete" onClick={novoUsuario}>
              Cancelar
            </button>
          )}
        </div>
      </form>
    </div>

    <div className="card">
      <h3>Usuários cadastrados</h3>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>E-mail</th>
            <th>CPF</th>
            <th>Perfil</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {listaUsuarios.map((u) => (
            <tr key={u.id}>
              <td>
                <div className="usuario-nome-cel">
                  <AvatarUsuario usuario={u} className="avatar-mini" />
                  <span>{u.nome}</span>
                </div>
              </td>
              <td>{u.email}</td>
              <td>{u.cpf ? formatarCpf(u.cpf) : <span className="texto-suave">—</span>}</td>
              <td>
                <span className={"perfil-badge perfil-badge--" + u.tipo}>
                  {LABEL_TIPO[u.tipo] || u.tipo}
                </span>
              </td>
              <td>
                <div className="acoes-linha">
                  <button className="btn" onClick={() => editarUsuario(u)}>
                    Editar
                  </button>
                  <button className="btn-delete" onClick={() => excluirUsuario(u.id)}>
                    Excluir
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </>
)}

{tela === "recebimentos" && (

<>

{/* =========================
   PASSO 1 — PDF DO AGENTE
   O dia começa aqui: o PDF preenche agente, banco,
   data e a lista de receitas do passo 2.
========================= */}

<div className="card">

  <div className="passo-head">

    <span
      className={
        "passo-num" + (pdfProcessado ? " passo-num--ok" : "")
      }
    >
      {pdfProcessado ? <Icone nome="sucesso" /> : "1"}
    </span>

    <div>
      <h3>Relatório de arrecadação (PDF)</h3>
      <p className="passo-sub">
        Carregue o PDF do agente arrecadador. O processamento
        preenche o agente, o banco, a data e as receitas do dia.
      </p>
    </div>

  </div>

  <div
    className={
      "dropzone" +
      (arrastandoPdf ? " dropzone--arrasto" : "") +
      (pdf ? " dropzone--arquivo" : "")
    }
    role="button"
    tabIndex={0}
    onClick={() => inputPdfRef.current?.click()}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        inputPdfRef.current?.click();
      }
    }}
    onDragOver={(e) => {
      e.preventDefault();
      setArrastandoPdf(true);
    }}
    onDragLeave={() => setArrastandoPdf(false)}
    onDrop={(e) => {
      e.preventDefault();
      setArrastandoPdf(false);
      const arquivo = e.dataTransfer.files?.[0];
      if (arquivo) setPdf(arquivo);
    }}
  >

    <input
      type="file"
      accept="application/pdf,.pdf"
      ref={inputPdfRef}
      hidden
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => setPdf(e.target.files[0] || null)}
    />

    <Icone nome="historico" />

    {pdf ? (
      <>
        <strong>{pdf.name}</strong>
        <span>Clique para trocar o arquivo</span>
      </>
    ) : (
      <>
        <strong>Arraste o PDF aqui</strong>
        <span>ou clique para escolher o arquivo</span>
      </>
    )}

  </div>

  <div className="passo-acoes">

    <button
      className="btn"
      onClick={processarPDF}
      disabled={processandoPdf}
    >
      {processandoPdf ? "Processando…" : "Processar PDF"}
    </button>

  </div>

  {pdfProcessado && receitas.length > 0 && (

    <div className="aviso-pdf">

      <Icone nome="info" />

      <p>
        <strong>PDF processado.</strong> Confira os dados abaixo,
        ajuste o que for preciso e clique em{" "}
        <strong>Salvar recebimento</strong>. Não é necessário
        processar o PDF de novo — reprocessar descarta as
        alterações feitas.
      </p>

    </div>

  )}

</div>

{/* =========================
   PASSO 2 — CONFERÊNCIA
========================= */}

<div className="card">

  <div className="passo-head">

    <span
      className={
        "passo-num" + (receitas.length > 0 ? " passo-num--ok" : "")
      }
    >
      2
    </span>

    <div>
      <h3>Conferência do recebimento</h3>
      <p className="passo-sub">
        Revise o que foi extraído do PDF: edite valores, exclua
        linhas e corrija agente, banco ou data se preciso.
      </p>
    </div>

  </div>

  <div className="grid">

    <div className="conc-campo">

      <label>Agente arrecadador</label>

      <select
        value={agente}
        onChange={(e) => {

          setAgente(e.target.value);

          const agenteSelecionado =
            listaAgentes.find(
              (a) => a.id == e.target.value
            );

          if (agenteSelecionado) {

            setBanco(
              agenteSelecionado.banco_id || ""
            );

          }

        }}
      >

        <option value="">
          Selecione o agente
        </option>

        {listaAgentes.map((a) => (

          <option
            key={a.id}
            value={a.id}
          >
            {a.nome}
          </option>

        ))}

      </select>

    </div>

    <div className="conc-campo">

      <label>Banco de depósito</label>

      <select
        value={banco}
        onChange={(e) =>
          setBanco(e.target.value)
        }
      >

        <option value="">
          Selecione o banco
        </option>

        {listaBancos.map((b) => (

          <option
            key={b.id}
            value={b.id}
          >
            {b.nome}
          </option>

        ))}

      </select>

    </div>

    <div className="conc-campo">

      <label>Data do recebimento</label>

      <input
        type="date"
        value={dataRecebimento}
        onChange={(e) =>
          setDataRecebimento(
            e.target.value
          )
        }
      />

    </div>

  </div>

  {/* TABELA */}

  <table className="tabela-receitas">

    <thead>

      <tr>

        <th className="th-marcar">

          <input
            type="checkbox"
            title="Marcar todas"
            checked={
              receitas.length > 0 &&
              receitas.every((r) => r.selecionado)
            }
            disabled={receitas.length === 0}
            onChange={(e) => {

              const marcar = e.target.checked;

              setReceitas(
                receitas.map((r) => ({
                  ...r,
                  selecionado: marcar,
                }))
              );

            }}
          />

        </th>
        <th>Código</th>
        <th>Descrição</th>
        <th className="col-valor">Valor</th>
        <th>Ações</th>

      </tr>

    </thead>

    <tbody>

      {receitas.length === 0 && (

        <tr>
          <td colSpan={5} className="conc-vazio">
            Nenhuma receita carregada. Processe o PDF do dia no
            passo 1 para preencher esta lista.
          </td>
        </tr>

      )}

      {receitas.map((r, i) => (

        <tr key={i}>

          <td className="th-marcar">

            <input
              type="checkbox"
              checked={r.selecionado || false}
              onChange={(e) => {

                const lista = [...receitas];

                lista[i].selecionado =
                  e.target.checked;

                setReceitas(lista);

              }}
            />

          </td>

          <td>{r.codigo}</td>

          <td>{r.descricao}</td>

          <td className="col-valor">R$ {r.valor}</td>

          <td>

            <div className="acoes-linha">

              <button
                className="btn"
                title="Editar valor"
                onClick={async () => {

                  const novoValor = await mostrarPrompt(
                    "Editar valor:",
                    r.valor
                  );

                  if (novoValor !== null) {

                    const lista = [...receitas];

                    lista[i].valor = novoValor;

                    setReceitas(lista);

                  }

                }}
              >
                <Icone nome="editar" />
              </button>

              <button
                className="btn-delete"
                title="Excluir receita"
                onClick={() => removerReceita(i)}
              >
                <Icone nome="fechar" />
              </button>

            </div>

          </td>

        </tr>

      ))}

    </tbody>

  </table>

  {receitas.length > 0 && (

  <div className="receitas-rodape">

    {receitas.some((r) => r.selecionado) ? (

      <button
        className="btn-delete"
        onClick={() => {

          const filtrados = receitas.filter(
            (r) => !r.selecionado
          );

          setReceitas(filtrados);

        }}
      >
        <Icone nome="lixeira" />
        Excluir selecionadas (
        {receitas.filter((r) => r.selecionado).length})
      </button>

    ) : (

      <span className="conc-qtd">
        {receitas.length === 1
          ? "1 receita"
          : receitas.length + " receitas"}
      </span>

    )}

    <div className="total-box">
      Total: {formatarBRL(totalReceitas)}
    </div>

  </div>

  )}

</div>

{/* =========================
   PASSO 3 — SALVAR
   (perfil gestor só consulta: não salva recebimento)
========================= */}

{usuario.tipo !== "gestor" && (
  <div className="card salvar-bar">

    <div className="salvar-bar__info">

      <span className="salvar-bar__lbl">
        Total do recebimento
      </span>

      <span className="salvar-bar__valor">
        {formatarBRL(totalReceitas)}
      </span>

    </div>

    <button
      className="btn"
      onClick={salvarRecebimento}
      disabled={salvandoRecebimento}
    >
      {salvandoRecebimento
        ? "Salvando…"
        : "Salvar recebimento"}
    </button>

  </div>
)}

</>

)}

{tela === "relacionamentos" && (

  <div className="card">

    <h2>Relacionamentos SIAFIC</h2>

    <h3>Bancos</h3>

    <select
      value={relBanco}
      onChange={(e) =>
        setRelBanco(e.target.value)
      }
    >

      <option value="">
        Selecione
      </option>

      {listaBancos.map((b) => (

        <option
          key={b.id}
          value={b.id}
        >
          {b.nome}
        </option>

      ))}

    </select>

    <input
      value={
        listaBancos.find(
          (b) => b.id == relBanco
        )?.codigo || ""
      }
      placeholder="Código do Banco"
      disabled
    />

    <input
      placeholder="Conta SIAFIC"
      value={relConta}
      onChange={(e) =>
        setRelConta(e.target.value)
      }
    />

    <input
      placeholder="Dígito"
      maxLength={2}
      value={relDigito}
      onChange={(e) =>
        setRelDigito(e.target.value)
      }
    />

    <button
      className="btn"
      onClick={async () => {

        try {

          await axios.post(
            "/api/relacionamentos/bancos",
            {
              banco_id: relBanco,
              codigo_sistema:
                listaBancos.find(
                  (b) => b.id == relBanco
                )?.codigo || "",
              conta_siafic: relConta,
              conta_digito: relDigito
            }
          );

          carregarDados();

          mostrarAlerta("Relacionamento salvo");

        } catch (err) {

          console.log(err);

          mostrarAlerta("Erro ao salvar");

        }

      }}
    >
      Salvar Banco
    </button>
<table>

  <thead>
    <tr>
      <th>Banco</th>
      <th>Código</th>
      <th>Conta SIAFIC</th>
      <th>Dígito</th>
      <th>Ações</th>
    </tr>
  </thead>

  <tbody>

    {listaRelacionamentosBancos.map((r) => (

      <tr key={r.id}>

        <td>{r.banco_nome}</td>

        <td>{r.codigo_sistema}</td>

        <td>{r.conta_siafic}</td>

        <td>{r.conta_digito || "—"}</td>

        <td>

          <button
            className="btn"
            onClick={async () => {

              const novaConta = await mostrarPrompt(
                "Nova conta SIAFIC:",
                r.conta_siafic
              );

              if (novaConta === null) return;

              const novoDigito = await mostrarPrompt(
                "Dígito da conta (separado):",
                r.conta_digito || ""
              );

              if (novoDigito === null) return;

              try {

                await axios.put(
                  `/api/relacionamentos/bancos/${r.id}`,
                  {
                    conta_siafic: novaConta,
                    conta_digito: novoDigito
                  }
                );

                carregarDados();

                mostrarAlerta("Relacionamento atualizado");

              } catch (err) {

                console.log(err);

                mostrarAlerta("Erro ao atualizar");

              }

            }}
          >
            Editar
          </button>

          <button
            className="btn-delete"
            onClick={async () => {

              const confirmar =
                await mostrarConfirmacao(
                  "Excluir relacionamento?"
                );

              if (!confirmar) return;

              try {

                await axios.delete(
                  `/api/relacionamentos/bancos/${r.id}`
                );

                carregarDados();

                mostrarAlerta("Relacionamento excluído");

              } catch (err) {

                console.log(err);

                mostrarAlerta("Erro ao excluir");

              }

            }}
          >
            <Icone nome="fechar" />
          </button>

        </td>

      </tr>

    ))}

  </tbody>

</table>

<h3>Credores SIAFIC</h3>

<div className="grid">

  <select
    value={relAgente}
    onChange={(e) =>
      setRelAgente(e.target.value)
    }
  >
    <option value="">
      Selecione
    </option>

    {listaAgentes.map((a) => (
      <option
        key={a.id}
        value={a.id}
      >
        {a.nome}
      </option>
    ))}
  </select>

  <input
    value={
      listaAgentes.find(
        (a) => a.id == relAgente
      )?.codigo || ""
    }
    placeholder="Código do Agente"
    disabled
  />

  <input
    placeholder="Código Credor SIAFIC"
    value={relCredor}
    onChange={(e) =>
      setRelCredor(e.target.value)
    }
  />

  <button
    className="btn"
    onClick={async () => {

      if (!relAgente || !relCredor) {

        mostrarAlerta("Preencha os campos");

        return;

      }

      try {

        await axios.post(
          "/api/relacionamentos/agentes",
          {
            agente_id: relAgente,
            codigo_sistema:
              listaAgentes.find(
                (a) => a.id == relAgente
              )?.codigo || "",
            codigo_credor_siafic: relCredor
          }
        );

        carregarDados();

        setRelAgente("");
        setRelCredor("");

        mostrarAlerta("Relacionamento salvo");

      } catch (err) {

        console.log(err);

        mostrarAlerta(
          err.response?.data?.erro ||
          "Erro ao salvar"
        );

      }

    }}
  >
    Salvar Credor
  </button>

</div>

<table>

  <thead>

    <tr>

      <th>Agente</th>
      <th>Código</th>
      <th>COD CREDOR SIAFIC</th>
      <th>Ações</th>

    </tr>

  </thead>

  <tbody>

  {listaRelacionamentosAgentes.map((r) => (

    <tr key={r.id}>

      <td>{r.agente_nome}</td>

      <td>{r.codigo_sistema}</td>

      <td>{r.codigo_credor_siafic}</td>

      <td>

        <button
          className="btn"
          onClick={() =>
            editarRelacionamento(r)
          }
        >
          <Icone nome="editar" />
        </button>

        <button
          className="btn-delete"
          onClick={() =>
            excluirRelacionamento(r.id)
          }
        >
          <Icone nome="lixeira" />
        </button>

      </td>

    </tr>

  ))}

</tbody>

    

</table>

  </div>
) }

{tela === "relacionamentos" && (

  <div className="card">

    <h3>Receitas → Plano de Contas do SIAFIC</h3>

    <p className="conc-ajuda">
      O envio da arrecadação exige a rubrica contábil de cada receita.
      O sistema consulta o plano de contas direto no SIAFIC e sugere o
      vínculo pelo código — confira antes de aplicar.
    </p>

    <div className="acoes-linha" style={{ marginBottom: 14 }}>

      <button
        className="btn"
        onClick={carregarRelReceitas}
        disabled={carregandoRelReceitas}
      >
        {carregandoRelReceitas ? "Consultando..." : "Buscar sugestões no SIAFIC"}
      </button>

      {sugestoesReceitas.length > 0 && (
        <button
          className="btn"
          onClick={aplicarSugestoesReceitas}
          disabled={carregandoRelReceitas}
        >
          Aplicar {sugestoesReceitas.length} sugestão(ões) de uma vez
        </button>
      )}

    </div>

    {/* Deixa explícito que não há nada pendente de gravação */}
    {relReceitas.length > 0 &&
      sugestoesReceitas.length === 0 &&
      Object.keys(edicaoReceitas).length === 0 && (
        <p className="conc-ajuda">
          Todos os vínculos abaixo já estão salvos. Para trocar a rubrica de
          uma receita, escolha outra na lista e clique em Salvar naquela linha.
        </p>
      )}

    <table>

      <thead>
        <tr>
          <th>Código da receita</th>
          <th>Plano de contas do SIAFIC</th>
          <th>Fonte</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>

      <tbody>

        {relReceitas.length === 0 && (
          <tr>
            <td colSpan={5} className="conc-vazio">
              Nenhuma receita vinculada. Use o botão acima para buscar as
              sugestões no SIAFIC.
            </td>
          </tr>
        )}

        {relReceitas.map((r) => {

          // Valor em edição tem prioridade sobre o que está gravado
          const emEdicao = edicaoReceitas[r.codigo_receita];
          const alterado = !!emEdicao;

          return (

          <tr key={r.codigo_receita}>

            <td>{r.codigo_receita}</td>

            <td>

              {planosContasSiafic.length > 0 ? (

                <select
                  value={emEdicao || r.num_plano_contas || ""}
                  onChange={(e) =>
                    setEdicaoReceitas({
                      ...edicaoReceitas,
                      [r.codigo_receita]: e.target.value,
                    })
                  }
                >
                  <option value="">Selecione a rubrica do SIAFIC</option>
                  {planosContasSiafic.map((p) => (
                    <option
                      key={p.num_plano_contas}
                      value={p.num_plano_contas}
                    >
                      {p.rotulo}
                    </option>
                  ))}
                </select>

              ) : (
                <>
                  {r.num_plano_contas || "—"}
                  {r.ds_plano_contas && (
                    <div className="conc-obs">{r.ds_plano_contas}</div>
                  )}
                </>
              )}

            </td>

            <td>{r.num_fonte_recurso || "—"}</td>

            <td>
              {alterado ? (
                <span className="status status--pendente">NÃO SALVO</span>
              ) : r.ja_vinculado ? (
                <span className="status status--enviado">SALVO</span>
              ) : r.encontrado ? (
                <span className="status status--excedente">SUGERIDO</span>
              ) : (
                <span className="status status--pendente">SEM VÍNCULO</span>
              )}
            </td>

            <td>
              <div className="acoes-linha">

                <button
                  className="btn"
                  onClick={() => salvarRelReceita(r.codigo_receita)}
                  disabled={
                    !alterado || salvandoReceita === r.codigo_receita
                  }
                >
                  {salvandoReceita === r.codigo_receita
                    ? "Salvando..."
                    : "Salvar"}
                </button>

                {r.ja_vinculado && (
                  <button
                    className="btn-delete"
                    onClick={() => excluirRelReceita(r.codigo_receita)}
                  >
                    <Icone nome="fechar" />
                  </button>
                )}

              </div>
            </td>

          </tr>

          );

        })}

      </tbody>

    </table>

  </div>
)}

{tela === "fontes" && (

  <div className="card">

    <h2>Fontes de Recursos</h2>

    {/* ============ ETAPA 1: EXERCÍCIO ============ */}

    <h3>1. Cadastro de Exercício</h3>

    <div className="grid">

      <input
        placeholder="Exercício (ex: 2026)"
        value={novoExercicio}
        onChange={(e) => setNovoExercicio(e.target.value)}
      />

      <button className="btn" onClick={salvarExercicio}>
        Salvar Exercício
      </button>

    </div>

    <table>
      <thead>
        <tr>
          <th>Exercício</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {listaExercicios.map((e) => (
          <tr key={e.id}>
            <td>{e.ano}</td>
            <td>
              <button
                className="btn-delete"
                onClick={() => excluirExercicio(e.id)}
              >
                <Icone nome="lixeira" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* ============ ETAPA 2: FONTE DE RECURSO ============ */}

    <h3>2. Cadastro de Fonte de Recurso</h3>

    <div className="grid">

      <input
        placeholder="Código da Fonte"
        value={novaFonteCodigo}
        onChange={(e) => setNovaFonteCodigo(e.target.value)}
      />

      <input
        placeholder="Descrição da Fonte"
        value={novaFonteDescricao}
        onChange={(e) => setNovaFonteDescricao(e.target.value)}
      />

      <button className="btn" onClick={salvarFonteRecurso}>
        Salvar Fonte
      </button>

    </div>

    <table>
      <thead>
        <tr>
          <th>Código</th>
          <th>Descrição</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {listaFontesRecurso.map((f) => (
          <tr key={f.id}>
            <td>{f.codigo}</td>
            <td>{f.descricao}</td>
            <td>
              <button
                className="btn-delete"
                onClick={() => excluirFonteRecurso(f.id)}
              >
                <Icone nome="lixeira" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* ============ ETAPA 3: VÍNCULO FONTE x EXERCÍCIO ============ */}

    <h3>3. Vincular Fonte ao Exercício</h3>

    <div className="grid">

      <select
        value={vinculoFonte}
        onChange={(e) => setVinculoFonte(e.target.value)}
      >
        <option value="">Selecione a Fonte</option>
        {listaFontesRecurso.map((f) => (
          <option key={f.id} value={f.id}>
            {f.codigo}{f.descricao ? " - " + f.descricao : ""}
          </option>
        ))}
      </select>

      <select
        value={vinculoExercicio}
        onChange={(e) => setVinculoExercicio(e.target.value)}
      >
        <option value="">Selecione o Exercício</option>
        {listaExercicios.map((e) => (
          <option key={e.id} value={e.id}>
            {e.ano}
          </option>
        ))}
      </select>

      <button className="btn" onClick={salvarVinculoFonte}>
        Vincular
      </button>

    </div>

    <table>
      <thead>
        <tr>
          <th>Exercício</th>
          <th>Fonte</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {listaVinculosFonte.map((v) => (
          <tr key={v.id}>
            <td>{v.exercicio_ano}</td>
            <td>
              {v.fonte_codigo}
              {v.fonte_descricao ? " - " + v.fonte_descricao : ""}
            </td>
            <td>
              <button
                className="btn-delete"
                onClick={() => excluirVinculoFonte(v.id)}
              >
                <Icone nome="lixeira" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

    {/* ============ ETAPA 4: VÍNCULO RECEITA x EXERCÍCIO/FONTE ============ */}

    <h3>4. Vincular Receita ao Exercício/Fonte</h3>

    <div className="grid">

      <select
        value={vinculoReceita}
        onChange={(e) => setVinculoReceita(e.target.value)}
      >
        <option value="">Selecione a Receita</option>
        {listaReceitas.map((r) => (
          <option key={r.id} value={r.id}>
            {r.codigo} - {r.descricao}
          </option>
        ))}
      </select>

      <select
        value={vinculoFonteExercicio}
        onChange={(e) => setVinculoFonteExercicio(e.target.value)}
      >
        <option value="">Selecione o Exercício/Fonte</option>
        {listaVinculosFonte.map((v) => (
          <option key={v.id} value={v.id}>
            {v.exercicio_ano} — {v.fonte_codigo}
            {v.fonte_descricao ? " - " + v.fonte_descricao : ""}
          </option>
        ))}
      </select>

      <button className="btn" onClick={salvarVinculoReceita}>
        Vincular Receita
      </button>

    </div>

    <table>
      <thead>
        <tr>
          <th>Exercício</th>
          <th>Receita</th>
          <th>Fonte</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        {listaReceitaVinculos.map((rv) => (
          <tr key={rv.id}>
            <td>{rv.exercicio_ano}</td>
            <td>
              {rv.receita_codigo} - {rv.receita_descricao}
            </td>
            <td>
              {rv.fonte_codigo}
              {rv.fonte_descricao ? " - " + rv.fonte_descricao : ""}
            </td>
            <td>
              <button
                className="btn-delete"
                onClick={() => excluirVinculoReceita(rv.id)}
              >
                <Icone nome="lixeira" />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>

  </div>

)}

  {tela === "envios" && (

  <div className="card">

    <h2>Status SIAFIC</h2>

    <h3>Recebimentos Salvos</h3>

    {(() => {
      const agentes = [...new Set(listaRecebimentos.map((r) => r.agente_nome).filter(Boolean))].sort();
      const bancos = [...new Set(listaRecebimentos.map((r) => r.banco_nome).filter(Boolean))].sort();
      const muda = (campo) => (e) => setFiltroReceb({ ...filtroReceb, [campo]: e.target.value });
      const algum = Object.values(filtroReceb).some(Boolean);
      return (
        <div className="filtros-recebimentos" style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "flex-end", marginBottom: 12 }}>
          <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>Valor
            <input type="text" inputMode="decimal" placeholder="Ex.: 13.567,71" value={filtroReceb.valor} onChange={muda("valor")} style={{ width: 130 }} />
          </label>
          <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>Mês do recebimento
            <input type="month" value={filtroReceb.mes} onChange={muda("mes")} />
          </label>
          <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>Data
            <input type="date" value={filtroReceb.data} onChange={muda("data")} />
          </label>
          <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>Agente
            <select value={filtroReceb.agente} onChange={muda("agente")}>
              <option value="">Todos</option>
              {agentes.map((a) => <option key={a} value={a}>{a}</option>)}
            </select>
          </label>
          <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>Banco
            <select value={filtroReceb.banco} onChange={muda("banco")}>
              <option value="">Todos</option>
              {bancos.map((b) => <option key={b} value={b}>{b}</option>)}
            </select>
          </label>
          <label style={{ display: "flex", flexDirection: "column", fontSize: 12 }}>Status
            <select value={filtroReceb.status} onChange={muda("status")}>
              <option value="">Todos</option>
              <option value="ENVIADO">Enviado</option>
              <option value="PENDENTE">Pendente</option>
              <option value="ESTORNADO">Estornado</option>
              <option value="ERRO">Erro</option>
            </select>
          </label>
          {algum && (
            <button className="btn" onClick={() => setFiltroReceb(filtroRecebVazio)}>Limpar</button>
          )}
          {algum && (
            <span style={{ fontSize: 12 }}>
              {recebimentosFiltrados().length} de {listaRecebimentos.length} recebimento(s)
            </span>
          )}
        </div>
      );
    })()}

    {/* Input escondido usado pelo botão "Anexar PDF" das linhas */}
    <input
      type="file"
      accept="application/pdf"
      ref={inputEspelhoRef}
      style={{ display: "none" }}
      onChange={(e) => {
        anexarEspelhoRecebimento(e.target.files[0]);
        e.target.value = "";
      }}
    />

    <table>

      <thead>

        <tr>

          <th>Seq</th>
          <th>Data</th>
          <th>Agente</th>
          <th>Banco</th>
          <th className="col-valor">Valor</th>
          <th>Status</th>
          <th>Tentativas</th>
          <th>Ações</th>

        </tr>

      </thead>

      <tbody>

        {recebimentosFiltrados().map((r) => (

          <tr key={r.id}>

            <td>{r.id}</td>

            <td>
              {formatarData(r.data_recebimento)}
            </td>

            <td>{r.agente_nome || "-"}</td>

            <td>{r.banco_nome || "-"}</td>

            <td className="col-valor">{formatarBRL(r.valor)}</td>

            <td style={{ whiteSpace: "nowrap" }}>

              {r.status_siafic === "ENVIADO" && (<><span className="dot dot--verde"></span>ENVIADO</>)}

              {/* Pedido do SAAE (15/10/2026): o pendente que veio de um
                  estorno (lote -R*) aparece como ESTORNADO ate o reenvio */}
              {r.status_siafic === "PENDENTE" && /-R\d+$/.test(String(r.chave_lote || "")) && (<><span className="dot dot--vermelho"></span>ESTORNADO</>)}

              {r.status_siafic === "PENDENTE" && !/-R\d+$/.test(String(r.chave_lote || "")) && (<><span className="dot dot--amarelo"></span>PENDENTE</>)}

              {r.status_siafic === "ERRO" && (<><span className="dot dot--vermelho"></span>ERRO</>)}

            </td>

            <td>{r.tentativas_envio || 0}</td>

            <td>

              <div className="acoes-linha acoes-compactas">

              <button
                className="btn"
                onClick={() =>
                  setRecebimentoSelecionado(r)
                }
              >
                Visualizar
              </button>

              {!!Number(r.tem_arquivo) && (
                <button
                  className="btn"
                  onClick={() => abrirEspelhoRecebimento(r.id)}
                >
                  Ver PDF
                </button>
              )}

              {!Number(r.tem_arquivo) && usuario.tipo !== "gestor" && (
                <button
                  className="btn"
                  onClick={() => {
                    setRecebimentoAnexo(r);
                    inputEspelhoRef.current?.click();
                  }}
                >
                  Anexar PDF
                </button>
              )}

              {(r.tentativas_envio || 0) > 0 && (
                <button
                  className="btn"
                  onClick={() => abrirHistoricoEnvios(r)}
                >
                  Histórico
                </button>
              )}

              {r.status_siafic === "ENVIADO" &&
                ["admin", "contabilidade"].includes(usuario.tipo) && (
                <button
                  className="btn-delete"
                  onClick={async () => {

                    // Pedido do SAAE (15/10/2026): o motivo do
                    // estorno e obrigatorio
                    const motivo = await mostrarPrompt(
                      `Estornar no SIAFIC todas as linhas do envio do ` +
                        `recebimento #${r.id}? O recebimento volta a ` +
                        `PENDENTE para ser reenviado corrigido.\n\n` +
                        `Informe o MOTIVO do estorno (obrigatório):`,
                      "",
                      "Estornar envio"
                    );

                    if (motivo === null || motivo === undefined) return;

                    if (String(motivo).trim().length < 5) {
                      mostrarAlerta("Informe o motivo do estorno (obrigatório).");
                      return;
                    }

                    try {

                      const resposta = await axios.post(
                        `/api/estornar-siafic/${r.id}`,
                        { motivo: String(motivo).trim() }
                      );

                      await carregarRecebimentos();

                      mostrarAlerta(
                        `${resposta.data.estornadas} linha(s) estornada(s) ` +
                          `no SIAFIC. ` +
                          (resposta.data.comprovantes_excluidos > 0
                            ? `${resposta.data.comprovantes_excluidos} ` +
                              `comprovante(s) de depósito vinculado(s) ` +
                              `foi(ram) excluído(s) da conciliação. `
                            : "") +
                          `Confira a Prévia e clique em ` +
                          `Enviar SIAFIC para reenviar corrigido.`
                      );

                    } catch (err) {

                      mostrarAlerta(
                        err.response?.data?.erro ||
                          "Não foi possível estornar o envio."
                      );

                    }

                  }}
                >
                  Estornar
                </button>
              )}

             {r.status_siafic !== "ENVIADO" && (

  <>
  
    <button
      className="btn"
      onClick={async () => {

        // Envio grava no sistema contábil: pede confirmação explícita
        const confirmarEnvio = await mostrarConfirmacao(
          `Enviar o recebimento #${r.id} (${formatarBRL(r.valor)}) ao ` +
            `SIAFIC? A arrecadação será gravada no sistema contábil.`
        );

        if (!confirmarEnvio) return;

        try {

  await axios.post(
  `/api/enviar-siafic/${r.id}`,
  {
    config: configSiafic
  }
);

  mostrarAlerta("Enviado ao SIAFIC");

  carregarRecebimentos();

} catch (err) {

  console.log(err);

  const resposta = err.response?.data;

  // Monta uma mensagem limpa, em português, a partir da
  // resposta tratada pelo backend (erro + dica + itens).
  let mensagem = "";

  if (resposta && typeof resposta === "object") {

    mensagem = resposta.erro || "Erro ao enviar ao SIAFIC";

    if (Array.isArray(resposta.itens) && resposta.itens.length > 0) {
      mensagem +=
        "\n\n• " + resposta.itens.join("\n• ");
    }

    if (resposta.dica) {
      mensagem += "\n\n" + resposta.dica;
    }

  } else {
    mensagem =
      "Erro ao enviar ao SIAFIC" +
      (err.message ? "\n\n" + err.message : "");
  }

  mostrarAlerta(mensagem);

}
  
      }}
    >
      {/* Pedido do SAAE (15/10/2026): estornado, o botao vira Reenviar */}
      {/-R\d+$/.test(String(r.chave_lote || "")) ? "Reenviar SIAFIC" : "Enviar SIAFIC"}
    </button>

    {/* Confere o que será enviado sem gravar nada no SIAFIC */}
    <button
      className="btn"
      onClick={() => verPreviaEnvio(r.id)}
    >
      Prévia
    </button>

    <button
      className="btn-delete"
      onClick={async () => {

        const confirmar =
          await mostrarConfirmacao(
            "Deseja excluir este recebimento?"
          );

        if (!confirmar) return;

        try {

          await axios.delete(
            `/api/recebimentos/${r.id}`
          );

          carregarRecebimentos();

          mostrarAlerta(
            "Recebimento excluído"
          );

        } catch (err) {

          console.log(err);

          mostrarAlerta(
            err.response?.data?.erro ||
            "Erro ao excluir"
          );

        }

      }}
    >
      Excluir
    </button>

  </>

)}

              </div>

            </td>

          </tr>

        ))}

      </tbody>

    </table>

    {/* ===== ENVIOS ESTORNADOS (pedido do SAAE, 15/10/2026) ===== */}
    <h3 style={{ marginTop: 28 }}>
      Envios estornados{listaEstornos.length ? ` — ${listaEstornos.length}` : ""}
    </h3>

    {listaEstornos.length === 0 ? (
      <p style={{ fontSize: 13, opacity: 0.7 }}>Nenhum envio estornado.</p>
    ) : (
      <table>
        <thead>
          <tr>
            <th>Seq</th>
            <th>Recebimento</th>
            <th>Agente</th>
            <th>Banco</th>
            <th className="col-valor">Valor</th>
            <th>Estornado em</th>
            <th>Por</th>
            <th>Motivo</th>
            <th>Lote estornado</th>
            <th>Situação atual</th>
          </tr>
        </thead>
        <tbody>
          {listaEstornos.map((e) => (
            <tr key={e.id}>
              <td>{e.recebimento_id}</td>
              <td>{formatarData(e.data_recebimento)}</td>
              <td>{e.agente_nome || "-"}</td>
              <td>{e.banco_nome || "-"}</td>
              <td className="col-valor">{formatarBRL(e.valor)}</td>
              <td>{formatarDataHora(e.estornado_em)}</td>
              <td>{e.usuario_nome || "-"}</td>
              <td>{e.motivo || <span style={{ opacity: 0.6 }}>(sem motivo — estorno anterior à exigência)</span>}</td>
              <td>{e.lote_estornado}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                {e.status_siafic === "ENVIADO"
                  ? <><span className="dot dot--verde"></span>REENVIADO</>
                  : <><span className="dot dot--amarelo"></span>AGUARDANDO REENVIO</>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}

    {/* ===== HISTÓRICO DE TENTATIVAS DE ENVIO ===== */}
    {historicoEnvios && (
      <div
        className="modal-overlay"
        onClick={() => setHistoricoEnvios(null)}
      >
        <div
          className="modal-box modal-info conc-modal"
          onClick={(e) => e.stopPropagation()}
        >

          <div className="modal-cabecalho">
            <span className="modal-icone"><Icone nome="historico" /></span>
            <h3>
              Histórico de envios — Recebimento #
              {historicoEnvios.recebimento.id}
            </h3>
          </div>

          <div className="modal-corpo">

            <p>
              {formatarData(historicoEnvios.recebimento.data_recebimento)}
              {" · "}
              {historicoEnvios.recebimento.agente_nome || "—"}
              {" · "}
              {historicoEnvios.recebimento.banco_nome || "—"}
            </p>

            {historicoEnvios.itens.length === 0 && (
              <p className="conc-vazio">
                Nenhuma tentativa de envio registrada para este
                recebimento.
              </p>
            )}

            {historicoEnvios.itens.map((h) => (

              <div key={h.id} className="conc-campo">

                <label>
                  {formatarDataHora(h.data_tentativa)}
                  {" — "}
                  {Number(h.sucesso)
                    ? (<><span className="dot dot--verde"></span>ENVIADO COM SUCESSO</>)
                    : (<><span className="dot dot--vermelho"></span>ERRO</>)}
                  {h.usuario_nome ? ` — por ${h.usuario_nome}` : ""}
                </label>

                {Number(h.sucesso) ? (
                  <p>
                    {h.protocolo
                      ? `Protocolo: ${h.protocolo}`
                      : "Envio aceito pelo SIAFIC."}
                    {h.tempo_resposta_api
                      ? ` (${h.tempo_resposta_api} ms)`
                      : ""}
                  </p>
                ) : (
                  <>
                    <p>{h.erro || "Erro não detalhado."}</p>
                    {h.dica && (
                      <div className="conc-obs">{h.dica}</div>
                    )}
                  </>
                )}

              </div>

            ))}

          </div>

          <div className="modal-acoes">
            <button
              className="modal-btn modal-btn-ok"
              onClick={() => setHistoricoEnvios(null)}
            >
              Fechar
            </button>
          </div>

        </div>
      </div>
    )}

    {recebimentoSelecionado && (

      <div className="card">

        <div className="det-head">

          <div>
            <h3>
              Recebimento #{recebimentoSelecionado.id}
            </h3>
            <p className="det-sub">
              {recebimentoSelecionado.agente_nome}
              {" — "}
              {formatarData(recebimentoSelecionado.data_recebimento)}
            </p>
          </div>

          <div className="det-acoes">

            {!!Number(recebimentoSelecionado.tem_arquivo) && (
              <button
                className="btn"
                onClick={() =>
                  abrirEspelhoRecebimento(recebimentoSelecionado.id)
                }
              >
                Ver espelho (PDF)
              </button>
            )}

            <button
              className="btn-suave"
              onClick={() =>
                setRecebimentoSelecionado(null)
              }
            >
              Fechar
            </button>

          </div>

        </div>

        <div className="det-grid">

          <div className="det-item">
            <span className="det-lbl">Data do recebimento</span>
            <span className="det-val">
              {formatarData(recebimentoSelecionado.data_recebimento)}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Data de geração</span>
            <span className="det-val">
              {formatarData(recebimentoSelecionado.data_geracao)}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Nº protocolo (CD_CHAVE)</span>
            <span className="det-val">
              {recebimentoSelecionado.chave_lote || "—"}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Agente arrecadador</span>
            <span className="det-val">
              {recebimentoSelecionado.agente_nome}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Código SIAFIC do agente</span>
            <span className="det-val">
              {recebimentoSelecionado.agente_credor_siafic || "—"}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Banco de depósito</span>
            <span className="det-val">
              {recebimentoSelecionado.banco_nome}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Código do banco</span>
            <span className="det-val">
              {recebimentoSelecionado.banco_codigo || "—"}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Conta SIAFIC</span>
            <span className="det-val">
              {recebimentoSelecionado.conta_siafic || "—"}
            </span>
          </div>

          <div className="det-item">
            <span className="det-lbl">Código da agência</span>
            <span className="det-val">
              {recebimentoSelecionado.agencia_codigo || "—"}
            </span>
          </div>

        </div>

        <h4>Receitas</h4>

        <table>

          <thead>

            <tr>

              <th>Código</th>
              <th>Descrição</th>
              <th className="col-valor">Valor</th>
              <th>Fonte de Recurso</th>
              <th>Documento</th>
              <th>Chave Única</th>


            </tr>

          </thead>

          <tbody>

            {recebimentoSelecionado.receitas?.map(
              (rec, i) => (

                <tr key={i}>

  <td>{rec.codigo}</td>

  <td>{rec.descricao}</td>

  <td className="col-valor">
    {formatarBRL(valorParaNumero(rec.valor))}
  </td>

  <td>
    {rec.fonte_recurso || "-"}
  </td>

  <td>
    {rec.numero_documento || "-"}
  </td>

  <td>
    {rec.chave_unica || "-"}
  </td>

</tr>

              )
            )}

          </tbody>

        </table>

        <div className="receitas-rodape">

          <span className="conc-qtd">
            {(recebimentoSelecionado.receitas || []).length === 1
              ? "1 receita"
              : (recebimentoSelecionado.receitas || []).length +
                " receitas"}
          </span>

          <div className="total-box">
            Total:{" "}
            {formatarBRL(
              somarValores(recebimentoSelecionado.receitas)
            )}
          </div>

        </div>

      </div>

    )}

  </div>

)}

{tela === "conciliacao" && (
  <>

    {/* ===== FILTROS ===== */}
    <div className="card">

      <h2>Conciliação de Depósitos</h2>

      <p className="conc-ajuda">
        Compara o valor arrecadado em cada dia com os comprovantes de
        depósito informados. Um mesmo dia pode ter vários comprovantes.
      </p>

      <div className="grid">

        <div className="conc-campo">
          <label>Data inicial</label>
          <input
            type="date"
            value={filtroConc.inicio}
            onChange={(e) =>
              setFiltroConc({ ...filtroConc, inicio: e.target.value })
            }
          />
        </div>

        <div className="conc-campo">
          <label>Data final</label>
          <input
            type="date"
            value={filtroConc.fim}
            onChange={(e) =>
              setFiltroConc({ ...filtroConc, fim: e.target.value })
            }
          />
        </div>

        <div className="conc-campo">
          <label>Agente arrecadador</label>
          <select
            value={filtroConc.agente_id}
            onChange={(e) =>
              setFiltroConc({ ...filtroConc, agente_id: e.target.value })
            }
          >
            <option value="">Todos</option>
            {listaAgentes.map((a) => (
              <option key={a.id} value={a.id}>
                {a.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="conc-campo">
          <label>Banco</label>
          <select
            value={filtroConc.banco_id}
            onChange={(e) =>
              setFiltroConc({ ...filtroConc, banco_id: e.target.value })
            }
          >
            <option value="">Todos</option>
            {listaBancos.map((b) => (
              <option key={b.id} value={b.id}>
                {b.nome}
              </option>
            ))}
          </select>
        </div>

        <div className="conc-campo">
          <label>Situação</label>
          <select
            value={filtroConc.situacao}
            onChange={(e) =>
              setFiltroConc({ ...filtroConc, situacao: e.target.value })
            }
          >
            <option value="">Todas</option>
            <option value="pendente">A conciliar</option>
            <option value="conciliado">Conciliado</option>
            <option value="excedente">Depósito a maior</option>
          </select>
        </div>

        <div className="conc-campo">
          <button
            className="btn"
            onClick={carregarConciliacao}
            disabled={carregandoConc}
          >
            {carregandoConc ? "Buscando..." : "Aplicar filtros"}
          </button>
        </div>

      </div>

    </div>

    {/* ===== TOTAIS DO PERÍODO ===== */}
    <div className="grid conc-totais">

      <div className="stat">
        <div className="stat__ic stat__ic--blue">
          <Icone nome="dinheiro" />
        </div>
        <div>
          <div className="stat__val">
            {formatarBRL(conciliacao.totais.valor_arrecadado)}
          </div>
          <div className="stat__lbl">Arrecadado no período</div>
        </div>
      </div>

      <div className="stat">
        <div className="stat__ic stat__ic--green">
          <Icone nome="conciliacao" />
        </div>
        <div>
          <div className="stat__val">
            {formatarBRL(conciliacao.totais.valor_conciliado)}
          </div>
          <div className="stat__lbl">Coberto por comprovantes</div>
        </div>
      </div>

      <div className="stat">
        <div
          className={
            "stat__ic " +
            (conciliacao.totais.diferenca === 0
              ? "stat__ic--green"
              : conciliacao.totais.diferenca > 0
                ? "stat__ic--amber"
                : "stat__ic--red")
          }
        >
          <Icone nome="alerta" />
        </div>
        <div>
          <div className="stat__val">
            {formatarBRL(Math.abs(conciliacao.totais.diferenca))}
          </div>
          <div className="stat__lbl">
            {conciliacao.totais.diferenca === 0
              ? "Tudo conciliado"
              : conciliacao.totais.diferenca > 0
                ? "Falta conciliar"
                : "Depositado a maior"}
          </div>
        </div>
      </div>

    </div>

    {/* ===== LANÇAR COMPROVANTE =====
        (perfil gestor só consulta: não lança depósito) */}
    {usuario.tipo !== "gestor" && (
    <div className="card">

      <h3>Lançar comprovante de depósito</h3>

      <p className="conc-ajuda">
        Anexe o comprovante: o nº do documento, o valor e a data são
        lidos do arquivo automaticamente (confira e ajuste se preciso).
        Depois de lançar o depósito, o sistema abre a lista de
        recebimentos para você distribuir o valor — enquanto houver
        saldo, dá para vincular mais recebimentos.
      </p>

      <div className="grid">

        <div className="conc-campo conc-campo--largo">
          <label>Arquivo do comprovante (obrigatório)</label>
          <input
            type="file"
            accept=".pdf,.png,.jpg,.jpeg"
            ref={inputArquivoComprovanteRef}
            onChange={(e) =>
              aoEscolherArquivoComprovante(e.target.files?.[0] || null)
            }
          />
          {extraindoComprovante && (
            <div className="conc-obs">Lendo o comprovante...</div>
          )}
          {!extraindoComprovante && dadosExtraidos && (
            <div className="conc-obs">
              {dadosExtraidos.falhou ||
              (!dadosExtraidos.numero_documento && !dadosExtraidos.valor)
                ? "Não foi possível ler o arquivo — preencha os campos manualmente."
                : "Lido do comprovante: " +
                  [
                    dadosExtraidos.numero_documento
                      ? `doc ${dadosExtraidos.numero_documento}`
                      : null,
                    dadosExtraidos.valor
                      ? `R$ ${dadosExtraidos.valor}`
                      : null,
                    dadosExtraidos.data_deposito
                      ? formatarData(dadosExtraidos.data_deposito)
                      : null,
                  ]
                    .filter(Boolean)
                    .join(" · ")}
            </div>
          )}
        </div>

        <div className="conc-campo">
          <label>Data do depósito</label>
          <input
            type="date"
            value={novoComprovante.data_deposito}
            onChange={(e) =>
              setNovoComprovante({
                ...novoComprovante,
                data_deposito: e.target.value,
              })
            }
          />
        </div>

        <div className="conc-campo">
          <label>Valor depositado</label>
          <input
            placeholder="0,00"
            value={novoComprovante.valor}
            onChange={(e) =>
              setNovoComprovante({
                ...novoComprovante,
                valor: e.target.value,
              })
            }
          />
        </div>

        <div className="conc-campo">
          <label>Nº do documento</label>
          <input
            placeholder="Opcional"
            value={novoComprovante.numero_documento}
            onChange={(e) =>
              setNovoComprovante({
                ...novoComprovante,
                numero_documento: e.target.value,
              })
            }
          />
        </div>

        <div className="conc-campo">
          <label>Observação</label>
          <input
            placeholder="Opcional"
            value={novoComprovante.observacao}
            onChange={(e) =>
              setNovoComprovante({
                ...novoComprovante,
                observacao: e.target.value,
              })
            }
          />
        </div>

        <div className="conc-campo">
          <button
            className="btn"
            onClick={salvarComprovante}
            disabled={salvandoComprovante || extraindoComprovante}
          >
            {salvandoComprovante
              ? "Salvando..."
              : "Lançar depósito e vincular"}
          </button>
        </div>

      </div>

    </div>
    )}

    {/* ===== CONCILIAÇÃO POR DIA ===== */}
    <div className="card">

      <h3>Por dia</h3>

      <table>

        <thead>
          <tr>
            <th>Data</th>
            <th>Agente</th>
            <th>Banco</th>
            <th className="col-valor">Arrecadado</th>
            <th className="col-valor">Comprovantes</th>
            <th className="col-valor">Diferença</th>
            <th>Situação</th>
            <th>Ações</th>
          </tr>
        </thead>

        <tbody>

          {conciliacao.linhas.length === 0 && (
            <tr>
              <td colSpan={8} className="conc-vazio">
                Nenhum movimento no período selecionado.
              </td>
            </tr>
          )}

          {conciliacao.linhas.map((l) => (

            <tr key={`${l.data}-${l.agente_id}-${l.banco_id}`}>

              <td>{formatarData(l.data)}</td>
              <td>{l.agente_nome}</td>
              <td>{l.banco_nome}</td>

              <td className="col-valor">
                {formatarBRL(l.valor_arrecadado)}
              </td>

              <td className="col-valor">
                {formatarBRL(l.valor_conciliado)}
                {l.qtd_comprovantes > 0 && (
                  <span className="conc-qtd">
                    {" "}
                    ({l.qtd_comprovantes})
                  </span>
                )}
                {l.qtd_sem_anexo > 0 && (
                  <div className="conc-obs conc-dif">
                    <span className="dot dot--amarelo"></span>
                    {l.qtd_sem_anexo === 1
                      ? "1 sem anexo"
                      : `${l.qtd_sem_anexo} sem anexo`}
                  </div>
                )}
              </td>

              <td
                className={
                  "col-valor " +
                  (l.diferenca === 0 ? "" : "conc-dif")
                }
              >
                {formatarBRL(l.diferenca)}
              </td>

              <td>
                {l.situacao === "conciliado" && (
                  <span className="status status--enviado">CONCILIADO</span>
                )}
                {l.situacao === "pendente" && (
                  <span className="status status--pendente">A CONCILIAR</span>
                )}
                {l.situacao === "excedente" && (
                  <span className="status status--excedente">A MAIOR</span>
                )}
              </td>

              <td>
                <button
                  className="btn"
                  onClick={() => abrirDetalheConciliacao(l)}
                >
                  Detalhar
                </button>
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

    {/* ===== TOTAL POR AGENTE ===== */}
    <div className="card">

      <h3>Total por agente</h3>

      <table>

        <thead>
          <tr>
            <th>Agente</th>
            <th className="col-valor">Arrecadado</th>
            <th className="col-valor">Comprovantes</th>
            <th className="col-valor">Diferença</th>
          </tr>
        </thead>

        <tbody>

          {conciliacao.agentes.length === 0 && (
            <tr>
              <td colSpan={4} className="conc-vazio">
                Nenhum agente com movimento no período.
              </td>
            </tr>
          )}

          {conciliacao.agentes.map((a) => (
            <tr key={a.agente_id || "sem-agente"}>
              <td>{a.agente_nome}</td>
              <td className="col-valor">
                {formatarBRL(a.valor_arrecadado)}
              </td>
              <td className="col-valor">
                {formatarBRL(a.valor_conciliado)}
              </td>
              <td
                className={
                  "col-valor " + (a.diferenca === 0 ? "" : "conc-dif")
                }
              >
                {formatarBRL(a.diferenca)}
              </td>
            </tr>
          ))}

        </tbody>

      </table>

    </div>

    {/* ===== COMPROVANTES DO PERÍODO ===== */}
    <div className="card">

      <h3>Comprovantes lançados</h3>

      <p className="conc-ajuda">
        O PDF unificado traz a capa com os totais (por agente e por
        banco) e, para cada dia do período em ordem cronológica, o BDA
        do dia seguido dos comprovantes daquele dia. Para gerar por um
        banco ou agente específico, use os filtros no topo da tela
        antes de baixar.
      </p>

      <label
        style={{ display: "inline-flex", alignItems: "center", gap: 6, marginRight: 12, fontSize: 13 }}
        title="Marcado: cada dia traz o BDA seguido dos comprovantes. Desmarcado: só os comprovantes, agrupados por dia."
      >
        <input
          type="checkbox"
          checked={pdfComBdas}
          onChange={(e) => setPdfComBdas(e.target.checked)}
        />
        Incluir os BDAs
      </label>

      <button
        className="btn"
        onClick={() => baixarPdfComprovantes(true)}
        disabled={gerandoPdfComprovantes}
        title="Abre o PDF unificado numa nova aba, sem baixar"
        style={{ marginRight: 8 }}
      >
        {gerandoPdfComprovantes
          ? "Gerando PDF..."
          : "Visualizar documentos unificados"}
      </button>

      <button
        className="btn"
        onClick={() => baixarPdfComprovantes(false)}
        disabled={gerandoPdfComprovantes}
      >
        {gerandoPdfComprovantes
          ? "Gerando PDF..."
          : "Baixar PDF unificado do período"}
      </button>

      {/* Input escondido usado pelo botão "Anexar" das linhas */}
      <input
        type="file"
        accept=".pdf,.png,.jpg,.jpeg"
        ref={inputAnexoComprovanteRef}
        style={{ display: "none" }}
        onChange={(e) => {
          anexarArquivoComprovante(e.target.files[0]);
          e.target.value = "";
        }}
      />

      <table>

        <thead>
          <tr>
            <th>Depósito</th>
            <th>Recebimento</th>
            <th>Agente</th>
            <th>Banco</th>
            <th className="col-valor">Valor</th>
            <th>Abatido em</th>
            <th>Documento</th>
            <th>Ações</th>
          </tr>
        </thead>

        <tbody>

          {listaComprovantes.length === 0 && (
            <tr>
              <td colSpan={8} className="conc-vazio">
                Nenhum comprovante lançado no período.
              </td>
            </tr>
          )}

          {listaComprovantes.map((c) => (

            <tr key={c.id}>

              <td>
                {formatarData(c.data_deposito)}
                {!c.tem_arquivo && (
                  <div className="conc-obs conc-dif">
                    <span className="dot dot--amarelo"></span>
                    sem anexo
                  </div>
                )}
              </td>

              <td>
                {c.recebimento_id ? (
                  <>
                    {"#" + c.recebimento_id}
                    <div className="conc-obs">
                      {formatarData(c.data_recebimento)}
                    </div>
                  </>
                ) : (
                  "—"
                )}
              </td>

              <td>{c.agente_nome || "—"}</td>
              <td>{c.banco_nome || "—"}</td>
              <td className="col-valor">{formatarBRL(c.valor)}</td>

              <td>
                {c.alocacoes.map((a) => (
                  <div key={a.id} className="conc-aloc">
                    {formatarData(a.data_referencia)}
                    {" · "}
                    {formatarBRL(a.valor)}
                  </div>
                ))}
                {c.saldo_nao_alocado > 0 && (
                  <div className="conc-aloc conc-dif">
                    Não distribuído: {formatarBRL(c.saldo_nao_alocado)}
                  </div>
                )}
              </td>

              <td>
                {c.numero_documento || "—"}
                {c.observacao && (
                  <div className="conc-obs">{c.observacao}</div>
                )}
              </td>

              <td>
                <div className="acoes-linha">

                  {c.tem_arquivo && (
                    <button
                      className="btn"
                      onClick={() => abrirArquivoComprovante(c.id)}
                    >
                      Ver anexo
                    </button>
                  )}

                  {!c.tem_arquivo && usuario.tipo !== "gestor" && (
                    <button
                      className="btn"
                      onClick={() => {
                        setComprovanteAnexo(c);
                        inputAnexoComprovanteRef.current?.click();
                      }}
                    >
                      Anexar
                    </button>
                  )}

                  {c.saldo_nao_alocado > 0 && (
                    <button
                      className="btn"
                      onClick={() => abrirVinculoComprovante(c)}
                    >
                      Vincular
                    </button>
                  )}

                  <button
                    className="btn"
                    onClick={() => editarDocumentoComprovante(c)}
                  >
                    Editar doc.
                  </button>

                  <button
                    className="btn"
                    onClick={() =>
                      setRemanejando({
                        comprovante: c,
                        modo: "data",
                        data_origem:
                          c.alocacoes[0]?.data_referencia || c.data_deposito,
                        data_destino: "",
                        recebimento_destino_id: "",
                        valor: c.alocacoes[0]?.valor || c.valor,
                      })
                    }
                  >
                    Remanejar
                  </button>

                  <button
                    className="btn-delete"
                    onClick={() => excluirComprovante(c.id)}
                  >
                    <Icone nome="fechar" />
                  </button>

                </div>
              </td>

            </tr>

          ))}

        </tbody>

      </table>

    </div>

    {/* ===== DETALHE DO DIA ===== */}
    {detalheConc && (
      <div
        className="modal-overlay"
        onClick={() => setDetalheConc(null)}
      >
        <div
          className="modal-box modal-info conc-modal"
          onClick={(e) => e.stopPropagation()}
        >

          <div className="modal-cabecalho">
            <span className="modal-icone"><Icone nome="lista" /></span>
            <h3>
              {formatarData(detalheConc.linha.data)} ·{" "}
              {detalheConc.linha.agente_nome}
            </h3>
          </div>

          <div className="modal-corpo">

            <h4 className="conc-sub">Recebimentos do dia</h4>

            <table>
              <thead>
                <tr>
                  <th>Seq</th>
                  <th>Documento</th>
                  <th className="col-valor">Valor</th>
                  <th>SIAFIC</th>
                </tr>
              </thead>
              <tbody>
                {detalheConc.recebimentos.length === 0 && (
                  <tr>
                    <td colSpan={4} className="conc-vazio">
                      Nenhum recebimento neste dia.
                    </td>
                  </tr>
                )}
                {detalheConc.recebimentos.map((r) => (
                  <tr key={r.id}>
                    <td>{r.id}</td>
                    <td>{r.numero_documento || r.documento || "—"}</td>
                    <td className="col-valor">{formatarBRL(r.valor)}</td>
                    <td>{r.status_siafic || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <h4 className="conc-sub">Comprovantes abatidos neste dia</h4>

            <table>
              <thead>
                <tr>
                  <th>Depósito</th>
                  <th>Documento</th>
                  <th className="col-valor">Valor do depósito</th>
                  <th className="col-valor">Abatido aqui</th>
                </tr>
              </thead>
              <tbody>
                {detalheConc.comprovantes.length === 0 && (
                  <tr>
                    <td colSpan={4} className="conc-vazio">
                      Nenhum comprovante abatido neste dia.
                    </td>
                  </tr>
                )}
                {detalheConc.comprovantes.map((c) => (
                  <tr key={c.alocacao_id}>
                    <td>
                      {formatarData(c.data_deposito)}
                      {!Number(c.tem_arquivo) && (
                        <div className="conc-obs conc-dif">
                          <span className="dot dot--amarelo"></span>
                          sem anexo
                        </div>
                      )}
                    </td>
                    <td>{c.numero_documento || "—"}</td>
                    <td className="col-valor">
                      {formatarBRL(c.valor_comprovante)}
                    </td>
                    <td className="col-valor">
                      {formatarBRL(c.valor_alocado)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="conc-resumo">
              <span>
                Arrecadado: <strong>
                  {formatarBRL(detalheConc.linha.valor_arrecadado)}
                </strong>
              </span>
              <span>
                Comprovantes: <strong>
                  {formatarBRL(detalheConc.linha.valor_conciliado)}
                </strong>
              </span>
              <span>
                Diferença: <strong>
                  {formatarBRL(detalheConc.linha.diferenca)}
                </strong>
              </span>
            </div>

          </div>

          <div className="modal-acoes">
            <button
              className="modal-btn modal-btn-ok"
              onClick={() => setDetalheConc(null)}
            >
              Fechar
            </button>
          </div>

        </div>
      </div>
    )}

    {/* ===== REMANEJAR SOBRA ===== */}
    {remanejando && (
      <div
        className="modal-overlay"
        onClick={() => setRemanejando(null)}
      >
        <div
          className="modal-box modal-info"
          onClick={(e) => e.stopPropagation()}
        >

          <div className="modal-cabecalho">
            <span className="modal-icone"><Icone nome="trocar" /></span>
            <h3>Remanejar valor do comprovante</h3>
          </div>

          <div className="modal-corpo">

            <p>
              Depósito de{" "}
              <strong>{formatarBRL(remanejando.comprovante.valor)}</strong>{" "}
              em {formatarData(remanejando.comprovante.data_deposito)}.
              Informe quanto sai de uma data e para onde o valor vai:
              outro dia ou outro recebimento (quando o comprovante foi
              vinculado ao recebimento errado).
            </p>

            <div className="conc-campo">
              <label>Sai da data</label>
              <select
                value={remanejando.data_origem}
                onChange={(e) => {
                  const origem = e.target.value;
                  const aloc = remanejando.comprovante.alocacoes.find(
                    (a) => a.data_referencia === origem
                  );
                  setRemanejando({
                    ...remanejando,
                    data_origem: origem,
                    valor: aloc ? aloc.valor : remanejando.valor,
                  });
                }}
              >
                {remanejando.comprovante.alocacoes.map((a) => (
                  <option key={a.id} value={a.data_referencia}>
                    {formatarData(a.data_referencia)} ·{" "}
                    {formatarBRL(a.valor)} disponível
                  </option>
                ))}
              </select>
            </div>

            <div className="conc-campo">
              <label>Remanejar para</label>
              <select
                value={remanejando.modo}
                onChange={(e) =>
                  setRemanejando({
                    ...remanejando,
                    modo: e.target.value,
                  })
                }
              >
                <option value="data">Outra data</option>
                <option value="recebimento">Outro recebimento</option>
              </select>
            </div>

            {remanejando.modo === "data" ? (
              <div className="conc-campo">
                <label>Abater no dia</label>
                <input
                  type="date"
                  value={remanejando.data_destino}
                  onChange={(e) =>
                    setRemanejando({
                      ...remanejando,
                      data_destino: e.target.value,
                    })
                  }
                />
              </div>
            ) : (
              <div className="conc-campo">
                <label>Recebimento de destino</label>
                <select
                  value={remanejando.recebimento_destino_id}
                  onChange={(e) =>
                    setRemanejando({
                      ...remanejando,
                      recebimento_destino_id: e.target.value,
                    })
                  }
                >
                  <option value="">Escolha o recebimento...</option>
                  {recebimentosConc
                    .filter(
                      (r) =>
                        String(r.id) !==
                        String(remanejando.comprovante.recebimento_id || "")
                    )
                    .map((r) => (
                      <option key={r.id} value={r.id}>
                        {"#" + r.id} ·{" "}
                        {formatarData(r.data_recebimento)} ·{" "}
                        {r.agente_nome} · {formatarBRL(r.valor)}
                      </option>
                    ))}
                </select>
                <div className="conc-obs">
                  O valor será abatido na data do recebimento escolhido
                  e o comprovante passa a apontar para ele. A lista traz
                  os recebimentos do período filtrado na tela.
                </div>
              </div>
            )}

            <div className="conc-campo">
              <label>Valor a remanejar</label>
              <input
                value={remanejando.valor}
                onChange={(e) =>
                  setRemanejando({
                    ...remanejando,
                    valor: e.target.value,
                  })
                }
              />
            </div>

          </div>

          <div className="modal-acoes">
            <button
              className="modal-btn modal-btn-cancelar"
              onClick={() => setRemanejando(null)}
            >
              Cancelar
            </button>
            <button
              className="modal-btn modal-btn-ok"
              onClick={confirmarRemanejamento}
            >
              Remanejar
            </button>
          </div>

        </div>
      </div>
    )}

    {/* ===== LEMBRETE DE DEPÓSITOS A MENOR ===== */}
    {lembreteDeposito && (
      <div
        className="modal-overlay"
        onClick={fecharLembreteDeposito}
      >
        <div
          className="modal-box modal-erro"
          onClick={(e) => e.stopPropagation()}
        >

          <div className="modal-cabecalho">
            <span className="modal-icone"><Icone nome="alerta" /></span>
            <h3>Depósitos a menor — cobrar agentes</h3>
          </div>

          <div className="modal-corpo">

            <p>
              {"Há dia(s) com depósito a menor no período:\n\n" +
                lembreteDeposito.itens
                  .map(
                    (l) =>
                      `• ${l.agente_nome} — ${formatarData(l.data)} — ` +
                      `falta ${formatarBRL(l.diferenca)}`
                  )
                  .join("\n") +
                (lembreteDeposito.total > lembreteDeposito.itens.length
                  ? `\n...e mais ${
                      lembreteDeposito.total - lembreteDeposito.itens.length
                    } dia(s) pendente(s).`
                  : "") +
                "\n\nSolicite ao agente que, no dia subsequente, efetue " +
                "DOIS depósitos separados: um com a diferença que falta " +
                "do dia anterior e outro com o valor arrecadado do dia " +
                "corrente. Depósitos separados facilitam a conciliação."}
            </p>

            <div className="conc-campo" style={{ marginTop: 14 }}>
              <label>Lembrar novamente (só para o seu usuário)</label>
              <select
                value={lembreteDeposito.dias ?? ""}
                onChange={(e) =>
                  setLembreteDeposito({
                    ...lembreteDeposito,
                    dias: e.target.value === "" ? null : Number(e.target.value),
                  })
                }
              >
                <option value="">Todo dia</option>
                <option value="2">A cada 2 dias</option>
                <option value="3">A cada 3 dias</option>
                <option value="5">A cada 5 dias</option>
              </select>
            </div>

          </div>

          <div className="modal-acoes">
            <button
              className="modal-btn modal-btn-ok"
              onClick={fecharLembreteDeposito}
            >
              OK
            </button>
          </div>

        </div>
      </div>
    )}

    {/* ===== VINCULAR DEPÓSITO AOS RECEBIMENTOS ===== */}
    {vinculando && (
      <div
        className="modal-overlay"
        onClick={() => setVinculando(null)}
      >
        <div
          className="modal-box modal-info conc-modal"
          onClick={(e) => e.stopPropagation()}
        >

          <div className="modal-cabecalho">
            <span className="modal-icone"><Icone nome="relacionamentos" /></span>
            <h3>Vincular depósito aos recebimentos</h3>
          </div>

          <div className="modal-corpo">

            <p>
              Depósito de{" "}
              <strong>{formatarBRL(vinculando.valor_total)}</strong> —
              saldo a distribuir:{" "}
              <strong>{formatarBRL(vinculando.saldo)}</strong>.
              O valor sugerido cobre o que falta em cada recebimento,
              mas pode ser alterado antes de vincular.
            </p>

            {(() => {

              const candidatos = recebimentosConc.filter(
                (r) =>
                  r.valor_em_aberto > 0 &&
                  (!vinculando.agente_id ||
                    String(r.agente_id) === String(vinculando.agente_id)) &&
                  (!vinculando.banco_id ||
                    String(r.banco_id) === String(vinculando.banco_id))
              );

              if (candidatos.length === 0) {
                return (
                  <p className="conc-vazio">
                    Nenhum recebimento em aberto para vincular
                    {vinculando.agente_id
                      ? " para o agente deste depósito"
                      : ""}{" "}
                    no período filtrado.
                  </p>
                );
              }

              return (
                <table>

                  <thead>
                    <tr>
                      <th>Recebimento</th>
                      <th>Agente</th>
                      <th className="col-valor">Falta</th>
                      <th className="col-valor">Valor a vincular</th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {candidatos.map((r) => {

                      const sugestao = String(
                        Math.min(r.valor_em_aberto, vinculando.saldo).toFixed(2)
                      ).replace(".", ",");

                      const valorAtual =
                        vinculando.valores[r.id] !== undefined
                          ? vinculando.valores[r.id]
                          : sugestao;

                      return (
                        <tr key={r.id}>

                          <td>
                            {"#" + r.id}
                            <div className="conc-obs">
                              {formatarData(r.data_recebimento)} ·{" "}
                              {r.banco_nome}
                            </div>
                          </td>

                          <td>{r.agente_nome}</td>

                          <td className="col-valor">
                            {formatarBRL(r.valor_em_aberto)}
                          </td>

                          <td className="col-valor">
                            <input
                              value={valorAtual}
                              onChange={(e) =>
                                setVinculando({
                                  ...vinculando,
                                  valores: {
                                    ...vinculando.valores,
                                    [r.id]: e.target.value,
                                  },
                                })
                              }
                            />
                          </td>

                          <td>
                            <button
                              className="btn"
                              onClick={() =>
                                vincularRecebimento(r, valorAtual)
                              }
                            >
                              Vincular
                            </button>
                          </td>

                        </tr>
                      );

                    })}
                  </tbody>

                </table>
              );

            })()}

          </div>

          <div className="modal-acoes">
            <button
              className="modal-btn modal-btn-ok"
              onClick={() => setVinculando(null)}
            >
              Concluir
            </button>
          </div>

        </div>
      </div>
    )}

  </>
)}

{tela === "smtp" && (
  <div className="card">

    <h2>E-mail (SMTP)</h2>

    <p className="conc-ajuda">
      Servidor usado para disparar os avisos automáticos de envio de
      arrecadação. Os destinatários dos avisos são cadastrados na tela
      Configuração SIAFIC, no campo "Avisos por e-mail".{" "}
      <button
        className="btn"
        style={{ padding: "2px 10px", fontSize: 13, height: 30 }}
        onClick={() => setMostrarComoObterSmtp(!mostrarComoObterSmtp)}
      >
        <svg viewBox="0 0 24 24" width="14" height="14" fill="none"
          stroke="currentColor" strokeWidth="2"
          strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5" />
          <path d="M12 7.6h.01" />
        </svg>
        Como obter esses dados
      </button>
    </p>

    {mostrarComoObterSmtp && (
      <div
        style={{
          padding: "14px 16px",
          background: "#eff6ff",
          borderLeft: "3px solid #3b82f6",
          borderRadius: 6,
          marginBottom: 16,
          fontSize: 14,
          color: "#1e3a5f",
          lineHeight: 1.7,
        }}
      >
        <p style={{ fontWeight: 700, margin: "0 0 6px" }}>
          O que preencher aqui?
        </p>
        <p style={{ margin: "0 0 10px" }}>
          São os dados da conta de e-mail que vai ENVIAR os avisos
          (qualquer conta serve — do SAAE ou uma criada só para isso).
          Escolha o caso do seu e-mail:
        </p>

        <p style={{ fontWeight: 700, margin: "10px 0 4px" }}>
          <Icone nome="email" /> Gmail
        </p>
        <ol style={{ paddingLeft: 20, margin: 0, listStyleType: "decimal" }}>
          <li>Servidor: <b>smtp.gmail.com</b> · Porta: <b>587</b></li>
          <li>
            Entre na Conta Google → Segurança e ative a
            "Verificação em duas etapas" (obrigatória).
          </li>
          <li>
            Ainda em Segurança, procure por <b>"Senhas de app"</b>{" "}
            e crie uma para "IntegraReceitas". O Google mostra uma
            senha de 16 letras — copie.
          </li>
          <li>
            Usuário: o e-mail completo · Senha: a senha de app de 16
            letras (NÃO a senha normal da conta).
          </li>
        </ol>

        <p style={{ fontWeight: 700, margin: "12px 0 4px" }}>
          <Icone nome="email" /> Outlook / Hotmail
        </p>
        <ol style={{ paddingLeft: 20, margin: 0, listStyleType: "decimal" }}>
          <li>Servidor: <b>smtp-mail.outlook.com</b> · Porta: <b>587</b></li>
          <li>
            Também exige senha de app: conta Microsoft → Segurança →
            Opções de segurança avançadas → Senhas de aplicativo.
          </li>
        </ol>

        <p style={{ fontWeight: 700, margin: "12px 0 4px" }}>
          <Icone nome="email" /> E-mail do próprio domínio (ex.: @saae.gov.br)
        </p>
        <ol style={{ paddingLeft: 20, margin: 0, listStyleType: "decimal" }}>
          <li>
            Peça ao provedor de hospedagem (ou ao TI) os "dados de SMTP":
            geralmente o servidor é <b>mail.seudominio.com.br</b>, porta
            <b> 587</b> (ou 465), e o usuário é o e-mail completo com a
            senha da própria conta.
          </li>
        </ol>

        <p style={{ margin: "12px 0 0" }}>
          Depois de preencher, clique em <b>Salvar</b> e use o{" "}
          <b>Enviar e-mail de teste</b> abaixo para confirmar que está
          tudo certo.
        </p>
      </div>
    )}

    <div className="grid">

      <div className="conc-campo conc-campo--largo">
        <label>Servidor SMTP (host)</label>
        <input
          placeholder="ex.: smtp.gmail.com"
          value={configSmtp.host}
          onChange={(e) =>
            setConfigSmtp({ ...configSmtp, host: e.target.value })
          }
        />
      </div>

      <div className="conc-campo">
        <label>Porta</label>
        <select
          value={String(configSmtp.porta)}
          onChange={(e) =>
            setConfigSmtp({ ...configSmtp, porta: Number(e.target.value) })
          }
        >
          <option value="587">587 (recomendada)</option>
          <option value="465">465 (SSL)</option>
          <option value="25">25</option>
        </select>
      </div>

      <div className="conc-campo conc-campo--largo">
        <label>Usuário (e-mail completo)</label>
        <input
          placeholder="ex.: avisos@saae.gov.br"
          value={configSmtp.usuario}
          onChange={(e) =>
            setConfigSmtp({ ...configSmtp, usuario: e.target.value })
          }
        />
      </div>

      <div className="conc-campo">
        <label>
          Senha{configSmtp.tem_senha ? " (deixe vazio para manter a atual)" : ""}
        </label>
        <input
          type="password"
          placeholder={configSmtp.tem_senha ? "••••••••" : "Senha ou senha de app"}
          value={configSmtp.senha}
          onChange={(e) =>
            setConfigSmtp({ ...configSmtp, senha: e.target.value })
          }
        />
      </div>

      <div className="conc-campo conc-campo--largo">
        <label>Remetente (opcional — se vazio, usa o usuário)</label>
        <input
          placeholder="ex.: IntegraReceitas <avisos@saae.gov.br>"
          value={configSmtp.remetente}
          onChange={(e) =>
            setConfigSmtp({ ...configSmtp, remetente: e.target.value })
          }
        />
      </div>

      <div className="conc-campo">
        <button className="btn verde" onClick={salvarSmtp}>
          Salvar
        </button>
      </div>

    </div>

    <h3>Testar o envio</h3>

    <p className="conc-ajuda">
      Envia um e-mail de teste com a configuração salva acima, para
      confirmar que os avisos vão chegar.
    </p>

    <div className="grid">

      <div className="conc-campo conc-campo--largo">
        <label>Enviar o teste para</label>
        <input
          placeholder="seu@email.com"
          value={emailTesteSmtp}
          onChange={(e) => setEmailTesteSmtp(e.target.value)}
        />
      </div>

      <div className="conc-campo">
        <button
          className="btn"
          onClick={testarSmtp}
          disabled={testandoSmtp}
        >
          {testandoSmtp ? "Enviando..." : "Enviar e-mail de teste"}
        </button>
      </div>

    </div>

  </div>
)}

{tela === "ajuda" && (
  <>

    <div className="card">
      <h2>Bem-vindo ao IntegraReceitas</h2>
      <p className="conc-ajuda">
        O sistema liga a arrecadação do SAAE ao SIAFIC (sistema
        contábil) e ajuda a conferir os depósitos dos agentes. O
        trabalho do dia a dia se resume a três etapas:
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 12, marginTop: 6 }}>
        {[
          ["1", "Importar", "Receba o arquivo diário de cada agente na tela Recebimentos."],
          ["2", "Enviar", "Confira a Prévia e transmita ao SIAFIC na tela Envios."],
          ["3", "Conciliar", "Lance os comprovantes de depósito na tela Conciliação."],
        ].map(([n, titulo, texto]) => (
          <div
            key={n}
            style={{
              flex: "1 1 220px",
              padding: "14px 16px",
              background: "#f8fafc",
              border: "1px solid #e2e8f0",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                background: "#1d4ed8",
                color: "#fff",
                fontWeight: 700,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: 8,
              }}
            >
              {n}
            </div>
            <div style={{ fontWeight: 700, color: "#1e293b", marginBottom: 4 }}>
              {titulo}
            </div>
            <div style={{ fontSize: 13.5, color: "#475569", lineHeight: 1.5 }}>
              {texto}
            </div>
          </div>
        ))}
      </div>
    </div>

    <CardAjuda
      icone="recebimentos"
      titulo="Recebimentos — importar a arrecadação"
      servePara="Onde entra o arquivo diário que cada agente arrecadador envia com os valores recebidos."
      passos={[
        "Abra a tela Recebimentos e clique para importar o arquivo do agente.",
        "O sistema lê as receitas, os valores e o número do documento, e cria um recebimento por agente/dia.",
        "Confira o total importado — ele será o valor transmitido ao SIAFIC e conciliado depois.",
      ]}
      dicas={[
        "Os códigos de agente, banco e receita do arquivo precisam existir nos Cadastros para o reconhecimento automático.",
      ]}
    />

    <CardAjuda
      icone="envios"
      titulo="Envios ao SIAFIC — transmitir a arrecadação"
      servePara="Cada recebimento importado aparece aqui com a situação: PENDENTE (ainda não enviado), ENVIADO ou ERRO."
      passos={[
        "Clique em Prévia para ver exatamente o que será transmitido, antes de enviar.",
        "Clique em Enviar SIAFIC. Se der certo, a situação vira ENVIADO e o protocolo fica guardado.",
        "Se der ERRO, clique em Histórico: cada tentativa aparece com a descrição do problema e uma dica de correção.",
        "Corrija o que a dica indicar (geralmente um relacionamento faltando) e envie de novo.",
      ]}
      dicas={[
        "Enviou com algum dado errado? O administrador ou a contabilidade pode clicar em Estornar: o sistema desfaz o lote no SIAFIC e o recebimento volta a PENDENTE para reenvio corrigido.",
        "Com os avisos por e-mail configurados (telas E-mail (SMTP) e Configuração SIAFIC), cada envio concluído dispara um e-mail automático com o protocolo.",
      ]}
    />

    <CardAjuda
      icone="conciliacao"
      titulo="Conciliação — conferir os depósitos"
      servePara="Compara, dia a dia e por agente, o valor arrecadado com os depósitos que caíram na conta. O painel mostra CONCILIADO, A CONCILIAR ou EXCEDENTE para cada dia."
      passos={[
        "Na seção Lançar comprovante de depósito, anexe o arquivo do comprovante (PDF ou foto).",
        "Aguarde alguns segundos: o sistema lê o arquivo e preenche sozinho o nº do documento, o valor e a data — confira e ajuste se precisar.",
        "Clique em Lançar depósito e vincular.",
        "Na janela que abre, distribua o valor entre os recebimentos em aberto: o valor sugerido já cobre o que falta em cada um. Enquanto houver saldo, dá para vincular mais recebimentos.",
      ]}
      dicas={[
        "Depósito caiu em outro dia? Use Remanejar na tabela de comprovantes para mover a sobra para a data certa.",
        "Precisa corrigir o número do documento? Botão Editar doc. na linha do comprovante.",
        "O botão Baixar PDF unificado do período gera um único PDF com resumo por agente e por banco e, dia a dia, o BDA do dia seguido dos comprovantes daquele dia — filtre por banco ou agente antes, se quiser um recorte.",
        "Quando um agente deposita a menor, o sistema avisa ao abrir a tela e orienta a pedir DOIS depósitos separados no dia seguinte. No próprio aviso você escolhe de quanto em quanto tempo quer ser lembrado (todo dia, 2, 3 ou 5 dias) — só para o seu usuário.",
      ]}
    />

    <CardAjuda
      icone="pastas"
      titulo="Cadastros — a base do sistema"
      servePara="Agentes Arrecadadores, Bancos, Agências Bancárias (número, dígito e nome) e Códigos de Receita."
      passos={[
        "Cadastre cada banco com o código oficial (ex.: 001 Banco do Brasil).",
        "Cadastre as agências com número e, se quiser, o nome.",
        "Cadastre cada agente arrecadador com o código usado nos arquivos dele.",
        "Os Códigos de Receita são criados automaticamente na importação, mas podem ser ajustados aqui.",
      ]}
      dicas={[
        "Se um arquivo importar com agente ou banco em branco, é sinal de código diferente do cadastro — confira aqui.",
      ]}
    />

    <CardAjuda
      icone="relacionamentos"
      titulo="Relacionamentos SIAFIC — o de-para contábil"
      servePara="Liga o nosso cadastro aos códigos do SIAFIC. Sem esses vínculos o envio é recusado."
      passos={[
        "Bancos: informe a conta SIAFIC e o dígito (em campos separados) de cada banco.",
        "Credores: vincule cada agente ao código de credor do SIAFIC.",
        "Receitas → Plano de Contas: clique em Buscar sugestões no SIAFIC — o sistema consulta o plano de contas oficial e propõe o vínculo de cada receita pelo código.",
        "Confira as sugestões e clique em Aplicar para gravar todas de uma vez. O que ficar SEM VÍNCULO pode ser escolhido manualmente na própria linha.",
      ]}
      dicas={[
        "Erro de validação no envio quase sempre significa vínculo faltando nesta tela (conta, credor ou receita).",
      ]}
    />

    <CardAjuda
      icone="config"
      titulo="Configuração (administrador)"
      servePara="Telas restritas ao administrador, no menu Configurações."
      passos={[
        "Configuração SIAFIC: URL e token da API, código do órgão, mapeamento dos campos do arquivo e os e-mails que recebem os avisos de envio. Use Testar Conexão SIAFIC após qualquer mudança.",
        "E-mail (SMTP): o servidor que envia os avisos — o botão de informações da tela explica como obter os dados (Gmail, Outlook ou e-mail do domínio) e há um envio de teste.",
        "Sequência da Chave Única: o próximo número usado nos lançamentos ao SIAFIC. Só altere com orientação da contabilidade.",
        "Usuários: crie os acessos com o perfil adequado (administrador, operador ou gestor).",
      ]}
    />

    <div className="card">
      <h3><Icone nome="ajuda" /> Perguntas frequentes</h3>

      {[
        [
          "O envio deu ERRO. O que eu faço?",
          "Clique em Histórico na linha do recebimento: a última tentativa mostra a descrição do problema e uma dica. Na maioria dos casos falta um vínculo em Relacionamentos SIAFIC. Corrija e clique em Enviar SIAFIC de novo.",
        ],
        [
          "O comprovante não preencheu os campos sozinho.",
          "Arquivos escaneados demoram alguns segundos para serem lidos. Se aparecer \"Não foi possível ler o arquivo\", preencha os campos manualmente — o lançamento funciona igual.",
        ],
        [
          "Enviei com uma informação errada para o SIAFIC.",
          "O administrador ou a contabilidade pode usar o botão Estornar na tela de Envios: o lote é desfeito no SIAFIC e o recebimento volta a PENDENTE para reenvio corrigido.",
        ],
        [
          "Um dia não fecha na conciliação.",
          "Abra o Detalhar do dia: se o agente depositou a menor, a diferença aparece e o sistema orienta a cobrança (dois depósitos separados no dia seguinte). Se o depósito caiu em outra data, use Remanejar no comprovante.",
        ],
        [
          "Os e-mails de aviso não chegam.",
          "Confira a tela E-mail (SMTP) (use o Enviar e-mail de teste) e se os destinatários estão preenchidos na Configuração SIAFIC. Verifique também a caixa de spam.",
        ],
      ].map(([pergunta, resposta]) => (
        <div key={pergunta} style={{ marginBottom: 14 }}>
          <p style={{ fontWeight: 700, color: "#1e293b", fontSize: 14.5, margin: "0 0 3px" }}>
            {pergunta}
          </p>
          <p style={{ color: "#475569", fontSize: 14, lineHeight: 1.6, margin: 0 }}>
            {resposta}
          </p>
        </div>
      ))}
    </div>

  </>
)}

{tela === "agentes" && (
  <div className="card">

    <h2>Agentes Arrecadadores</h2>

    <input
      placeholder="Nome do agente"
      value={agente}
      onChange={(e) =>
        setAgente(e.target.value)
      }
    />

    <input
      placeholder="Código do agente"
      value={codigoAgente}
      onChange={(e) =>
        setCodigoAgente(e.target.value)
      }
    />

    <select
      value={agenteBanco}
      onChange={(e) => {

        setAgenteBanco(e.target.value);

        const bancoSelecionado =
          listaBancos.find(
            (b) => b.id == e.target.value
          );

        if (bancoSelecionado) {

          setCodigoBanco(
            bancoSelecionado.codigo || ""
          );

        }

      }}
    >

      <option value="">
        Selecione o Banco
      </option>

      {listaBancos.map((b) => (
        <option
          key={b.id}
          value={b.id}
        >
          {b.nome}
        </option>
      ))}

    </select>

    <input
      value={codigoBanco}
      placeholder="Código do Banco"
      disabled
    />

    <select
      value={agenteAgencia}
      onChange={(e) =>
        setAgenteAgencia(e.target.value)
      }
    >

      <option value="">
        Selecione a Agência
      </option>

      {listaAgencias
        .filter((a) => !agenteBanco || a.banco_id == agenteBanco)
        .map((a) => (
          <option
            key={a.id}
            value={a.id}
          >
            {a.codigo}
          </option>
        ))}

    </select>

    <button
      className="btn"
      onClick={salvarAgente}
    >
      {agenteEditando ? "Atualizar" : "Salvar"}
    </button>

    {agenteEditando && (
      <button
        className="btn-delete"
        onClick={limparFormAgente}
      >
        Cancelar
      </button>
    )}

    <table>

      <thead>

        <tr>

          <th>Seq</th>
          <th>Nome</th>
          <th>Código</th>
          <th>Banco</th>
          <th>Cód. Banco</th>
          <th>Agência</th>
          <th>Ações</th>

        </tr>

      </thead>

      <tbody>

        {listaAgentes.map((a) => (

          <tr key={a.id}>

            <td>{a.id}</td>
            <td>{a.nome}</td>
            <td>{a.codigo}</td>
            <td>{a.banco_nome}</td>
            <td>{a.banco_codigo || "—"}</td>
            <td>{a.agencia_numero}</td>

            <td>

              <button
                className="btn"
                onClick={() =>
                  editarAgente(a)
                }
              >
                Editar
              </button>

              <button
                className="btn-delete"
                onClick={() =>
                  excluirItem("agentes", a.id)
                }
              >
                <Icone nome="fechar" />
              </button>

            </td>

          </tr>

        ))}

      </tbody>

    </table>

  </div>
)}

{tela === "bancos" && (
  <div className="card">

    <h2>Bancos</h2>

    <input
      placeholder="Nome do banco"
      value={banco}
      onChange={(e) =>
        setBanco(e.target.value)
      }
    />

    <button
      className="btn"
      onClick={salvarBanco}
    >
      Salvar
    </button>

    <table>

      <thead>

        <tr>

          <th>Seq</th>
          <th>Nome</th>
          <th>Código</th>
          <th>Ações</th>

        </tr>

      </thead>

      <tbody>

        {listaBancos.map((b) => (

          <tr key={b.id}>

            <td>{b.id}</td>
            <td>{b.nome}</td>
            <td>{b.codigo}</td>

            <td>

              <button
                className="btn"
                onClick={() =>
                  editarItem("bancos", b)
                }
              >
                Editar
              </button>

              <button
                className="btn-delete"
                onClick={() =>
                  excluirItem("bancos", b.id)
                }
              >
                <Icone nome="fechar" />
              </button>

            </td>

          </tr>

        ))}

      </tbody>

    </table>

  </div>
)}

{tela === "agencias" && (
  <div className="card">

    <h2>Agências Bancárias</h2>

    <select
      value={agenciaBanco}
      onChange={(e) =>
        setAgenciaBanco(e.target.value)
      }
    >

      <option value="">
        Selecione o Banco
      </option>

      {listaBancos.map((b) => (
        <option
          key={b.id}
          value={b.id}
        >
          {b.nome}
        </option>
      ))}

    </select>

    <input
      placeholder="Número da Agência"
      value={numeroAgencia}
      onChange={(e) =>
        setNumeroAgencia(e.target.value)
      }
    />

    <input
      placeholder="Nome da Agência (opcional)"
      value={nomeAgencia}
      onChange={(e) =>
        setNomeAgencia(e.target.value)
      }
    />

    <button
      className="btn"
      onClick={salvarAgencia}
    >
      Salvar
    </button>

    <table>

      <thead>

        <tr>

          <th>Seq</th>
          <th>Código</th>
          <th>Nome</th>
          <th>Banco</th>
          <th>Ações</th>

        </tr>

      </thead>

      <tbody>

        {listaAgencias.map((a) => (

          <tr key={a.id}>

            <td>{a.id}</td>
            <td>{a.codigo}</td>
            <td>{a.nome || "—"}</td>
            <td>{a.banco_nome || "—"}</td>

            <td>

              <button
                className="btn"
                onClick={() =>
                  editarItem("agencias", a)
                }
              >
                Editar
              </button>

              <button
                className="btn-delete"
                onClick={() =>
                  excluirItem("agencias", a.id)
                }
              >
                <Icone nome="fechar" />
              </button>

            </td>

          </tr>

        ))}

      </tbody>

    </table>

  </div>
)}

{tela === "receitas" && (
  <div className="card">

    <h2>Códigos de Receita</h2>

    <div className="grid">

      <input
        placeholder="Código"
        value={codigoReceita}
        onChange={(e) =>
          setCodigoReceita(
            formatarCodigo(e.target.value)
          )
        }
      />

      <input
        placeholder="Descrição"
        value={descricaoReceita}
        onChange={(e) =>
          setDescricaoReceita(e.target.value)
        }
      />

      <button
        className="btn"
        onClick={salvarCodigoReceita}
      >
        Salvar
      </button>

    </div>

    <table>

      <thead>

        <tr>

          <th>Código</th>
          <th>Descrição</th>
          <th>Ações</th>

        </tr>

      </thead>

      <tbody>

        {listaReceitas.map((r) => (

          <tr key={r.id}>

            <td>{r.codigo}</td>
            <td>{r.descricao}</td>

            <td>

              <button
                className="btn"
                onClick={() =>
                  editarItem("receitas", r)
                }
              >
                Editar
              </button>

              <button
                className="btn-delete"
                onClick={() =>
                  excluirItem("receitas", r.id)
                }
              >
                <Icone nome="fechar" />
              </button>

            </td>

          </tr>

        ))}

      </tbody>

    </table>

  </div>
)}

{tela === "sequencia" && (

  <div className="card">

    <h2>Sequência da Chave Única</h2>

    <p className="subtitulo-config">
      A chave única corresponde ao número de conhecimento da receita e é
      gerada automaticamente de forma sequencial a cada lançamento. Caso
      algum número seja ocupado por lançamento manual no SIAFIC, ajuste
      aqui o próximo número — o sistema passará a gerar a partir dele.
    </p>

    <div className="grid">

      <input
        type="number"
        min="1"
        placeholder="Próximo número da chave única"
        value={proximoChave}
        onChange={(e) => setProximoChave(e.target.value)}
      />

      <button
        className="btn"
        onClick={salvarProximoChave}
      >
        Salvar
      </button>

    </div>

    <p className="texto-suave">
      Próximo número que será usado: <strong>{proximoChave || "—"}</strong>
    </p>

  </div>

)}

{tela === "config" && (

  <div className="card">

    <h2>Configuração SIAFIC</h2>

    <h3>Conexão da API</h3>

    <div className="grid">

      {/* URL */}

      <div className="campo-senha">

        <input
          type={mostrarUrl ? "text" : "password"}
          placeholder="URL do SIAFIC"
          value={configSiafic.url}
          onChange={(e) =>
            setConfigSiafic({
              ...configSiafic,
              url: e.target.value
            })
          }
        />

        {usuario.tipo === "admin" && (

          <button
            type="button"
            className="btn"
            onClick={() =>
              setMostrarUrl(!mostrarUrl)
            }
          >
            {mostrarUrl ? "Ocultar" : "Mostrar"}
          </button>

        )}

      </div>

      {/* TOKEN */}

      <div className="campo-senha">

        <input
          type={mostrarToken ? "text" : "password"}
          placeholder="Token da API"
          value={configSiafic.token}
          onChange={(e) =>
            setConfigSiafic({
              ...configSiafic,
              token: e.target.value
            })
          }
        />

        {usuario.tipo === "admin" && (

          <button
            type="button"
            className="btn"
            onClick={() =>
              setMostrarToken(!mostrarToken)
            }
          >
            {mostrarToken ? "Ocultar" : "Mostrar"}
          </button>

        )}

      </div>

      {/* ÓRGÃO */}

      <input
        placeholder="Código do Órgão"
        value={configSiafic.codigoOrgao}
        onChange={(e) =>
          setConfigSiafic({
            ...configSiafic,
            codigoOrgao: e.target.value
          })
        }
      />

      <input
        placeholder="Nome do Órgão"
        value={configSiafic.nomeOrgao}
        onChange={(e) =>
          setConfigSiafic({
            ...configSiafic,
            nomeOrgao: e.target.value
          })
        }
      />

      {/* AMBIENTE */}

      <select
        value={configSiafic.ambiente}
        onChange={(e) =>
          setConfigSiafic({
            ...configSiafic,
            ambiente: e.target.value
          })
        }
      >

        <option value="homologacao">
          Ambiente Homologação
        </option>

        <option value="producao">
          Ambiente Produção
        </option>

      </select>

      {/* TIPO */}

      <select
        value={configSiafic.tipoIntegracao}
        onChange={(e) =>
          setConfigSiafic({
            ...configSiafic,
            tipoIntegracao: e.target.value
          })
        }
      >

        <option value="api">
          API REST
        </option>

        <option value="arquivo">
          Arquivo TXT/XML
        </option>

      </select>

    </div>

    {/* ========================================= */}
    {/* DE PARA */}
    {/* ========================================= */}

    <h3>
      Origem dos Dados (DE-PARA SIAFIC)
    </h3>

    <p className="subtitulo-config">

      Informe de qual campo do sistema cada
      informação será enviada para a API do SIAFIC.

    </p>

    <table>

      <thead>

        <tr>

          <th>Campo API</th>
          <th>Obrigatório</th>
          <th>Origem</th>
          <th>Descrição</th>

        </tr>

      </thead>

      <tbody>

        {/* ORGAO */}

        <tr>

          <td>CD_ORGAO</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.cdOrgao}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  cdOrgao: e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="codigoOrgao">
                Código do Órgão
              </option>

            </select>

          </td>

          <td>
            Código do órgão público
          </td>

        </tr>

        {/* RECEITA */}

        <tr>

          <td>NUM_PLANO_CONTAS</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.numPlanoContas}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  numPlanoContas:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="codigoReceita">
                Código da Receita
              </option>

            </select>

          </td>

          <td>
            Código da receita SIAFIC
          </td>

        </tr>

        {/* DESCRICAO */}

        <tr>

          <td>DS_PLANO_CONTAS</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.dsPlanoContas}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  dsPlanoContas:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="descricaoReceita">
                Descrição da Receita
              </option>

            </select>

          </td>

          <td>
            Descrição da receita
          </td>

        </tr>

        {/* FONTE */}

        <tr>

          <td>NUM_FONTE_RECURSO</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.numFonte}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  numFonte:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="fonteRecurso">
                Fonte de Recurso
              </option>

            </select>

          </td>

          <td>
            Fonte de recurso
          </td>

        </tr>

        {/* DATA */}

        <tr>

          <td>DT_CREDITO</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.dtCredito}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  dtCredito:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="dataRecebimento">
                Data Recebimento
              </option>

            </select>

          </td>

          <td>
            Data do crédito
          </td>

        </tr>

        {/* VALOR */}

        <tr>

          <td>VALENTIA</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.valentia}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  valentia:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="valor">
                Valor do Recebimento
              </option>

            </select>

          </td>

          <td>
            Valor financeiro
          </td>

        </tr>

        {/* BANCO */}

        <tr>

          <td>CD_BANCO</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.cdBanco}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  cdBanco:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="codigoBanco">
                Código Banco
              </option>

            </select>

          </td>

          <td>
            Código do banco
          </td>

        </tr>

        {/* AGENCIA */}

        <tr>

          <td>CD_AGENCIA</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.cdAgencia}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  cdAgencia:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="numeroAgencia">
                Número Agência
              </option>

            </select>

          </td>

          <td>
            Código da agência
          </td>

        </tr>

        {/* CONTA */}

        <tr>

          <td>CONTA_RECEBEDORA</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.contaRecebedora}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  contaRecebedora:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="conta_siafic">
                Conta SIAFIC
              </option>

            </select>

          </td>

          <td>
            Conta bancária recebedora
          </td>

        </tr>

        {/* HISTORICO */}

        <tr>

          <td>HISTORICO</td>

          <td>
            <span className="badge-opcional">
              OPCIONAL
            </span>
          </td>

          <td>

            <select
              value={configSiafic.historico}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  historico:
                    e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="historico">
                Histórico
              </option>

            </select>

          </td>

          <td>
            Histórico do lançamento
          </td>

        </tr>

        {/* CD_CHAVE */}

        <tr>

          <td>CD_CHAVE</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.cdChave}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  cdChave: e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="protocoloLote">
                Nº Protocolo de Envio do Lote
              </option>

            </select>

          </td>

          <td>
            Nº protocolo de envio do lote
          </td>

        </tr>

        {/* CD_RECEBIMENTO */}

        <tr>

          <td>CD_RECEBIMENTO</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.cdRecebimento}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  cdRecebimento: e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="documento">
                Documento (tela de envios)
              </option>

            </select>

          </td>

          <td>
            Documento do recebimento
          </td>

        </tr>

        {/* CHAVE_UNICA */}

        <tr>

          <td>CHAVE_UNICA</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.chaveUnica}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  chaveUnica: e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="chaveUnica">
                Chave única (tela de envios)
              </option>

            </select>

          </td>

          <td>
            Chave única do recebimento
          </td>

        </tr>

        {/* DT_GERACAO */}

        <tr>

          <td>DT_GERACAO</td>

          <td>
            <span className="badge-obrigatorio">
              SIM
            </span>
          </td>

          <td>

            <select
              value={configSiafic.dtGeracao}
              onChange={(e) =>
                setConfigSiafic({
                  ...configSiafic,
                  dtGeracao: e.target.value
                })
              }
            >

              <option value="">
                Selecione
              </option>

              <option value="dataRecebimento">
                Data (tela de envios)
              </option>

            </select>

          </td>

          <td>
            Data de geração do recebimento
          </td>

        </tr>

      </tbody>

    </table>

    {/* ========================================= */}
    {/* REGRAS */}
    {/* ========================================= */}

    <h3>Regras da Integração</h3>

    <div className="grid">

      <label>

        <input
          type="checkbox"
          checked={configSiafic.validarAntesEnviar}
          onChange={(e) =>
            setConfigSiafic({
              ...configSiafic,
              validarAntesEnviar:
                e.target.checked
            })
          }
        />

        Validar antes de enviar

      </label>

      <label>

        <input
          type="checkbox"
          checked={configSiafic.enviarAutomatico}
          onChange={(e) =>
            setConfigSiafic({
              ...configSiafic,
              enviarAutomatico:
                e.target.checked
            })
          }
        />

        Envio automático

      </label>

    </div>

    {/* E-MAILS AVISADOS A CADA ENVIO */}

    <h3>Avisos por e-mail</h3>

    <p className="conc-ajuda">
      A cada envio de arrecadação concluído, o sistema dispara um
      e-mail com os dados do lote (recebimento, agente, valor e
      protocolo) para os endereços abaixo, separados por vírgula.
    </p>

    {/* Liga/desliga os disparos sem apagar os e-mails cadastrados */}

    <label>

      <input
        type="checkbox"
        checked={configSiafic.avisosAtivos}
        onChange={(e) =>
          setConfigSiafic({
            ...configSiafic,
            avisosAtivos: e.target.checked
          })
        }
      />

      {configSiafic.avisosAtivos ? (
        <><span className="dot dot--verde"></span>
        Avisos ativos: os e-mails abaixo serão notificados</>
      ) : (
        <><span className="dot dot--vermelho"></span>
        Avisos suspensos: nenhum e-mail será enviado</>
      )}

    </label>

    <textarea
      placeholder="exemplo@saae.gov.br, contabilidade@saae.gov.br"
      value={configSiafic.emailsNotificacao || ""}
      onChange={(e) =>
        setConfigSiafic({
          ...configSiafic,
          emailsNotificacao:
            e.target.value
        })
      }
    />

    {/* OBSERVAÇÃO */}

    <textarea
      placeholder="Observações da integração"
      value={configSiafic.observacaoPadrao}
      onChange={(e) =>
        setConfigSiafic({
          ...configSiafic,
          observacaoPadrao:
            e.target.value
        })
      }
    />

    {/* BOTÕES */}

    <div className="grid">

      <button
        className="btn"
        onClick={async () => {

          try {

            const response = await axios.post(
              "/api/testar-siafic",
              {
                ...configSiafic
              }
            );

            mostrarAlerta(
              response.data.mensagem ||
              "Conexão realizada com sucesso"
            );

          } catch (err) {

            console.log(err);

            const erro = err.response?.data;

            let msg = erro?.erro || "Não foi possível conectar ao SIAFIC.";
            if (erro?.dica) {
              msg += "\n\n" + erro.dica;
            }

            mostrarAlerta(msg);

          }

        }}
      >
        Testar Conexão SIAFIC
      </button>

      <button
        className="btn"
        onClick={testarMetodosSiafic}
        disabled={testandoMetodos}
      >
        {testandoMetodos ? "Testando..." : "Testar Métodos da API"}
      </button>

      <button
        className="btn verde"
        onClick={salvarConfiguracao}
      >
        Salvar Configuração
      </button>

    </div>

    {/* Resultado do diagnóstico: um item por método usado na integração */}
    {diagnosticoSiafic && (

      <div style={{ marginTop: 18 }}>

        <h3>Métodos da API</h3>

        <p className="conc-ajuda">{diagnosticoSiafic.mensagem}</p>

        <table>
          <thead>
            <tr>
              <th>Método</th>
              <th>Recurso</th>
              <th>Registros</th>
              <th>Situação</th>
            </tr>
          </thead>
          <tbody>
            {diagnosticoSiafic.itens.map((i) => (
              <tr key={i.recurso}>
                <td>{i.nome}</td>
                <td className="conc-obs">{i.recurso}</td>
                <td>{i.ok ? i.quantidade : "—"}</td>
                <td>
                  {i.ok ? (
                    <span className="status status--enviado">OK</span>
                  ) : (
                    <>
                      <span className="status status--erro">SEM ACESSO</span>
                      <div className="conc-obs">{i.erro}</div>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

      </div>

    )}

  </div>

)}

        </main>
      </div>

      {/* ========= MODAL PERSONALIZADO ========= */}
      {modal && (
        <div
          className="modal-overlay"
          onClick={() => {
            // clicar fora fecha; alerta/confirmação = cancelar
            if (modal.tipo === "prompt" || modal.tipo === "confirmacao") {
              fecharModal(modal.tipo === "confirmacao" ? false : null);
            } else {
              fecharModal(true);
            }
          }}
        >
          <div
            className={"modal-box modal-" + modal.variante}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-cabecalho">
              <span className="modal-icone">
                {modal.variante === "erro" && <Icone nome="alerta" />}
                {modal.variante === "sucesso" && <Icone nome="sucesso" />}
                {modal.variante === "info" && <Icone nome="info" />}
              </span>
              <h3>{modal.titulo}</h3>
            </div>

            <div className="modal-corpo">
              <p>{modal.mensagem}</p>

              {modal.tipo === "prompt" && (
                <input
                  className="modal-input"
                  autoFocus
                  value={modalInput}
                  onChange={(e) => setModalInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") fecharModal(modalInput);
                    if (e.key === "Escape") fecharModal(null);
                  }}
                />
              )}
            </div>

            <div className="modal-acoes">
              {(modal.tipo === "confirmacao" || modal.tipo === "prompt") && (
                <button
                  className="modal-btn modal-btn-cancelar"
                  onClick={() =>
                    fecharModal(modal.tipo === "confirmacao" ? false : null)
                  }
                >
                  Cancelar
                </button>
              )}

              <button
                className="modal-btn modal-btn-ok"
                onClick={() => {
                  if (modal.tipo === "confirmacao") fecharModal(true);
                  else if (modal.tipo === "prompt") fecharModal(modalInput);
                  else fecharModal(true);
                }}
              >
                {modal.tipo === "alerta" ? "OK" : "Confirmar"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default App;